<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        class="st3"
        d="M302.8,119.2c1.1,0.6,2.2,1.1,3.2,1.8c0.1,0.1,0.2,0.1,0.2,0.2v-2.9V118v-4c-1,0.3-2,0.6-3,0.9
		c-1.1,0.4-1.7,1.2-1.8,2.1C301.3,118,301.8,118.7,302.8,119.2z"
      />
      <path
        class="st3"
        d="M228.5,143.8L228.5,143.8C228.5,143.8,228.6,143.8,228.5,143.8L228.5,143.8L228.5,143.8
		C228.5,143.9,228.5,143.9,228.5,143.8C228.5,143.9,228.5,143.9,228.5,143.8z"
      />
      <path
        class="st3"
        d="M250.1,139.8C250.2,139.8,250.2,139.8,250.1,139.8C250.2,139.8,250.2,139.8,250.1,139.8
		C250.1,139.7,250.1,139.8,250.1,139.8L250.1,139.8z"
      />
      <path
        class="st3"
        d="M107.9,309.2c-0.4-0.1-0.8-0.1-1.1-0.2c0.1,0.3,0.3,0.6,0.6,0.8c0.2,0,0.3,0,0.5,0.1
		C107.9,309.6,107.9,309.4,107.9,309.2z"
      />
      <path
        class="st3"
        d="M103.5,301c0.5,0,0.9,0.1,1.4,0.1c0.1-0.2,0.2-0.5,0.4-0.7c0.3,0.3,0.5,0.6,0.7,0.8c1.2,0.1,2.3,0.2,3.5,0.3
		c0.1,0,0.2,0.1,0.4,0.1c0.3-0.2,0.7-0.4,0.9-0.6c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.8-0.6-1.9-0.8-3.1-0.5c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C103.3,300.3,103.4,300.6,103.5,301z"
      />
      <path
        class="st3"
        d="M112.3,304.9c-0.1,1.8-0.1,3.6-0.2,5.4c0.8-0.4,1.5-1.1,1.7-1.9c0-0.6,0-1.2,0-1.8
		C113.5,305.8,113,305.2,112.3,304.9z"
      />
      <path
        class="st3"
        d="M101.7,304.4c-0.6-0.1-1.2-0.2-1.9-0.3c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.8,0.1,1.6,0.2,2.4,0.3C101.6,304.9,101.6,304.7,101.7,304.4z"
      />
      <path
        class="st3"
        d="M79.8,324.6c0-0.6,0.1-1.3,0.1-1.9C79.3,323.3,79.3,323.6,79.8,324.6z"
      />
      <path
        class="st3"
        d="M85.1,320.1c-0.3,1.9-0.6,3.7-1,5.6c0.1-0.1,0.3-0.3,0.4-0.5c0.3,0,0.6,0,0.9,0.1c0.3-1.7,0.5-3.4,0.8-5
		c-0.3-0.1-0.6-0.1-0.9-0.1C85.2,320.1,85.1,320.1,85.1,320.1z"
      />
      <path
        class="st3"
        d="M82.4,319.1c-0.2-0.2-0.5-0.3-0.8-0.4c0.2,2.5,0,5-0.7,7.4c0.5,0,0.8,0.1,1.1,0.1c0.3-2.1,0.7-4.1,1-6.2
		c-0.2-0.3-0.3-0.5-0.5-0.8C82.4,319.2,82.4,319.2,82.4,319.1z"
      />
      <path
        class="st3"
        d="M79.9,321.7c0-0.7-0.1-1.5-0.2-2.2l-0.1,0.1C79,320.3,79.1,321.1,79.9,321.7z"
      />
      <path
        class="st3"
        d="M95,310.8c-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.1-1.8-0.3-2.7-0.4c-0.2,0.2-0.4,0.3-0.6,0.6c0,0,0,0.1-0.1,0.1
		c1.9,0.2,3.7,0.6,5.5,1c0.2-0.2,0.5-0.5,0.7-0.7c0.4,0.2,0.8,0.4,1.2,0.5c1,0.3,1.9,0.3,2.5-0.2c-2.1-0.3-4.2-0.6-6.3-0.9
		C95.1,310.7,95.1,310.7,95,310.8z"
      />
      <path
        class="st3"
        d="M102,308.3c-0.2-0.1-0.3-0.3-0.5-0.3c-0.4-0.1-0.8-0.1-1.2-0.2c-0.3,0-0.5,0-0.8,0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.3,0.1-0.6,0.3-0.8,0.6c1.4,0.2,2.8,0.4,4.1,0.6c-0.1-0.2-0.2-0.5-0.4-0.7C102.1,308.4,102,308.3,102,308.3z"
      />
      <path
        class="st3"
        d="M148,337.3c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st3"
        d="M241.7,237.3c0.2,0.9,0.6,1.6,1.5,1.9c0.5-0.7,0.9-1.5,1.3-2.2c0.1-0.3,0.3-0.5,0.4-0.8
		c-0.4,0-0.8,0.1-1.3,0.2C242.9,236.7,242.3,237,241.7,237.3z"
      />
      <path
        class="st3"
        d="M190.2,254.4c-2,0.2-3.8,0.4-5.6,0.6c0.2,0.6,0.7,1.2,1.5,1.4c0.2,0.1,0.4,0.1,0.6,0.1c0.3,0,0.6,0,0.9,0
		c0.7-0.1,1.5-0.4,2-0.9C189.9,255.3,190.1,254.8,190.2,254.4z"
      />
      <path
        class="st3"
        d="M194.3,257.8c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.6-0.1-1.1,0-1.6,0.4c1.2,0.3,2.3,1,3.3,2
		c0.5,0.5,1,1.1,1.5,1.7c0.2,0.1,0.5,0.2,0.8,0.3c0.3-0.4,0.7-0.9,1.1-1.4c-0.2-0.2-0.3-0.4-0.5-0.6
		C194.7,258.4,194.4,258.2,194.3,257.8z"
      />
      <path
        class="st3"
        d="M225.2,294.2c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7c-0.1-0.3-0.3-0.5-0.6-0.7c0,0.3,0.1,0.6,0.1,0.9
		c0,0.2-0.1,0.4-0.2,0.6c-0.2,0-0.4,0.1-0.6,0.1c-0.1-0.4-0.3-0.9-0.4-1.3c-0.1,0.1-0.1,0.3-0.1,0.4c-0.1,0.7,0.5,1.3,0.9,1.9
		c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.2,0,0.4,0,0.5,0
		c0-1.4,0-2.8-0.1-4.1C225.3,294.3,225.3,294.2,225.2,294.2z"
      />
      <path
        class="st3"
        d="M91.7,307.5c1.4,0.2,2.9,0.4,4.3,0.6c0.2-0.2,0.5-0.5,0.6-0.8v-0.1C95,307.2,93.4,307.2,91.7,307.5z"
      />
      <path
        class="st3"
        d="M94.2,299.8C94.2,299.8,94.3,299.8,94.2,299.8c0.8-0.8,0.9-2,0.3-2.8l0,0c-0.2-0.2-0.4-0.4-0.6-0.5
		c-0.4,1.2-2,2.4-3.5,2.6c0.4-0.9,0.8-1.7,1.2-2.7c-0.1,0-0.1,0-0.2,0c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		c-0.1,0.6,0,1.2,0.5,1.7c0,0,0.1,0.1,0.2,0.1c1.1,0.1,2.2,0.2,3.4,0.2C93.8,300.1,94,300,94.2,299.8z"
      />
      <path
        class="st3"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st3"
        d="M88.6,314c-0.2,0-0.3,0.1-0.5,0.1c-0.4-0.9-0.8-1.4-1.5-1.6c0.4,1,0.7,1.9,1,2.9c0,0,0.1,0,0.1-0.1
		c0.7,0.5,1.2,0.8,1.6,0.8C89.1,315.5,88.9,314.7,88.6,314z"
      />
      <path
        class="st3"
        d="M85.8,316.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.5-0.5-1-0.9-1.5-1.4c-0.1,0.1-0.3,0.3-0.4,0.4s-0.1,0.1-0.2,0.2
		c0.5,0.4,0.8,0.7,1.2,0.9C85.1,316.3,85.5,316.3,85.8,316.3z"
      />
      <path
        class="st3"
        d="M85.1,314c0.2-0.2,0.3-0.3,0.5-0.5c-0.3-0.3-0.6-0.5-0.9-0.8c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.3,0.6,0.5,0.9,0.7
		c-0.1,0.1-0.2,0.2-0.3,0.3C85,313.9,85,314,85.1,314z"
      />
      <path
        class="st3"
        d="M270.6,244.5c-0.1,0-0.1,0-0.1,0c-0.5,0.1-1,0.4-1.3,0.8c-0.2,0.4-0.4,0.8-0.6,1.2c0,0.1-0.1,0.3-0.1,0.4
		c0,0.1,0,0.1,0,0.2c0.1,0.7,0.7,1.2,1.4,1.5c0.9-1.3,2-2.2,3.6-2.7c0,0,0,0,0.1,0C273.2,244.8,271.9,244.2,270.6,244.5z"
      />
      <path
        class="st3"
        d="M273.1,247.8c-0.8,0.3-1.6,0.6-2.3,1c0.2,0,0.5,0,0.7,0s0.5-0.1,0.7-0.2C272.6,248.4,272.9,248.1,273.1,247.8z
		"
      />
      <path
        class="st3"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st3"
        d="M84.7,294.1c0.1,0,0.1-0.1,0.2-0.1h-0.1C84.7,294,84.7,294,84.7,294.1z"
      />
      <path
        class="st3"
        d="M89.5,296.1c-0.4,0.5-0.8,0.9-1.1,1.4c0.5,0,1.1-0.2,1.6-0.5c0.1-0.2,0.2-0.4,0.3-0.7
		C90,296.3,89.8,296.2,89.5,296.1z"
      />
      <path
        class="st3"
        d="M90,297C89.9,297,89.9,297.1,90,297C90,297.1,90,297.1,90,297L90,297L90,297z"
      />
      <path
        class="st3"
        d="M207.1,268.1c-0.4-0.7-0.8-1.4-1.2-2c-0.2,0.1-0.4,0.2-0.6,0.3c-0.8,0.1-1.3,0.5-1.7,1
		c0.7,1.1,1.4,2.2,2.1,3.3c0.7-0.1,1.9-1.2,1.6-1.6C207,268.7,207,268.4,207.1,268.1z"
      />
      <path
        class="st3"
        d="M207.5,265.9c0.1,0.3,0.2,0.5,0.3,0.7C207.8,266.3,207.7,266.1,207.5,265.9z"
      />
      <path
        class="st3"
        d="M104.2,312c-0.3,0.4-0.4,0.8-0.4,1.2c1.5,0.2,2.9,0.2,4.4,0.1c0.1-0.2,0.1-0.5,0.1-0.8
		C106.9,312.3,105.6,312.2,104.2,312z"
      />
      <path
        class="st3"
        d="M251.5,281.6c0.6-0.5,0.8-1.2,0.6-1.8c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7
		c0.9-0.2,1.6-0.3,2.2-0.5c0.5-0.2,1-0.4,1.5-0.6C251.3,281.8,251.4,281.7,251.5,281.6z"
      />
      <path
        class="st3"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st3"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st3"
        d="M202,260.3c-0.8,0.6-1.4,1.2-1.8,1.9c0.8,1.2,1.5,2.3,2.3,3.5c0-0.2,0-0.3,0-0.5c0-0.4-0.2-0.9,0-1.2
		C203.8,262.5,203.1,261.4,202,260.3z"
      />
      <path
        class="st3"
        d="M15,301.8L15,301.8v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C15.2,303,15.3,302.3,15,301.8z"
      />
      <path
        class="st3"
        d="M165.8,307.3c0.5-0.1,0.8-0.4,1.1-0.6c-0.8,0.2-1.6,0.4-2.4,0.6C164.9,307.3,165.4,307.4,165.8,307.3z"
      />
      <path
        class="st3"
        d="M293.3,253.3v0.1c0.4,0.7,1.2,1.2,2.1,1h0.1c0.4-0.1,0.7-0.3,1-0.5c-0.3-0.1-0.6-0.1-0.9-0.2
		C294.9,253.5,294.1,253.4,293.3,253.3z"
      />
      <path
        class="st3"
        d="M195.4,251c0.1,0,0.1,0,0.2,0.1l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-0.4,0.2-0.8,0.2-1.1C196.1,249.7,195.7,250.4,195.4,251z"
      />
      <path
        class="st3"
        d="M194.3,250.8c-0.7-0.6-1.1-1.3-1.5-2.1C192.5,250.1,192.7,250.6,194.3,250.8z"
      />
      <path
        class="st3"
        d="M283.4,249.2c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5c-0.3-0.1-0.6-0.1-0.9-0.1
		c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2,1-0.5,1.9-0.7,2.9c0,0.2,0.1,0.4,0.2,0.5c0.5-0.3,1-0.4,1.6-0.3c0.6-0.3,1.2-0.7,1.7-1
		C283.8,250.3,283.7,249.6,283.4,249.2z"
      />
      <path
        class="st3"
        d="M261.7,256c0.2-0.2,0.2-0.4,0.3-0.7c-0.5,0.5-0.9,1-1.4,1.5C261,256.7,261.4,256.4,261.7,256z"
      />
      <path
        class="st3"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st3"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st3"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st3"
        d="M172.6,290.5c0,0.1,0,0.1,0,0.2c0.1,0.4,0.4,0.7,0.8,0.9c0.6,0,1.1,0,1.7,0C174.3,291,173.4,290.7,172.6,290.5
		L172.6,290.5z"
      />
      <path
        class="st3"
        d="M278.3,253.8c-0.2,0-0.4,0-0.5,0c-0.9,0.2-1.5,1-1.4,1.8c0,0.1,0.1,0.2,0.1,0.3
		C277.2,255.3,277.7,254.5,278.3,253.8z"
      />
      <path
        class="st3"
        d="M218.8,301.9c0.4,0.7,0.7,1.4,1.1,2.1c0.7-0.3,1.2-0.6,1.7-0.8c-0.3-0.7-0.7-1.4-1-2
		C219.9,301.3,219.4,301.6,218.8,301.9z"
      />
      <path
        class="st3"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.6-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st3"
        d="M286,287.5c-0.4-0.3-0.9-0.5-1.4-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5c0.1,0.8,0.9,1.3,1.8,1.1
		c0.4-0.1,0.9-0.3,1.2-0.6C286,288.7,286,288.1,286,287.5z"
      />
      <path
        class="st3"
        d="M278.3,289.4c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C280,289.6,279.3,289.2,278.3,289.4z"
      />
      <path
        class="st3"
        d="M111.9,314.7c0,0.9-0.1,1.8-0.1,2.7c0.2,0,0.3,0,0.5,0c0.5-0.1,1-0.5,1.2-0.9c0.1-0.3,0.2-0.5,0.1-0.8
		C113.5,315,112.7,314.6,111.9,314.7z"
      />
      <path
        class="st3"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st3"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,337,0.7,336.5,0,336.6z"
      />
      <path
        class="st3"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st3"
        d="M260.7,257.7c-0.2-0.1-0.5-0.2-0.7-0.2c-0.5,0.5-1.1,1.1-1.6,1.6c0.1,0.6,0.7,0.9,1.2,0.8
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7C261.1,258,260.9,257.8,260.7,257.7z"
      />
      <path
        class="st3"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st3"
        d="M278.4,285.7c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C277.6,287.2,278.2,286.7,278.4,285.7z"
      />
      <path
        class="st3"
        d="M285.7,293.8c0.1,0.3,0.3,0.4,0.5,0.6c0-0.6,0-1.2-0.1-1.7C285.8,293,285.6,293.4,285.7,293.8z"
      />
      <path
        class="st3"
        d="M211.1,306.6c0,0.2,0.1,0.4,0.2,0.5c0.3-0.2,0.6-0.3,1-0.5C211.9,306.5,211.5,306.5,211.1,306.6
		C211.1,306.5,211.1,306.5,211.1,306.6z"
      />
      <path
        class="st3"
        d="M16.4,311c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C15.6,311.9,16.1,311.6,16.4,311z"
      />
      <path
        class="st3"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.1,0,0.2c0.8,0,1.6,0,2.5,0.1c0.1-0.2,0.1-0.3,0.1-0.5
		C159.4,309.5,158.6,309.2,158,309.3z"
      />
      <path
        class="st3"
        d="M217,271.1c0.7,0.8,0.9,0.9,1.8,0.6c-0.4-0.9-0.9-1.9-1.3-2.8c0.1,0.8,0,1-0.7,2
		C216.9,271,217,271.1,217,271.1z"
      />
      <path
        class="st3"
        d="M85.6,317.5c-0.1,0-0.3,0.1-0.4,0.2c0.1,0.3,0.2,0.6,0.1,1.1c0,0.2-0.1,0.5-0.1,0.7c0.2,0.1,0.5,0.1,0.8,0.1
		c0.1,0,0.2-0.1,0.4-0.1c0.1-0.6,0.2-1.1,0.3-1.7C86.3,317.6,86,317.5,85.6,317.5z"
      />
      <path
        class="st3"
        d="M305.4,285.7c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.4-0.1,0.7-0.3,0.8-0.5V286
		C306.3,285.8,305.9,285.6,305.4,285.7z"
      />
      <path
        class="st3"
        d="M213.1,271.3c-0.1-0.3-0.3-0.6-0.4-0.9c-0.3,0.1-0.6,0.2-0.9,0.3c0,0.4,0.2,0.7,0.7,0.9
		C212.7,271.5,212.9,271.4,213.1,271.3z"
      />
      <path
        class="st3"
        d="M213.5,270.1c0.2,0.4,0.4,0.8,0.6,1.2c0.1-0.1,0.2-0.4,0.3-0.5c0.1-0.3-0.1-0.6-0.1-0.8
		C214,269.9,213.7,270,213.5,270.1z"
      />
      <path
        class="st3"
        d="M190.5,248.4c0.2,0.4,0.3,0.8,0.4,1.2c0.1-0.3,0.3-0.6,0.4-0.8C191,248.4,190.8,248.3,190.5,248.4z"
      />
      <path
        class="st3"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,0.9,0.8c-0.1-0.6-0.2-1.1-0.2-1.7
		C233.9,285.3,233.8,285.3,233.7,285.4z"
      />
      <path
        class="st3"
        d="M232.8,272c-0.6,0.2-1.5,0.1-1.8,1c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0
		C233.9,273.1,233.4,272.6,232.8,272z"
      />
      <path
        class="st3"
        d="M201.4,259.7C201.4,259.6,201.4,259.6,201.4,259.7c-0.5-0.2-0.8-0.3-1.1-0.4c-0.6-0.1-0.9,0.3-1.1,0.7
		c-0.2,0.4-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2C201.2,260.4,201.2,260,201.4,259.7z"
      />
      <path
        class="st3"
        d="M202.8,243.2c0.2,0,0.4,0.1,0.6,0.1c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3
		c-0.4,0.1-0.7,0.2-1.1,0.2C202.6,242.4,202.7,242.8,202.8,243.2z"
      />
      <path
        class="st3"
        d="M75.6,325.2c-0.1,0.4-0.1,0.9-0.2,1.3c0.6-0.4,1.2-0.7,1.7-1c0-0.1,0-0.1,0-0.2C76.5,325,76,325,75.6,325.2z"
      />
      <path
        class="st3"
        d="M28.1,335.7c-0.1,0.2-0.1,0.4-0.1,0.8C28,336.2,28,335.9,28.1,335.7z"
      />
      <path
        class="st3"
        d="M215.8,294.9c0,0.5,0.5,0.8,1.1,0.7c0.2,0,0.3-0.1,0.5-0.2c-0.3-0.5-0.5-0.9-0.8-1.4
		C216.1,294.2,215.8,294.4,215.8,294.9z"
      />
      <path
        class="st3"
        d="M217,277.8c0,0.1,0,0.1-0.1,0.2c0.2,0.6,0.4,1.1,0.6,1.7c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.6,0-1.2-0.5-1.6
		C217.6,278.1,217.4,277.9,217,277.8z"
      />
      <path
        class="st3"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st3"
        d="M233.2,299c0,0.3,0,0.5-0.1,0.7c0.2-0.2,0.3-0.4,0.2-0.6C233.3,299,233.3,299,233.2,299z"
      />
      <path
        class="st3"
        d="M225.4,272.3c-0.1,0-0.5,0.3-0.5,0.4c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.3,0.1,0.5,0.2,0.8,0.3
		c-0.2-0.4-0.3-0.7-0.5-1.1C225.6,272.4,225.5,272.3,225.4,272.3z"
      />
      <path
        class="st3"
        d="M194.2,255c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3-0.2-0.5-0.4-0.8-0.5c-0.2,0.2-0.4,0.4-0.4,0.5c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C194.5,255.5,194.4,255.2,194.2,255z"
      />
      <path
        class="st3"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st3"
        d="M233.8,279.7c-0.1,0-0.2,0-0.3,0.1c0.1,0,0.2,0.1,0.3,0.1C233.8,279.8,233.8,279.8,233.8,279.7z"
      />
      <path
        class="st3"
        d="M30.2,303.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4
		s0.3,0.2,0.4,0.2C30.2,303.8,30.5,303.5,30.2,303.1z"
      />
      <path
        class="st3"
        d="M74,315.9L74,315.9c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4
		c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.3,0.3-0.5C74.6,316.3,74.3,316.1,74,315.9z"
      />
      <path
        class="st3"
        d="M233.3,279.4c0.1,0,0.2-0.4,0.2-0.5c-0.3-0.4-0.7-0.7-1.3-1.2c-0.1,0.2-0.1,0.3-0.2,0.5
		c-0.1,0.6,0.2,0.9,0.5,1.2C232.6,279.5,233,279.4,233.3,279.4L233.3,279.4z"
      />
      <path
        class="st3"
        d="M205.4,253.5c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		c0.2,0.3,0.3,0.7,0.8,0.7C205,253.5,205.2,253.5,205.4,253.5z"
      />
      <path
        class="st3"
        d="M251.6,275c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C250.9,274.8,251.5,275.1,251.6,275z"
      />
      <path
        class="st3"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st3"
        d="M305.8,230.5c-0.1-0.3-0.4-0.6-0.8-0.4c-0.3,0.1-0.5,0.5-0.6,0.8c0,0,0.1,0.1,0.3,0.2
		C305.1,231,305.5,230.8,305.8,230.5z"
      />
      <path
        class="st3"
        d="M206,250.9c1.1,0.7,1.1,0.7,1.8-0.1C207.1,250.7,206.7,250,206,250.9z"
      />
      <path
        class="st3"
        d="M78.5,326.3c0.2-0.2,0.7-0.5,0.7-0.7c0-0.3-0.4-0.5-0.7-0.9l-0.1,0.1c0,0.4-0.1,0.8-0.2,1.2
		C78.3,326.2,78.4,326.3,78.5,326.3z"
      />
      <path
        class="st3"
        d="M45.7,328c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7c-0.4-0.1-0.7-0.3-0.9-0.3
		C46,327.6,45.9,327.8,45.7,328z"
      />
      <path
        class="st3"
        d="M12,327.3c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.3z"
      />
      <path
        class="st3"
        d="M113.8,302.5L113.8,302.5c0.1-0.3,0.3-0.6,0.6-0.8c0,0-0.1,0-0.1-0.1C114.1,302,113.7,302.3,113.8,302.5z"
      />
      <path
        class="st3"
        d="M256.1,286c0,0.5,0.1,0.7,0.3,0.9c0.2-0.1,0.4-0.1,0.5-0.1C256.8,286.5,256.6,286.2,256.1,286z"
      />
      <path
        class="st3"
        d="M212.2,287c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C212.8,287.4,212.5,287.3,212.2,287z"
      />
      <path
        class="st3"
        d="M233.4,274.1c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C234.7,274,234.3,273.8,233.4,274.1z"
      />
      <path
        class="st3"
        d="M47.3,337.7c0.2-0.4,0.4-0.9,0.6-1.4c-0.4,0.3-0.6,0.4-0.7,0.6C47.2,337.1,47.2,337.4,47.3,337.7z"
      />
      <path
        class="st3"
        d="M271.9,251.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2-0.1,0.3-0.2,0.5-0.3c0-0.1,0.1-0.1,0.1-0.1c-0.4-0.2-0.7-0.3-1-0.4
		C272.1,251.1,271.9,251.4,271.9,251.5z"
      />
      <path
        class="st3"
        d="M216.7,273.5c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.3-0.5-0.5-0.8-0.9c0.1,1,0.1,1.2,0.7,1.3
		C216.3,273.4,216.4,273.5,216.7,273.5z"
      />
      <path
        class="st3"
        d="M241.3,236.2c0-0.2-0.4-0.3-0.7-0.5c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4
		C241,236.6,241.3,236.4,241.3,236.2z"
      />
      <path
        class="st3"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st3"
        d="M74.8,329.8c0.1,0,0.1,0,0.2,0.1c0.2-0.3,0.4-0.6,0.4-0.7S75.2,329,75,329C74.9,329.2,74.9,329.5,74.8,329.8z"
      />
      <path
        class="st3"
        d="M16.8,301c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C16.5,301.3,16.6,301.2,16.8,301z"
      />
      <path
        class="st3"
        d="M29.3,322.4c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.4z"
      />
      <path
        class="st3"
        d="M208.6,255.1c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C208.2,254.3,208.2,254.3,208.6,255.1z"
      />
      <path
        class="st3"
        d="M209.6,276c0.1,0,0.3,0,0.4,0c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1
		C209.8,275.2,209.7,275.6,209.6,276z"
      />
      <path
        class="st3"
        d="M233.6,296.2c0,0.2,0,0.5-0.1,0.7c0.2,0.2,0.3,0.3,0.6,0.5c0-0.2,0-0.3-0.1-0.4
		C233.9,296.6,233.8,296.3,233.6,296.2z"
      />
      <path
        class="st3"
        d="M89.7,320.7c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C90.2,321.1,89.9,321,89.7,320.7z"
      />
      <path
        class="st3"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st3"
        d="M201.3,241.5c-0.1,0.1-0.2,0.2-0.3,0.4c0.2,0,0.3,0,0.4,0C201.3,241.7,201.3,241.6,201.3,241.5z"
      />
      <path
        class="st3"
        d="M193.1,252c0.7,0.2,1.1,0.3,1.8,0.5C194.4,251.8,194,251.6,193.1,252z"
      />
      <path
        class="st3"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.4,213.5,289.7z"
      />
      <path
        class="st3"
        d="M14,312.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C14.2,312.4,14.1,312.3,14,312.2z"
      />
      <path
        class="st3"
        d="M195.3,252.7c0.1,0,0.2-0.1,0.2-0.1c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3
		C195.6,252.1,195.5,252.4,195.3,252.7z"
      />
      <path
        class="st3"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st3"
        d="M216.3,275.7c-0.1,0-0.1,0.1-0.2,0.2c0.1,0.2,0.2,0.4,0.2,0.6h0.1c0.1,0,0.3-0.2,0.7-0.7
		C216.7,275.7,216.5,275.7,216.3,275.7z"
      />
      <path
        class="st3"
        d="M31.5,337.3c0,0.1,0.1,0.2,0.2,0.2c0.2-0.2,0.4-0.3,0.5-0.5c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.8,337,31.6,337.2,31.5,337.3z"
      />
      <path
        class="st3"
        d="M78.6,319.8c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3s-0.1,0.1-0.2,0.2c0,0.2,0.1,0.4,0.1,0.6
		C78.5,319.8,78.6,319.8,78.6,319.8z"
      />
      <path
        class="st3"
        d="M92.2,292C92.1,292,92.1,292,92.2,292c0.1,0.1,0.3,0.2,0.4,0.3l0,0C92.5,292.1,92.3,292.1,92.2,292z"
      />
      <path
        class="st3"
        d="M36,306.2c0.2,0.1,0.3,0.2,0.5,0.2c0.1,0,0.2-0.2,0.4-0.4c-0.3-0.1-0.5-0.2-0.7-0.2
		C36.2,305.9,36.1,306.1,36,306.2z"
      />
      <path
        class="st3"
        d="M82.4,334.8c0,0.2,0.2,0.3,0.4,0.5c0.1-0.1,0.1-0.2,0.2-0.2c-0.1-0.2-0.3-0.4-0.4-0.6
		C82.5,334.6,82.4,334.8,82.4,334.8z"
      />
      <path
        class="st3"
        d="M203.8,250.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.4,0-0.6,0
		c0,0.2-0.1,0.4-0.2,0.8C203.6,250.3,203.7,250.2,203.8,250.1L203.8,250.1L203.8,250.1z"
      />
      <path
        class="st3"
        d="M93.1,317.8c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.1,0.2-0.2,0.3-0.4c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93.1,317.7,93.1,317.8z"
      />
      <path
        class="st3"
        d="M303,281.8c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C303.3,281.6,303.2,281.7,303,281.8z"
      />
      <path
        class="st3"
        d="M10.4,296.3c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C10.1,296.1,10.2,296.2,10.4,296.3z"
      />
      <path
        class="st3"
        d="M299.5,272.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C299.9,272.5,299.6,272.5,299.5,272.4z"
      />
      <path
        class="st3"
        d="M237.1,246c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5c0-0.1,0.1-0.2,0.1-0.3
		c-0.2,0.1-0.3,0.2-0.5,0.3C237.4,245.8,237.3,245.9,237.1,246z"
      />
      <path
        class="st3"
        d="M235.4,246.5c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.2,0.9-0.3
		C235.5,246.8,235.4,246.6,235.4,246.5z"
      />
      <path
        class="st3"
        d="M214.4,280.6c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C214.5,280.1,214.4,280.3,214.4,280.6z"
      />
      <path
        class="st3"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st3"
        d="M83.4,317.4c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.1,0-0.2,0C83.3,317.2,83.4,317.3,83.4,317.4z"
      />
      <path
        class="st3"
        d="M206.5,257.3c-0.1,0-0.3-0.1-0.4-0.1c0.1,0.1,0.1,0.2,0.2,0.3C206.4,257.4,206.5,257.3,206.5,257.3z"
      />
      <path
        class="st3"
        d="M230,270.6c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st3"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st3"
        d="M213.1,278.6c0.1,0.1,0.2,0.3,0.4,0.4c0.1-0.1,0.2-0.2,0.2-0.3C213.5,278.6,213.3,278.6,213.1,278.6z"
      />
      <path
        class="st3"
        d="M204.3,256.7c0-0.1-0.1-0.2-0.1-0.3c0,0.1,0,0.1-0.1,0.2C204.2,256.7,204.3,256.7,204.3,256.7z"
      />
      <path
        class="st3"
        d="M202.1,269.1c0.1,0,0.2,0,0.3,0c0-0.1-0.1-0.1-0.1-0.2C202.3,269,202.2,269.1,202.1,269.1z"
      />
      <path
        class="st3"
        d="M127,296.9c0.2,0.2,0.4,0.5,0.6,0.8C127.9,296.9,127.4,297,127,296.9z"
      />
      <path
        class="st3"
        d="M127,296.9C127,296.9,127,296.8,127,296.9c-0.1-0.1-0.1-0.1-0.1-0.1l0,0C127,296.9,127,296.9,127,296.9z"
      />
      <path
        class="st3"
        d="M30.2,310.7c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C30.3,310.6,30.3,310.7,30.2,310.7z"
      />
      <path
        class="st3"
        d="M212.8,278c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C213,278,212.9,278,212.8,278z"
      />
      <path
        class="st3"
        d="M213,278.5v0.1h0.1C213.1,278.6,213,278.6,213,278.5L213,278.5z"
      />
      <path
        class="st3"
        d="M203.7,241.2c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C203.9,241.3,203.8,241.3,203.7,241.2z"
      />
      <path
        class="st3"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st3"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st3"
        d="M297.4,236.1c0,0.1,0.1,0.3,0.1,0.5c0.1-0.2,0.1-0.3,0.1-0.4C297.6,236.1,297.5,236.1,297.4,236.1L297.4,236.1
		z"
      />
      <path
        class="st3"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st3"
        d="M108.7,277.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C108.9,277.1,108.8,277.2,108.7,277.3z"
      />
      <path
        class="st3"
        d="M67.2,310.8c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.8z"
      />
      <path
        class="st3"
        d="M205.7,256.5c0.1,0.1,0.1,0.2,0.2,0.3l0.1-0.1C205.9,256.6,205.8,256.5,205.7,256.5L205.7,256.5z"
      />
      <path
        class="st3"
        d="M230.1,271.5c0.1,0.1,0.2,0.1,0.4,0.1c0,0,0.1-0.2,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
		C230.3,271.3,230.2,271.4,230.1,271.5z"
      />
      <path
        class="st3"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0
		c0,0,0.1,0,0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st3"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0,0,0,0,0.1,0c0-0.1-0.1-0.2-0.1-0.3C62.6,320.8,62.6,320.9,62.5,321z"
      />
      <path
        class="st3"
        d="M209.6,266.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C209.8,266.8,209.7,266.7,209.6,266.7z"
      />
      <path
        class="st3"
        d="M118.9,284.1l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1
		c-0.1,0-0.1,0-0.2-0.1L118.9,284.1z"
      />
      <path
        class="st3"
        d="M297.9,255.5c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C298.1,255.5,298,255.5,297.9,255.5z"
      />
      <path
        class="st3"
        d="M293.8,282.7c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C293.8,282.4,293.8,282.6,293.8,282.7z"
      />
      <path
        class="st3"
        d="M39.8,311.2c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0v-0.1C39.9,311.2,39.8,311.2,39.8,311.2z"
      />
      <path
        class="st3"
        d="M241.9,240.4c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1C242,240.3,241.9,240.4,241.9,240.4z"
      />
      <path
        class="st3"
        d="M114.2,297c0.1,0,0.1,0.1,0.2,0.1s0.2-0.1,0.3-0.2l-0.1-0.1C114.4,296.8,114.3,296.9,114.2,297z"
      />
      <path
        class="st3"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st3"
        d="M201.1,240.8c-0.1,0-0.1,0-0.2,0l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1C201,241,201.1,240.9,201.1,240.8
		L201.1,240.8z"
      />
      <path
        class="st3"
        d="M144.2,292.6l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st3"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.8,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st3"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st3"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.6,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st3"
        d="M25.2,308.7c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C25.2,308.8,25.2,308.8,25.2,308.7z"
      />
      <path
        class="st3"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st3"
        d="M216.1,283.8c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C216.1,283.7,216.1,283.8,216.1,283.8z"
      />
      <path
        class="st3"
        d="M222.6,282.7C222.6,282.6,222.5,282.6,222.6,282.7c-0.1,0-0.1,0.1-0.1,0.1h0.1
		C222.6,282.8,222.6,282.7,222.6,282.7z"
      />
      <path
        class="st3"
        d="M222.8,283.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1C223,283.4,222.9,283.4,222.8,283.4z"
      />
      <path
        class="st3"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0L50.9,321.9z"
      />
      <path
        class="st3"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st3"
        d="M52.8,296.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C52.7,296.5,52.8,296.5,52.8,296.5z"
      />
      <path
        class="st3"
        d="M274.1,248.3c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C274.2,248.2,274.1,248.2,274.1,248.3z"
      />
      <path
        class="st3"
        d="M274.5,248.6C274.5,248.5,274.4,248.5,274.5,248.6C274.4,248.5,274.4,248.6,274.5,248.6L274.5,248.6
		L274.5,248.6L274.5,248.6L274.5,248.6z"
      />
      <path
        class="st3"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st3"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7l0,0c-0.3,0.5-0.7,1.1-1.1,1.6c-0.6,0.7-1.2,1.4-1.8,2.1l0.1,0.1
		c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5C268,250.5,268.2,250.2,268.3,249.9
		C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st3"
        d="M274.5,248.9c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C274.5,248.7,274.5,248.8,274.5,248.9z"
      />
      <path
        class="st3"
        d="M204.5,265.7c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		C204.6,265.8,204.6,265.7,204.5,265.7z"
      />
      <path
        class="st3"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314
		C97.2,314.1,97.2,314,97.2,314z"
      />
      <path
        class="st3"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st3"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st3"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st3"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st3"
        d="M44.9,296L44.9,296c0.1,0,0.2-0.1,0.2-0.1s-0.1,0-0.1-0.1C44.9,295.9,44.9,296,44.9,296z"
      />
      <path
        class="st3"
        d="M272.2,244c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C272.1,243.9,272.2,243.9,272.2,244z"
      />
      <path
        class="st3"
        d="M272.6,243.3L272.6,243.3L272.6,243.3c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C272.4,243.6,272.5,243.5,272.6,243.3
		C272.6,243.4,272.6,243.3,272.6,243.3z"
      />
      <path
        class="st3"
        d="M272.7,243.1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1C272.8,243.2,272.7,243.2,272.7,243.1z"
      />
      <polygon class="st3" points="290.8,252.8 290.9,252.7 290.8,252.7 	" />
      <polygon class="st3" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st3"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <path
        class="st3"
        d="M194.3,256.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C194.3,256.6,194.3,256.7,194.3,256.7z"
      />
      <path
        class="st3"
        d="M290.4,255.1C290.4,255.2,290.4,255.2,290.4,255.1C290.5,255.2,290.4,255.2,290.4,255.1L290.4,255.1z"
      />
      <path
        class="st3"
        d="M208.3,253.4C208.3,253.5,208.4,253.5,208.3,253.4C208.4,253.5,208.4,253.5,208.3,253.4c0.1,0.1,0.1,0,0.1,0
		C208.4,253.5,208.3,253.5,208.3,253.4z"
      />
      <polygon class="st3" points="296.3,233.9 296.3,234 296.4,234 	" />
      <polygon class="st3" points="42.3,310.1 42.3,310 42.2,310 	" />
      <path
        class="st3"
        d="M141.4,263.2l0.1,0.1l0.1-0.1l-0.1-0.1C141.5,263,141.5,263.1,141.4,263.2z"
      />
      <path
        class="st3"
        d="M240.1,239.9l-0.1-0.1l-0.1,0.1l0.1,0.1L240.1,239.9z"
      />
      <polygon class="st3" points="203.5,244.7 203.6,244.7 203.6,244.6 	" />
      <path
        class="st3"
        d="M114.7,297.8l0.1,0.1l0.1-0.1l-0.1-0.1C114.7,297.7,114.7,297.7,114.7,297.8z"
      />
      <polygon class="st3" points="85.2,306.1 85.3,306 85.2,306 	" />
      <path
        class="st3"
        d="M235.7,275.1l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C235.6,275.1,235.7,275.1,235.7,275.1z"
      />
      <polygon class="st3" points="69.9,314.8 70,314.7 69.9,314.7 	" />
      <polygon class="st3" points="237.7,279 237.8,279 237.8,278.9 	" />
      <path
        class="st3"
        d="M44.1,334.7L44.1,334.7c0.1,0.1,0.1,0.1,0.1,0.1L44.1,334.7C44.2,334.6,44.2,334.6,44.1,334.7
		C44.1,334.6,44.1,334.6,44.1,334.7z"
      />
      <path
        class="st3"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st3"
        d="M296.9,289.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0.1-0.1,0.1C296.9,288.9,296.9,289,296.9,289.1z"
      />
      <path
        class="st3"
        d="M229.3,313.8l0.1-0.1l-0.1-0.1l-0.1,0.1C229.1,313.8,229.2,313.8,229.3,313.8z"
      />
      <path
        class="st3"
        d="M228.1,268c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,268z"
      />
      <path
        class="st3"
        d="M57.7,144.1c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C56.5,142.9,57.1,143.5,57.7,144.1z"
      />
      <path
        class="st3"
        d="M120.4,135.3c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0
		c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1C119.7,134,119.8,134.6,120.4,135.3z"
      />
      <path
        class="st3"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,2
		C4.1,179,4.1,179.7,4.6,180.4C4.6,180.3,4.6,180.4,4.6,180.4z"
      />
      <path
        class="st3"
        d="M82.9,122c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C83.8,118.3,82.5,120.3,82.9,122z"
      />
      <path
        class="st3"
        d="M193.3,109.8c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.6-0.3-2.1s-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C192.9,109.1,193,109.5,193.3,109.8z"
      />
      <path
        class="st3"
        d="M180.8,110c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C180.7,109,180.5,109.5,180.8,110z
M191.3,123.6c-0.5-0.4-0.6-0.9-0.8-1.4C191,122.6,191.1,122.7,191.3,123.6z"
      />
      <path
        class="st3"
        d="M95.8,125.2c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C96.5,125.1,96.1,125.2,95.8,125.2z"
      />
      <path
        class="st3"
        d="M65.8,148.9c2-0.4,3.5-2.1,3.2-3.8c-0.3-1.8-2.3-2.8-4.4-2.4c-2.1,0.5-3.4,2.1-3,3.8
		C61.8,148.2,63.7,149.3,65.8,148.9z"
      />
      <path
        class="st3"
        d="M231.3,136.2c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5
		c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0
		c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3C231.1,136.6,231.2,136.4,231.3,136.2z"
      />
      <path
        class="st3"
        d="M96.7,123.7c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C95.9,121.6,95.9,122.8,96.7,123.7z"
      />
      <path
        class="st3"
        d="M296.4,112.2c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4c0.1-0.9-1.6-2.6-2-2.8
		c-1.1-0.3-2.2-0.1-3.1,0.5C297.1,111,296.7,111.5,296.4,112.2z"
      />
      <path
        class="st3"
        d="M97.9,135.1c1-0.2,1.9-0.8,2.4-1.6c0.3-0.5,0.5-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5
		c-1.8,0.4-3,1.9-2.6,3.4C94.5,134.5,96.3,135.4,97.9,135.1z"
      />
      <path
        class="st3"
        d="M107.8,126.9c-0.3-1.5-2-2.4-3.8-2c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2
		C107,129.8,108.1,128.4,107.8,126.9z"
      />
      <path
        class="st3"
        d="M220.4,116.2c1.7-0.4,2.8-1.9,2.5-3.3s-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C216.8,115.7,218.6,116.6,220.4,116.2z"
      />
      <path
        class="st3"
        d="M93.1,138.1c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6
		c-0.9,0.6-1.4,1.6-1.1,2.6c0.2,0.8,0.8,1.4,1.6,1.7c0.6,0.3,1.4,0.4,2.1,0.2C91.9,139.5,92.7,138.9,93.1,138.1z"
      />
      <path
        class="st3"
        d="M40.3,162.7c0.5,0.2,1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9c-0.9,0.4-1.5,1.4-1.2,2.3
		c0.3,1,1.2,1.4,3.2,1.2C39.3,162.2,39.9,162.5,40.3,162.7z"
      />
      <path
        class="st3"
        d="M109.9,130.8c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6
		c-0.9,0.4-2.1,0.5-2,1.5c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2
		c1.1-0.4,1.7-1.2,1.7-2.2c0-0.6-0.3-1.2-0.7-1.5C111.3,131,110.6,130.8,109.9,130.8z"
      />
      <path
        class="st3"
        d="M293.2,110.7c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-1,0-3.2-0.2-3.3c-0.4-0.1-0.8-0.3-1.1-0.3
		c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5C291.6,109,292.1,110.1,293.2,110.7z"
      />
      <path
        class="st3"
        d="M225.5,111c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2s-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C223.7,109.4,224.3,110.5,225.5,111z"
      />
      <path
        class="st3"
        d="M25.4,135.7c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C26.3,133.2,25.2,134.5,25.4,135.7z"
      />
      <path
        class="st3"
        d="M98.1,143.4c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.1h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4s-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C96.7,145,97.7,144.4,98.1,143.4z"
      />
      <path
        class="st3"
        d="M105.2,138.6c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5c0.3-0.1,0.6-0.2,0.8-0.3
		C104.6,139.5,105,139.1,105.2,138.6z"
      />
      <path
        class="st3"
        d="M35,143.7c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C31.8,143.6,33.5,144.3,35,143.7z"
      />
      <path
        class="st3"
        d="M59.2,133.9c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C56.4,133.4,57.7,134.2,59.2,133.9z"
      />
      <path
        class="st3"
        d="M246.1,74.9c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C245.9,73.3,246,74.2,246.1,74.9z"
      />
      <path
        class="st3"
        d="M301.4,120.9c-0.2-1.2-1.5-2-3-1.7c-1,0.2-1.7,0.8-2.1,1.5c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2
		c0.2,1.2,1.6,1.9,3.1,1.6C300.6,123.2,301.6,122.1,301.4,120.9z"
      />
      <path
        class="st3"
        d="M210.9,104.4c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C210.5,105.7,210.9,105.1,210.9,104.4z"
      />
      <path
        class="st3"
        d="M102.2,146.9c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3
		c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2
		s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5C103.2,148,102.9,147.4,102.2,146.9z"
      />
      <path
        class="st3"
        d="M19.5,164.1c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1
		c-0.2-0.4-0.4-0.7-0.6-1.1c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3
		c-0.9,0.9-1,1.8-0.5,2.7C17.2,164.7,18.3,164.9,19.5,164.1z"
      />
      <path
        class="st3"
        d="M66,179.3c0.2,0.4,0.7,0.8,1.5,1.2c1-0.4,1.5-1,1.6-1.9c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.9-1-1.6-1.3
		c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1
		c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1C66,178,65.7,178.7,66,179.3z"
      />
      <path
        class="st3"
        d="M72.2,167.6L72.2,167.6c-0.3,0-0.5-0.1-0.7-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2
		c0.4,0.1,0.7,0.2,1,0.3l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0
		c-0.7-0.1-1.3-0.3-2-0.4c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1C72.6,167.7,72.4,167.7,72.2,167.6z"
      />
      <path
        class="st3"
        d="M231.5,104.4c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C232.3,102.2,231.3,103.3,231.5,104.4z"
      />
      <path
        class="st3"
        d="M251.5,99.4c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.3-0.3-0.5
		C251.2,100.3,251.4,99.9,251.5,99.4z"
      />
      <path
        class="st3"
        d="M110.1,143c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.1-0.2,0.2-0.2C110.1,143.8,110.2,143.4,110.1,143z"
      />
      <path
        class="st3"
        d="M238.3,111.5c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C237,110.7,237.6,111.3,238.3,111.5z"
      />
      <path
        class="st3"
        d="M266.5,89c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6c0.8-0.3,1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C268,88.9,267.3,88.7,266.5,89z"
      />
      <path
        class="st3"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st3"
        d="M65.1,128.2c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C62.6,127.9,63.8,128.5,65.1,128.2z"
      />
      <path
        class="st3"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st3"
        d="M282.8,128.3c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1c0.2-0.7,0.7-1.4-0.1-2.1c-0.8-0.6-1.6-0.1-2.5,0.1
		c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1C281.3,127,282,127.7,282.8,128.3z"
      />
      <path
        class="st3"
        d="M68.5,131.5c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C68.4,131.2,68.4,131.3,68.5,131.5z"
      />
      <path
        class="st3"
        d="M95.8,153.5c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-1,0.2-1.8,0.9-1.9,1.7c0,0.2,0,0.3,0,0.5
		c0.2,1.1,1.3,1.7,2.6,1.5c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C95.5,154.2,95.7,153.9,95.8,153.5z"
      />
      <path
        class="st3"
        d="M252.4,98.6c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C251.5,97,251.4,98,252.4,98.6z"
      />
      <path
        class="st3"
        d="M286.2,121.7c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C285.9,121.4,286.1,121.5,286.2,121.7z"
      />
      <path
        class="st3"
        d="M28.2,146.6c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C27.6,148.6,28.4,147.6,28.2,146.6z"
      />
      <path
        class="st3"
        d="M81.2,128.1c-0.4-1.6-0.1-3.4-0.8-5c-2.1,0.8-3,1.8-2.6,3.2C78.1,127.7,79.2,128.3,81.2,128.1z"
      />
      <path
        class="st3"
        d="M34.1,152.9c-0.3-1-1.3-1.5-2.6-1.2c-1.2,0.3-2,1.3-1.8,2.3c0.2,0.9,1.5,1.6,2.6,1.3
		C33.5,155,34.3,153.9,34.1,152.9z"
      />
      <path
        class="st3"
        d="M43.8,158.9c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C43.3,156.1,43.1,157.5,43.8,158.9z"
      />
      <path
        class="st3"
        d="M87.2,131.2c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2
		C86.6,133.1,87.4,132.1,87.2,131.2z"
      />
      <path
        class="st3"
        d="M265,111.8c0,0,0-0.1-0.1-0.1c-0.1-0.3-0.2-0.5-0.3-0.8c-0.7,0.4-1.4,0.8-2,1.2c0.2-0.5,0.5-0.8,0.8-1.1
		c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6c0.6,1.2,0.3,2-0.5,2.7
		c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7C263,113,263.1,111.7,265,111.8
		C264.9,111.8,264.9,111.8,265,111.8z"
      />
      <path
        class="st3"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,134,2.2,133z"
      />
      <path
        class="st3"
        d="M269.7,121c0.3,0.3,0.6,0.6,0.9,0.9c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2
		c-0.4,0.1-0.8,0.3-1.1,0.5c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5C270.5,119.6,270,120.2,269.7,121L269.7,121z"
      />
      <path
        class="st3"
        d="M88.7,149.9C88.8,149.9,88.8,149.9,88.7,149.9c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C88.4,149.7,88.5,149.8,88.7,149.9z"
      />
      <path
        class="st3"
        d="M70.6,138.9c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C71.9,139.1,71.2,138.8,70.6,138.9z"
      />
      <path
        class="st3"
        d="M62.2,170.3c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		c0.1,0.5,0.4,0.9,0.8,1.3c0.5,0.4,1.2,0.5,2,0.2c0.1-0.9-1.7-1.1-0.5-2.2C60.6,170.5,61.3,171.1,62.2,170.3z"
      />
      <path
        class="st3"
        d="M143.3,128.4c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.3,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C143.1,128,143.2,128.3,143.3,128.4z"
      />
      <path
        class="st3"
        d="M237.8,118.5c-0.2,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C239.1,119,238.5,118.6,237.8,118.5z"
      />
      <path
        class="st3"
        d="M191.7,99.2c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C189.4,99,190.4,99.5,191.7,99.2z"
      />
      <path
        class="st3"
        d="M251.6,105.6c-0.2-0.8-1.2-1.3-2.2-1.1c-1,0.2-1.7,1.1-1.5,1.9s1.2,1.2,2.1,1
		C251.2,107.1,251.8,106.4,251.6,105.6z"
      />
      <path
        class="st3"
        d="M136.6,100.2c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C135.2,99.3,135.6,99.8,136.6,100.2z"
      />
      <path
        class="st3"
        d="M274.3,121.9c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-1.2-0.7
		C274.2,121.5,274.2,121.5,274.3,121.9z"
      />
      <path
        class="st3"
        d="M118.5,144.9c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9c-0.2-0.8-1.1-1.2-2.1-1.1
		c-0.9,0.2-1.6,0.9-1.6,1.7C118.4,144.7,118.5,144.8,118.5,144.9z"
      />
      <path
        class="st3"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st3"
        d="M300.5,87.6c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C300.3,87.4,300.4,87.5,300.5,87.6z"
      />
      <path
        class="st3"
        d="M26.3,163.5c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C26,165.1,26.6,164.3,26.3,163.5z"
      />
      <path
        class="st3"
        d="M280.7,132.7c-0.2-0.2-1,0.5-0.7,0.7c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5
		C282.9,132.7,281.6,133.3,280.7,132.7z"
      />
      <path
        class="st3"
        d="M113.2,150.7C113.3,150.7,113.3,150.7,113.2,150.7c1.1-0.2,1.7-1,1.5-1.8c-0.1-0.3-0.2-0.5-0.4-0.7
		c-0.4-0.4-1-0.6-1.6-0.5c-0.9,0.2-1.6,1-1.5,1.8C111.5,150.3,112.3,150.8,113.2,150.7z"
      />
      <path
        class="st3"
        d="M235,101.3c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C233.1,101,234.4,101.5,235,101.3z"
      />
      <path
        class="st3"
        d="M42.6,135.9c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C41.5,134.4,41.8,135.2,42.6,135.9z"
      />
      <path
        class="st3"
        d="M193.8,113.9c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8
		c0.6-0.3,1.1-0.7,1.6-0.9C193.8,115.8,193.8,115,193.8,113.9z"
      />
      <path
        class="st3"
        d="M24.1,160.3h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C22.2,160.1,23.2,160.5,24.1,160.3z"
      />
      <path
        class="st3"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st3"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st3"
        d="M94.5,117.7c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C92.7,117.5,93.6,117.9,94.5,117.7z"
      />
      <path
        class="st3"
        d="M71.5,176.3c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6l0.3,0.1c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0
		C70.5,176.3,71,176.3,71.5,176.3z"
      />
      <path
        class="st3"
        d="M105.4,118.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C105.9,117.1,105.3,117.8,105.4,118.6z"
      />
      <path
        class="st3"
        d="M104.2,115C104.2,115,104.3,115,104.2,115c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3
		c-0.2-0.6-0.9-0.9-1.7-0.8c-0.9,0.1-1.6,1-1.5,1.7C102.5,114.7,103.3,115.2,104.2,115z"
      />
      <path
        class="st3"
        d="M245.4,124.6c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C244.2,123.9,244.9,123.9,245.4,124.6z"
      />
      <path
        class="st3"
        d="M31.4,164.6c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C31.4,166.1,31.8,165.4,31.4,164.6z"
      />
      <path
        class="st3"
        d="M134,98.3c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C133.7,100.3,134.2,99.3,134,98.3z"
      />
      <path
        class="st3"
        d="M271.4,93.8c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C270.9,93.5,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st3"
        d="M40.5,150c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C38.3,150.1,39,150.3,40.5,150z"
      />
      <path
        class="st3"
        d="M154.3,139.3c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		s0.7,0.1,1,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1s0.4-0.6,0.6-1C154,139.7,154.2,139.5,154.3,139.3z"
      />
      <path
        class="st3"
        d="M72.6,149.8c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C72.3,151.1,72.8,150.5,72.6,149.8z"
      />
      <path
        class="st3"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st3"
        d="M255.8,115c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C254.9,114.3,255.4,114.5,255.8,115z"
      />
      <path
        class="st3"
        d="M132.4,143.9c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.7,1,1.1,1.8,0.9c0.7-0.2,1.3-0.8,1.2-1.4
		C134,144.2,133.2,143.8,132.4,143.9z"
      />
      <path
        class="st3"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st3"
        d="M42.6,148c0.1-1.6-0.4-2.1-2.6-2.4C39.8,147.5,40.5,148.1,42.6,148z"
      />
      <path
        class="st3"
        d="M36.7,165c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C37.6,165,37.2,164.9,36.7,165z"
      />
      <path
        class="st3"
        d="M256.2,93.5c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C255.3,93.1,255.8,93.3,256.2,93.5z"
      />
      <path
        class="st3"
        d="M139.1,136.2c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C138.3,135.5,138.6,136.1,139.1,136.2z"
      />
      <path
        class="st3"
        d="M124.8,150.9c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.6
		C124.1,150.4,124.5,150.7,124.8,150.9z"
      />
      <path
        class="st3"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st3"
        d="M19.2,170.6c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C18.9,170.6,19,170.6,19.2,170.6z"
      />
      <path
        class="st3"
        d="M65.9,164.8c0.6,0.4,1.3,0.5,2,0.3c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6
		C64.8,163.9,65.3,164.4,65.9,164.8z"
      />
      <path
        class="st3"
        d="M262,81.4c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C262.7,80.7,262.3,81,262,81.4z"
      />
      <path
        class="st3"
        d="M111,139.3c0.3-0.3,0.4-0.6,0.3-1c0-0.1-0.1-0.1-0.1-0.1c-0.2-0.5-0.9-0.8-1.6-0.6s-1.1,0.7-1,1.3
		c0.1,0.7,0.8,1,1.6,0.8C110.6,139.7,110.8,139.5,111,139.3z"
      />
      <path
        class="st3"
        d="M86.8,150.6c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0.1,0.6,0.9,1,1.6,0.8
		C86.4,151.8,87,151.3,86.8,150.6z"
      />
      <path
        class="st3"
        d="M244.2,112.3c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3C243.5,112,243.8,112.2,244.2,112.3z"
      />
      <path
        class="st3"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st3"
        d="M203.1,107.2c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C203.5,106,203,106.7,203.1,107.2z"
      />
      <path
        class="st3"
        d="M207.2,111.1c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0
		c-0.4-0.3-0.8-0.4-1.3-0.2h-0.1c-0.5,0.2-0.8,0.5-0.8,1C206.3,110.6,206.5,110.9,207.2,111.1z"
      />
      <path
        class="st3"
        d="M110.1,111.7c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4S109.4,112,110.1,111.7
		z"
      />
      <path
        class="st3"
        d="M262.8,79.8c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C261.3,79.7,262.1,79.9,262.8,79.8z"
      />
      <path
        class="st3"
        d="M16.1,175.4c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C14.7,175.1,15.4,175.5,16.1,175.4z"
      />
      <path
        class="st3"
        d="M110.5,122.5c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C110.9,121.9,110.6,122.2,110.5,122.5z"
      />
      <path
        class="st3"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st3"
        d="M139.6,124.2c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C140.6,125.5,140.4,124.7,139.6,124.2z"
      />
      <path
        class="st3"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9c0.6,0,1.2-0.1,1.7-0.1C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st3"
        d="M146.1,135.3C146.1,135.4,146.1,135.4,146.1,135.3C146.1,135.4,146.2,135.4,146.1,135.3
		C146.2,135.4,146.2,135.4,146.1,135.3L146.1,135.3z"
      />
      <path
        class="st3"
        d="M100.6,97.9c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C99.2,97.6,99.9,98,100.6,97.9z"
      />
      <path
        class="st3"
        d="M245,133.3c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C244.1,133.1,244.6,133.4,245,133.3z"
      />
      <path
        class="st3"
        d="M77.8,122c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C76.6,121.8,77.2,122.1,77.8,122z"
      />
      <path
        class="st3"
        d="M208.6,108c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C207.7,107.9,208.3,108.1,208.6,108z"
      />
      <path
        class="st3"
        d="M146.2,135.4c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6c0.2,0.4,0.7,0.5,1.2,0.2
		c0.4-0.2,0.4-0.9-0.1-1.2s-1.1-0.6-1.7-0.9C146.9,134.9,146.6,135.2,146.2,135.4z"
      />
      <path
        class="st3"
        d="M84.5,177.6c0.3-0.3,0.7-0.7,0.9-1.1c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.9,0.7-0.9,1.2C83,177.4,83.7,177.5,84.5,177.6z"
      />
      <path
        class="st3"
        d="M24.1,127.1c-0.2,1.2-0.3,2.4-0.4,3.5C25.6,129.2,25.7,128.2,24.1,127.1z"
      />
      <path
        class="st3"
        d="M238.4,132.9c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C240.1,132.2,240,132.1,238.4,132.9z"
      />
      <path
        class="st3"
        d="M137.3,151.6c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0
		c-0.3,0.1-0.5,0.2-0.7,0.5l0,0C136.5,150.9,136.8,151.4,137.3,151.6z"
      />
      <path
        class="st3"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st3"
        d="M48.6,153.8c-0.4-1.3-0.4-1.4-2.2-1.8C46.3,153.7,47,154.2,48.6,153.8z"
      />
      <path
        class="st3"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st3"
        d="M136.1,103.3c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S135.4,103.2,136.1,103.3z"
      />
      <path
        class="st3"
        d="M128.9,101.4c0.1,0.5,0.7,0.9,1.2,0.8s0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C129.2,100.2,128.8,100.9,128.9,101.4z"
      />
      <path
        class="st3"
        d="M82.4,171.6c-1.6,1.4-1.6,1.4-0.7,2.4C83.6,172.6,83.6,172.6,82.4,171.6z"
      />
      <path
        class="st3"
        d="M180.3,105.2c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C181,106,181,105.6,180.3,105.2z"
      />
      <path
        class="st3"
        d="M211.4,107.4c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C212.8,107.5,212.2,107.2,211.4,107.4z"
      />
      <path
        class="st3"
        d="M91.8,164.6c0.5-0.1,0.9-0.5,1-0.9c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3
		c-0.4,0.1-0.7,0.3-0.9,0.5c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6C91.1,164.6,91.5,164.7,91.8,164.6z"
      />
      <path
        class="st3"
        d="M289.2,111.9c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6s0.9-0.6,0.9-1.1
		C290.3,112.2,289.8,111.8,289.2,111.9z"
      />
      <path
        class="st3"
        d="M259.2,84.1c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C257.9,84.2,258.5,84.3,259.2,84.1z"
      />
      <path
        class="st3"
        d="M94.4,157c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C94.1,157.2,94.3,157.1,94.4,157z"
      />
      <path
        class="st3"
        d="M264.1,88.3c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C263.8,89.3,264.2,88.8,264.1,88.3z"
      />
      <path
        class="st3"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.3,39.4,128.7z"
      />
      <path
        class="st3"
        d="M187.6,110.2c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C186.5,110,187.1,110.3,187.6,110.2z"
      />
      <path
        class="st3"
        d="M179.2,113.4c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C178.4,114,178.8,113.9,179.2,113.4z"
      />
      <path
        class="st3"
        d="M201.3,103.1c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C201.7,102,201.2,102.6,201.3,103.1z"
      />
      <path
        class="st3"
        d="M186.8,122c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C186.4,122.5,186.7,122.2,186.8,122z"
      />
      <path
        class="st3"
        d="M87.3,144.3c-0.1-0.4-0.7-0.7-1.2-0.6c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6
		C86.9,145.4,87.4,144.7,87.3,144.3z"
      />
      <path
        class="st3"
        d="M261.6,117.3c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C262.1,117.9,261.9,117.6,261.6,117.3z"
      />
      <path
        class="st3"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158.1,50.5,158.2z"
      />
      <path
        class="st3"
        d="M278.8,121c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C278.5,120.9,278.6,121,278.8,121z"
      />
      <path
        class="st3"
        d="M170.1,101.7c-0.2-0.9-0.8-1.4-2.1-1.1C168.5,102.1,168.7,102.2,170.1,101.7z"
      />
      <path
        class="st3"
        d="M176.2,130.1c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C178,129.5,177.4,129.6,176.2,130.1z"
      />
      <path
        class="st3"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st3"
        d="M148.7,133.6c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C149.7,133.4,149.2,133.4,148.7,133.6z"
      />
      <path
        class="st3"
        d="M114.9,110.9c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C113.2,111.3,113.7,111.3,114.9,110.9z"
      />
      <path
        class="st3"
        d="M285.4,132.9c-0.2,0.6-0.4,1.2-0.7,2.2c1.2-0.3,1.8-0.5,1.9-1.2C286.6,133.3,286.3,132.9,285.4,132.9z"
      />
      <path
        class="st3"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st3"
        d="M264.6,118.4c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C264.2,118.2,264.4,118.3,264.6,118.4z"
      />
      <path
        class="st3"
        d="M247.1,106.8c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C246.4,107,247,106.9,247.1,106.8z"
      />
      <path
        class="st3"
        d="M129.4,129.8c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C128.4,129.5,128.9,130,129.4,129.8z"
      />
      <path
        class="st3"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st3"
        d="M128.7,88.9c0.5-1.1,0.5-1.1-0.8-1.8C127.5,88.5,127.5,88.5,128.7,88.9z"
      />
      <path
        class="st3"
        d="M2.5,122.3c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1
		C1.5,122.3,1.9,122.5,2.5,122.3z"
      />
      <path
        class="st3"
        d="M186.7,115c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C186.2,114.2,186,114.7,186.7,115z"
      />
      <path
        class="st3"
        d="M251.4,115.7c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C252.1,116.5,251.8,116.1,251.4,115.7z"
      />
      <path
        class="st3"
        d="M275.8,125.7c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C276.4,125.1,276,125.1,275.8,125.7z"
      />
      <path
        class="st3"
        d="M138.4,97.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9
		C137.7,97.2,138.1,97.3,138.4,97.5z"
      />
      <path
        class="st3"
        d="M275.1,139.7c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C276.3,139.8,275.8,139.7,275.1,139.7z"
      />
      <path
        class="st3"
        d="M56.2,155.3c-0.5-0.6-1-1-1.9-1C54.2,155.8,54.6,155.9,56.2,155.3z"
      />
      <path
        class="st3"
        d="M119.3,106.8c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C117.8,106.4,118.3,106.6,119.3,106.8z"
      />
      <path
        class="st3"
        d="M179.6,109.7c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C178.4,109.6,179,109.5,179.6,109.7z"
      />
      <path
        class="st3"
        d="M177.6,118.2c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C177.2,118.6,177.4,118.4,177.6,118.2z"
      />
      <path
        class="st3"
        d="M128.1,117.6L128.1,117.6c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6
		c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C128.1,118,128.2,117.7,128.1,117.6z"
      />
      <path
        class="st3"
        d="M259.6,98.3c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C260,97.7,259.5,98.1,259.6,98.3z
		"
      />
      <path
        class="st3"
        d="M129.5,104.6c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0s-0.2,0.6-0.1,0.8
		C128.6,104.1,129.1,104.3,129.5,104.6z"
      />
      <path
        class="st3"
        d="M281.5,129.1c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C282.2,128.5,281.7,128.5,281.5,129.1z"
      />
      <path
        class="st3"
        d="M255.2,116.8c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C252.9,116.8,253.3,117.1,255.2,116.8z"
      />
      <path
        class="st3"
        d="M13.2,165.7c1-1,0.8-1.3-0.7-1.4C12.5,164.9,12.6,165.4,13.2,165.7z"
      />
      <path
        class="st3"
        d="M121.7,100.5c0.3-1.1,0.3-1.1-1.3-1.4C120.4,99.8,120.6,100.3,121.7,100.5z"
      />
      <path
        class="st3"
        d="M266.7,119.5l0.1,0.1c0.1,0.1,0.6,0.2,0.8,0.1c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C265.9,118.8,266.3,119.2,266.7,119.5z"
      />
      <path
        class="st3"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st3"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st3"
        d="M24.5,155c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8C23.7,154.7,24.1,154.8,24.5,155z"
      />
      <path
        class="st3"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.3,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st3"
        d="M247.3,95.9c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C246.4,96,246.9,96.1,247.3,95.9z"
      />
      <path
        class="st3"
        d="M101.9,151.5c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C102.2,151.9,102.1,151.6,101.9,151.5z"
      />
      <path
        class="st3"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st3"
        d="M5.1,201.1c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C4.6,201.6,4.8,201.4,5.1,201.1z"
      />
      <path
        class="st3"
        d="M218.3,108.1c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C218.2,108,218.3,108,218.3,108.1z"
      />
      <path
        class="st3"
        d="M154.4,99.9c0.4-0.5,0.8-0.9,0.2-1.4C153.7,99.3,153.7,99.3,154.4,99.9z"
      />
      <path
        class="st3"
        d="M165.6,117.3c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C165.4,117.2,165.5,117.3,165.6,117.3z"
      />
      <path
        class="st3"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st3"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st3"
        d="M258.4,116.9c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C258,116.1,258.2,116.5,258.4,116.9z"
      />
      <path
        class="st3"
        d="M201.8,116.5c0.2,0.5,0.3,0.8,0.5,0.9s0.5,0.1,1.2,0.1l0,0C202.9,117,202.8,116.3,201.8,116.5z"
      />
      <path
        class="st3"
        d="M245.5,108.1c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.4-0.2,0.6,0.1,0.8c0.2,0.1,0.4,0.3,0.8,0.5
		c0-0.3,0-0.5,0-0.7C246.1,108.6,245.9,108.3,245.5,108.1z"
      />
      <path
        class="st3"
        d="M175.7,112.3c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C176,112.7,175.8,112.6,175.7,112.3z"
      />
      <path
        class="st3"
        d="M202.3,83c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C201.7,83.6,202,83.4,202.3,83z"
      />
      <path
        class="st3"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st3"
        d="M123.3,110.9c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st3"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st3"
        d="M123.6,141.8c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C123.8,141.2,123.5,141.7,123.6,141.8z"
      />
      <path
        class="st3"
        d="M249.1,112.6c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C248,112.6,248.3,113.1,249.1,112.6z"
      />
      <path
        class="st3"
        d="M32.9,169c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C32.8,169.2,32.9,169.1,32.9,169z"
      />
      <path
        class="st3"
        d="M65.6,157.8c0,0.3,0,0.5,0,0.6c0.2,0.3,0.6,0.4,1.2,0.4c0-0.6-0.3-0.8-0.8-1C66,157.8,65.8,157.8,65.6,157.8z"
      />
      <path
        class="st3"
        d="M122.4,94.4c0.4-0.9-0.2-1.1-1-1.3C121.4,93.8,121.4,94.4,122.4,94.4z"
      />
      <path
        class="st3"
        d="M135.2,147.1c0.5,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.4-0.5-0.8-0.9-1.4
		C135.5,146.4,135.3,146.7,135.2,147.1z"
      />
      <path
        class="st3"
        d="M183.4,122.4c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C183.6,122,183.3,122.3,183.4,122.4z"
      />
      <path
        class="st3"
        d="M273.6,133.1c0.4-1.2,0.4-1.2-0.9-1.7C273,132,273.3,132.4,273.6,133.1z"
      />
      <path
        class="st3"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st3"
        d="M273.1,134.6c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C273.6,134.1,273.4,134.4,273.1,134.6z"
      />
      <path
        class="st3"
        d="M184.7,120.3c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C184.3,120.8,184.5,120.5,184.7,120.3z"
      />
      <path
        class="st3"
        d="M24.5,177c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		s-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C24.8,176.6,24.6,176.8,24.5,177z"
      />
      <path
        class="st3"
        d="M134.6,124.3c-0.1,0.1-0.1,0.3-0.1,0.4c0.4,0.4,0.8,0.2,1.2-0.1c0,0,0-0.1,0.1-0.3
		C134.9,124,134.8,124,134.6,124.3z"
      />
      <path
        class="st3"
        d="M188.6,80.1c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C187.8,80.1,188.2,80.2,188.6,80.1z"
      />
      <path
        class="st3"
        d="M138.3,138.3c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1
		C138.3,138,138.3,138.2,138.3,138.3z"
      />
      <path
        class="st3"
        d="M130.9,111c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C130.4,110.5,130.3,110.9,130.9,111z"
      />
      <path
        class="st3"
        d="M157.1,99.1c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C156.6,99,156.9,99,157.1,99.1z"
      />
      <path
        class="st3"
        d="M170.3,105.5c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C169.7,106,169.9,105.8,170.3,105.5z"
      />
      <path
        class="st3"
        d="M85.7,146.5c0.7,0.3,1.1,0.1,1.4-0.6C86.3,145.7,85.9,145.9,85.7,146.5z"
      />
      <path
        class="st3"
        d="M135.1,127.1c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.7-0.5
		C135.5,127.3,135.2,127.1,135.1,127.1z"
      />
      <path
        class="st3"
        d="M134.6,115.9c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		s0.3,0,0.4-0.1C134.6,116.2,134.7,115.9,134.6,115.9L134.6,115.9z"
      />
      <path
        class="st3"
        d="M12.9,156.6c-0.1-0.6-0.2-1-0.3-1.4C12,155.8,12.1,156.3,12.9,156.6z"
      />
      <path
        class="st3"
        d="M7.7,169.5c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C6.6,168.6,6.7,169,7.7,169.5z"
      />
      <path
        class="st3"
        d="M272.4,133.6c-0.4-0.4-0.8-0.6-1.6,0.1C271.5,133.9,271.9,134.4,272.4,133.6z"
      />
      <path
        class="st3"
        d="M192.7,122.7c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C192.8,122.2,192.7,122.5,192.7,122.7z"
      />
      <path
        class="st3"
        d="M84.4,169.9C84.5,169.9,84.5,169.9,84.4,169.9c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C84.1,169.8,84.3,170,84.4,169.9z"
      />
      <path
        class="st3"
        d="M87,167c0.3-0.3,0.5-0.6,0.7-0.9C86.8,166.4,86.8,166.4,87,167z"
      />
      <path
        class="st3"
        d="M164.1,110.4c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C163.9,109.8,164,110.1,164.1,110.4z"
      />
      <path
        class="st3"
        d="M171,118.5c-0.7,0.5-1,1-0.6,1.6C170.7,119.6,171.2,119.1,171,118.5z"
      />
      <path
        class="st3"
        d="M267.6,76c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st3"
        d="M159.1,108.9c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C158.7,108.7,159,108.8,159.1,108.9z"
      />
      <path
        class="st3"
        d="M243.9,125.1c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C242.4,124.9,243.1,125,243.9,125.1z"
      />
      <path
        class="st3"
        d="M252.7,111.1c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C252.2,110.7,252.5,110.9,252.7,111.1z"
      />
      <path
        class="st3"
        d="M87.3,173.8c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C86.5,173.4,86.8,173.6,87.3,173.8z"
      />
      <path
        class="st3"
        d="M272.4,138.4c-0.5,0.5-0.5,0.9,0,1.3C273,139.2,272.9,138.8,272.4,138.4z"
      />
      <path
        class="st3"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st3"
        d="M264.9,104.4c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C264.6,104.4,264.8,104.4,264.9,104.4z"
      />
      <path
        class="st3"
        d="M174.3,115.4c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C174.3,115.4,174.3,115.4,174.3,115.4z"
      />
      <path
        class="st3"
        d="M237.9,131.3c-0.3-0.1-0.5-0.2-0.8-0.3h0.1c0,0,0,0-0.1,0c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9
		c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3v0.1c0,0,0,0,0.1,0C237,132.2,237,132.2,237.9,131.3z"
      />
      <path
        class="st3"
        d="M33.2,171.4c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C32.9,171.7,33.2,171.5,33.2,171.4z"
      />
      <path
        class="st3"
        d="M95.3,99.6c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st3"
        d="M49,149.7c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1c-0.1-0.1-0.2-0.1-0.3-0.2
		C49.5,149.2,49.3,149.4,49,149.7z"
      />
      <path
        class="st3"
        d="M27.3,172.8l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C26.9,173.3,27.1,173,27.3,172.8z"
      />
      <path
        class="st3"
        d="M246.8,115.6c0,0.8,0.8,0.6,1.2,0.8C247.9,115.9,247.6,115.5,246.8,115.6z"
      />
      <path
        class="st3"
        d="M105.3,132.8c0.2-0.8,0.2-1.2-0.7-1.2C104.8,132,104.9,132.3,105.3,132.8z"
      />
      <path
        class="st3"
        d="M241.2,130.5c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C241.5,129.5,241.3,129.8,241.2,130.5z"
      />
      <path
        class="st3"
        d="M128.3,114.1C128.2,114.1,128.2,114.1,128.3,114.1c-0.1,0-0.1,0.1-0.1,0.1S128.2,114.2,128.3,114.1
		C128.2,114.2,128.3,114.1,128.3,114.1z"
      />
      <path
        class="st3"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st3"
        d="M75.8,168.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4
		c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2C75.6,168,75.7,168.1,75.8,168.3z"
      />
      <path
        class="st3"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st3"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st3"
        d="M28.8,176.2c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C28.5,175.6,28.4,175.9,28.8,176.2z"
      />
      <path
        class="st3"
        d="M262.3,115.3c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C262.8,115.9,262.6,115.7,262.3,115.3z"
      />
      <path
        class="st3"
        d="M168.9,114.5c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C169.1,114.6,169,114.5,168.9,114.5z"
      />
      <path
        class="st3"
        d="M175.6,128.4C175.6,128.4,175.6,128.3,175.6,128.4h-0.1C175.5,128.4,175.5,128.4,175.6,128.4
		C175.5,128.4,175.6,128.4,175.6,128.4z"
      />
      <path
        class="st3"
        d="M176.4,129c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C175.7,128.8,175.8,129.1,176.4,129z"
      />
      <path
        class="st3"
        d="M177.9,127.3c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C178.2,127.4,178.1,127.3,177.9,127.3z"
      />
      <path
        class="st3"
        d="M55.7,151.9c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2
		c-0.4,0-0.8,0-1.3,0.1C55.8,151.8,55.8,151.9,55.7,151.9z"
      />
      <path
        class="st3"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.6,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st3"
        d="M63.7,175.8c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C63.9,175.6,63.8,175.7,63.7,175.8z"
      />
      <path
        class="st3"
        d="M233.6,127.7c-0.1,0.6,0.3,0.8,1,1.1C234.5,128.1,234.2,127.8,233.6,127.7z"
      />
      <path
        class="st3"
        d="M126.4,88.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C126.2,88.8,126.3,88.8,126.4,88.7z"
      />
      <path
        class="st3"
        d="M79.5,179.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.5z"
      />
      <path
        class="st3"
        d="M253.2,102.9c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C253,103,253.1,103,253.2,102.9z"
      />
      <path
        class="st3"
        d="M75.6,177.5c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5,0.1-0.8,0.1
		C75.4,177.4,75.5,177.4,75.6,177.5z"
      />
      <path
        class="st3"
        d="M76.7,177.2c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C76.7,177.3,76.7,177.2,76.7,177.2z"
      />
      <path
        class="st3"
        d="M267.6,113.3c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0
		C267.5,113.9,267.6,113.6,267.6,113.3z"
      />
      <path
        class="st3"
        d="M251.1,118.8c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C250.7,118.2,250.9,118.5,251.1,118.8z"
      />
      <path
        class="st3"
        d="M281.9,131.8c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3
		C282.5,132,282.2,131.9,281.9,131.8z"
      />
      <path
        class="st3"
        d="M130.1,113.8L130.1,113.8C130,113.7,130,113.8,130.1,113.8C130,113.8,130,113.8,130.1,113.8
		C130,113.8,130.1,113.8,130.1,113.8z"
      />
      <path
        class="st3"
        d="M130.1,115.1c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C130.2,114.7,130.1,114.9,130.1,115.1z"
      />
      <path
        class="st3"
        d="M142.6,129.1c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C141.5,129.3,141.9,129.3,142.6,129.1z"
      />
      <path
        class="st3"
        d="M167.5,111.8c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C167.2,112.1,167.4,111.9,167.5,111.8z"
      />
      <path
        class="st3"
        d="M114.3,106.3c0.4,0.2,0.7,0.4,1.2,0.7C115.4,106.1,115.1,106,114.3,106.3z"
      />
      <path
        class="st3"
        d="M178.2,88.2c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.2z"
      />
      <path
        class="st3"
        d="M217.5,117.8c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C217.3,117.7,217.4,117.7,217.5,117.8z"
      />
      <path
        class="st3"
        d="M178,121.9L178,121.9c0.1-0.1,0.1-0.2,0.2-0.2C178.1,121.7,178,121.8,178,121.9
		C177.9,121.9,177.9,121.9,178,121.9z"
      />
      <path
        class="st3"
        d="M177.5,122.9c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C177.5,122.1,177.4,122.5,177.5,122.9z"
      />
      <path
        class="st3"
        d="M135.6,131.2c-0.2,0.2-0.4,0.4-0.5,0.5c0,0.1,0.2,0.2,0.3,0.3h0.1c0.2,0,0.4-0.2,0.5-0.4l0,0
		C136,131.5,135.8,131.4,135.6,131.2z"
      />
      <path
        class="st3"
        d="M227.4,130.6c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C227.8,130.8,227.5,130.6,227.4,130.6z"
      />
      <path
        class="st3"
        d="M159,143.4c0.1-0.2,0.2-0.4,0.2-0.5s-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C158.6,143.2,158.9,143.3,159,143.4z"
      />
      <path
        class="st3"
        d="M102.1,156c-0.1-0.3-0.2-0.6-0.3-0.9C101.3,155.8,101.3,155.8,102.1,156z"
      />
      <path
        class="st3"
        d="M173.7,114.3c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2
		C173.4,114.3,173.6,114.3,173.7,114.3z"
      />
      <path
        class="st3"
        d="M246.8,98c-0.2-0.3-0.5-0.5-0.8-1C245.9,97.7,246.1,98,246.8,98z"
      />
      <path
        class="st3"
        d="M247,109.1c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C247.5,108.8,247.2,108.9,247,109.1z"
      />
      <path
        class="st3"
        d="M135.9,133.3c0.3-0.1,0.6-0.2,0.8-0.3c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2
		C135.9,133,135.9,133.1,135.9,133.3z"
      />
      <path
        class="st3"
        d="M179.8,125.5c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4C179.5,125.3,179.7,125.5,179.8,125.5z"
      />
      <path
        class="st3"
        d="M279.5,115.9c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1
		c0,0,0,0.1,0.1,0.1C279.2,115.5,279.4,115.7,279.5,115.9z"
      />
      <path
        class="st3"
        d="M288.7,125.7c0.4,0.2,0.6,0.3,1,0.4C289.4,125.6,289.4,125.6,288.7,125.7z"
      />
      <path
        class="st3"
        d="M141.7,126.3c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C141.4,126.2,141.6,126.4,141.7,126.3z"
      />
      <path
        class="st3"
        d="M80.8,167.6c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2C80.7,167.2,80.8,167.4,80.8,167.6z"
      />
      <path
        class="st3"
        d="M232.4,137.7c-0.7-0.3-1.1-0.4-1.5-0.6C231,137.6,231.3,137.9,232.4,137.7z"
      />
      <path
        class="st3"
        d="M230.9,137.1C230.9,137.1,230.9,137,230.9,137.1C230.9,137,230.9,137,230.9,137.1
		C230.8,137.1,230.8,137.1,230.9,137.1L230.9,137.1z"
      />
      <path
        class="st3"
        d="M144.8,103.2c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8
		C144.5,103.2,144.7,103.2,144.8,103.2z"
      />
      <path
        class="st3"
        d="M124,98c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5C123.9,98.2,124,98.1,124,98z"
      />
      <path
        class="st3"
        d="M127,94.3c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C126.8,94.4,127,94.3,127,94.3z"
      />
      <path
        class="st3"
        d="M237,132.2c-0.5,0.3-0.8,0.5-1.3,0.8C236.6,132.9,236.6,132.9,237,132.2z"
      />
      <path
        class="st3"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st3"
        d="M82.8,166.3c0.1-0.3,0.3-0.5,0.4-0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.4,0.5-0.6,0.7
		C82.5,166.2,82.6,166.3,82.8,166.3z"
      />
      <path
        class="st3"
        d="M27.6,162.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C27.4,162.8,27.5,162.8,27.6,162.8z
		"
      />
      <path
        class="st3"
        d="M189.2,113.3c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C189.3,113.1,189.2,113.2,189.2,113.3z"
      />
      <path
        class="st3"
        d="M127.4,90c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C126.8,89.8,127.1,89.9,127.4,90z"
      />
      <path
        class="st3"
        d="M233.6,144.6c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C233,144.9,233.3,144.8,233.6,144.6z"
      />
      <path
        class="st3"
        d="M251.3,140.7c0.6-0.3,1-0.5,1.4-0.6C252.1,139.9,251.6,139.9,251.3,140.7z"
      />
      <path
        class="st3"
        d="M232.1,132c0.1-0.1,0.1-0.1,0.2-0.2l0,0c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1,0.1-0.2,0.2-0.3,0.2
		c0.1,0,0.1,0.1,0.2,0.1C231.8,131.7,232,131.8,232.1,132z"
      />
      <path
        class="st3"
        d="M233.2,133.2c-0.3,0.1-0.7,0.1-1,0.2v0.1c0.3-0.1,0.7-0.1,1-0.2C233.3,133.3,233.2,133.3,233.2,133.2z"
      />
      <path
        class="st3"
        d="M163.8,103.7c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C163.6,104,163.6,103.8,163.8,103.7z"
      />
      <path
        class="st3"
        d="M155.9,76.1c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3
		C155.7,76,155.8,76.1,155.9,76.1z"
      />
      <path
        class="st3"
        d="M289.8,107.9c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0
		C289.6,108.3,289.7,108.1,289.8,107.9z"
      />
      <path
        class="st3"
        d="M196.2,68.4h-0.4C195.9,68.4,196,68.5,196.2,68.4C196.1,68.5,196.2,68.5,196.2,68.4z"
      />
      <path
        class="st3"
        d="M171.2,111.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C171,112.1,171.1,111.9,171.2,111.7z"
      />
      <path
        class="st3"
        d="M147.4,125.1c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C147.6,124.9,147.5,125,147.4,125.1z"
      />
      <path
        class="st3"
        d="M153.6,104.6c0.1,0,0.3-0.2,0.3-0.3c0-0.1-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1
		c0.2,0,0.3,0.1,0.4,0.1C153.5,104.6,153.5,104.6,153.6,104.6z"
      />
      <path
        class="st3"
        d="M127.7,97.4c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st3"
        d="M304.6,83c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C304.5,83,304.5,83,304.6,83z"
      />
      <path
        class="st3"
        d="M243.8,106c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C243.6,105.9,243.8,106,243.8,106z"
      />
      <path
        class="st3"
        d="M272.5,128.8c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C272.3,129,272.4,128.9,272.5,128.8z"
      />
      <path
        class="st3"
        d="M134.1,96.9c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.5,133.5,96.9,134.1,96.9z"
      />
      <path
        class="st3"
        d="M263.2,102.3c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C263.4,102.8,263.3,102.6,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3z"
      />
      <path
        class="st3"
        d="M129.7,115.9c-0.3-0.2-0.5-0.3-0.7-0.5C129,115.7,129,116.1,129.7,115.9z"
      />
      <path
        class="st3"
        d="M128.7,115.2L128.7,115.2l0.1,0.2C128.9,115.4,128.9,115.3,128.7,115.2C128.8,115.3,128.8,115.2,128.7,115.2z"
      />
      <path
        class="st3"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C83,142.1,83.1,142.2,83.2,142.3z"
      />
      <path
        class="st3"
        d="M82.1,169.7c-0.1,0.1-0.1,0.1-0.2,0.2L82,170c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C82.2,169.7,82.1,169.7,82.1,169.7z"
      />
      <path
        class="st3"
        d="M77.5,109.3c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3
		C77.1,109.6,77.2,109.4,77.5,109.3z"
      />
      <path
        class="st3"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C211.9,81.1,212,81.1,212.2,81.3z"
      />
      <path
        class="st3"
        d="M274.3,118.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.2-0.2,0.3c0.1,0,0.1,0.1,0.2,0.1
		C274,118.8,274.1,118.7,274.3,118.5L274.3,118.5z"
      />
      <path
        class="st3"
        d="M146.2,130.3c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4
		C146.1,130.5,146.2,130.4,146.2,130.3z"
      />
      <path
        class="st3"
        d="M131.8,115.6c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C132.1,115.8,131.9,115.6,131.8,115.6z"
      />
      <path
        class="st3"
        d="M161,94.8c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0.2-0.1,0.2
		C160.7,94.6,160.8,94.7,161,94.8z"
      />
      <path
        class="st3"
        d="M76.2,174c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.2
		C76,174.2,76.1,174.1,76.2,174z"
      />
      <path
        class="st3"
        d="M224.9,114.3c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C224.8,114.1,224.9,114.2,224.9,114.3z"
      />
      <path
        class="st3"
        d="M255.1,84.8c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C255.1,85,255.1,84.9,255.1,84.8z"
      />
      <path
        class="st3"
        d="M171.3,91.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C171.2,91.9,171.2,91.9,171.3,91.8z"
      />
      <path
        class="st3"
        d="M223.9,113.8c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C224,113.6,223.9,113.7,223.9,113.8z"
      />
      <path
        class="st3"
        d="M224.6,113.9c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1C224.7,113.9,224.6,113.9,224.6,113.9z"
      />
      <path
        class="st3"
        d="M158.6,96.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C158.4,96.3,158.5,96.2,158.6,96.1z"
      />
      <path
        class="st3"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174.1,78.3,174z"
      />
      <path
        class="st3"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C231.1,76.6,231.1,76.6,231,76.7z"
      />
      <path
        class="st3"
        d="M126.5,103.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C126.2,103.6,126.3,103.7,126.5,103.8z"
      />
      <path
        class="st3"
        d="M235.1,110.1c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C235.1,110,235.1,110,235.1,110.1z"
      />
      <path
        class="st3"
        d="M270,130.4c0,0.4,0.1,0.7,0.1,0.9C270.6,131.1,270.3,130.8,270,130.4z"
      />
      <path
        class="st3"
        d="M267.9,118.1c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0,0,0.2-0.1,0.2
		C267.8,118.1,267.9,118.1,267.9,118.1z"
      />
      <path
        class="st3"
        d="M25.3,172.8c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1C25.5,172.9,25.4,172.8,25.3,172.8z
		"
      />
      <path
        class="st3"
        d="M124.5,137c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st3"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st3"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st3"
        d="M83.7,173.5C83.8,173.5,83.8,173.5,83.7,173.5c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C84,173.3,83.9,173.4,83.7,173.5C83.8,173.4,83.8,173.4,83.7,173.5z"
      />
      <path
        class="st3"
        d="M178.5,120.8c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.3-0.4,0.5-0.6C178.7,120.9,178.6,120.9,178.5,120.8z"
      />
      <path
        class="st3"
        d="M185.8,124.4L185.8,124.4l0.1,0.1C185.9,124.6,185.8,124.5,185.8,124.4C185.8,124.5,185.8,124.5,185.8,124.4z"
      />
      <path
        class="st3"
        d="M185.5,124.1c0.1,0.1,0.1,0.2,0.2,0.3C185.7,124.3,185.7,124.2,185.5,124.1
		C185.6,124.1,185.6,124.1,185.5,124.1z"
      />
      <path
        class="st3"
        d="M173.4,108.5c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C173.1,108.6,173.2,108.6,173.4,108.5z"
      />
      <path
        class="st3"
        d="M276.7,141.3c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C276.5,141.2,276.6,141.3,276.7,141.3z"
      />
      <path
        class="st3"
        d="M186.3,125c0.1-0.1,0.1-0.2,0.2-0.3c-0.2,0-0.4-0.1-0.6-0.1C186,124.7,186.2,124.9,186.3,125z"
      />
      <path
        class="st3"
        d="M74.6,143.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C74.5,143.2,74.6,143.2,74.6,143.3z"
      />
      <path
        class="st3"
        d="M75.1,143c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C75.2,142.9,75.2,142.9,75.1,143z"
      />
      <path
        class="st3"
        d="M189.7,117.8c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C189.6,118.1,189.6,117.9,189.7,117.8
		z"
      />
      <path
        class="st3"
        d="M31.6,158.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C31.7,158.6,31.6,158.5,31.6,158.5z"
      />
      <path
        class="st3"
        d="M159.9,113.6l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1
		C160,113.3,159.9,113.4,159.9,113.6C159.8,113.5,159.8,113.6,159.9,113.6z"
      />
      <path
        class="st3"
        d="M199.6,114.3c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C199.7,114.1,199.6,114.3,199.6,114.3z"
      />
      <path
        class="st3"
        d="M249.7,113.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		C249.6,113.4,249.7,113.5,249.7,113.5z"
      />
      <path
        class="st3"
        d="M120.9,108.8c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1
		C120.9,108.7,120.8,108.8,120.9,108.8z"
      />
      <path
        class="st3"
        d="M120.8,131c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1C120.7,131.3,120.8,131.2,120.8,131
		z"
      />
      <path
        class="st3"
        d="M233.5,121.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C233.3,121,233.4,121,233.5,121.1z"
      />
      <path
        class="st3"
        d="M238.3,135.4c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C238.2,135.5,238.2,135.5,238.3,135.4z"
      />
      <path
        class="st3"
        d="M115.1,112.8c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1
		C115.2,112.9,115.1,112.9,115.1,112.8z"
      />
      <path
        class="st3"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st3"
        d="M81.2,162.6c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1c-0.1,0.1-0.2,0.2-0.3,0.3C80.9,162.6,81,162.6,81.2,162.6z"
      />
      <path
        class="st3"
        d="M275.1,111c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C275,111.3,275.1,111.1,275.1,111z"
      />
      <path
        class="st3"
        d="M234.4,134.7c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.2-0.1-0.3,0C234.4,134.5,234.4,134.6,234.4,134.7z
		"
      />
      <path
        class="st3"
        d="M185.5,110c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C185.7,110.4,185.6,110.2,185.5,110z"
      />
      <path
        class="st3"
        d="M141.6,137.6c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C141.4,137.5,141.5,137.7,141.6,137.6z"
      />
      <path
        class="st3"
        d="M166.4,103.5h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C166.4,103.7,166.4,103.6,166.4,103.5z"
      />
      <path
        class="st3"
        d="M241.2,132.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C241,132.1,241.1,132.2,241.2,132.2z"
      />
      <path
        class="st3"
        d="M270.8,109.5c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2
		C270.9,109.4,270.8,109.5,270.8,109.5z"
      />
      <path
        class="st3"
        d="M23.2,178.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C23.3,178.5,23.2,178.5,23.2,178.5z"
      />
      <path
        class="st3"
        d="M188.1,100.7c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C188.2,100.5,188.1,100.6,188.1,100.7z"
      />
      <path
        class="st3"
        d="M288.4,105.9c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C288.2,105.8,288.3,105.9,288.4,105.9z"
      />
      <path
        class="st3"
        d="M150.5,137.2c0-0.1,0.1-0.2,0.1-0.3c0,0-0.1-0.1-0.2-0.1l0,0l0,0l0,0c0,0,0,0,0,0.1l0,0
		c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C150.2,137.2,150.3,137.2,150.5,137.2z"
      />
      <path
        class="st3"
        d="M168.6,118.4c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C168.5,118.1,168.5,118.2,168.6,118.4z"
      />
      <path
        class="st3"
        d="M140.8,123.7L140.8,123.7C140.8,123.6,140.7,123.6,140.8,123.7C140.7,123.7,140.7,123.8,140.8,123.7
		C140.8,123.7,140.8,123.7,140.8,123.7z"
      />
      <path
        class="st3"
        d="M141.8,122.5c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C142,122.6,141.9,122.5,141.8,122.5z"
      />
      <path
        class="st3"
        d="M241.2,99.3c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C241,99.2,241.1,99.3,241.2,99.3z"
      />
      <path
        class="st3"
        d="M165.6,119.8c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C165.5,119.7,165.6,119.8,165.6,119.8z"
      />
      <path
        class="st3"
        d="M84.1,137.9c0-0.1,0.1-0.1,0.1-0.2C84.2,137.7,84.1,137.8,84.1,137.9c-0.1,0-0.2,0.1-0.2,0.1
		C84,137.9,84,137.9,84.1,137.9z"
      />
      <path
        class="st3"
        d="M105.9,133.3c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C106.3,133.3,106.1,133.3,105.9,133.3z"
      />
      <path
        class="st3"
        d="M183.4,109.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C183.7,109.4,183.6,109.4,183.4,109.5
		C183.4,109.4,183.4,109.5,183.4,109.5z"
      />
      <path
        class="st3"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st3"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st3"
        d="M75.1,166.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2
		C75,166.2,75.1,166.2,75.1,166.3z"
      />
      <path
        class="st3"
        d="M196.7,104.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.7,104.8z"
      />
      <path
        class="st3"
        d="M171.3,123.2h0.1C171.4,123.2,171.4,123.1,171.3,123.2C171.4,123.1,171.3,123.1,171.3,123.2L171.3,123.2z"
      />
      <path
        class="st3"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st3"
        d="M132.6,115.3c0,0,0.1,0,0.2,0C132.8,115.3,132.8,115.2,132.6,115.3C132.6,115.2,132.6,115.2,132.6,115.3
		C132.5,115.2,132.5,115.3,132.6,115.3z"
      />
      <path
        class="st3"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st3"
        d="M148.6,130.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C148.6,130.7,148.6,130.7,148.6,130.6L148.6,130.6z"
      />
      <path
        class="st3"
        d="M139.9,113.4c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C140.1,113.4,140,113.4,139.9,113.4z"
      />
      <path
        class="st3"
        d="M261.7,107.2L261.7,107.2c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1l0,0C261.5,107.3,261.6,107.3,261.7,107.2
		C261.7,107.3,261.7,107.3,261.7,107.2z"
      />
      <path
        class="st3"
        d="M163.2,107.7c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C163.3,107.6,163.3,107.7,163.2,107.7z"
      />
      <path
        class="st3"
        d="M275,141.4c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C274.9,141.1,275,141.2,275,141.4z"
      />
      <path
        class="st3"
        d="M290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3c-0.1,0.2-0.1,0.3-0.1,0.3
		C290.8,102.6,290.9,102.5,290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3z"
      />
      <path
        class="st3"
        d="M291,102c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C291.1,102,291.1,102,291,102z"
      />
      <path
        class="st3"
        d="M30.6,159.6l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st3"
        d="M119,141c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C118.9,141.2,118.9,141.1,119,141z"
      />
      <path
        class="st3"
        d="M273.2,140.4l0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1S273.2,140.3,273.2,140.4z"
      />
      <path
        class="st3"
        d="M31.7,160.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C31.7,160.9,31.7,160.8,31.7,160.8z"
      />
      <path
        class="st3"
        d="M188.1,127.4l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C188,127.2,188.1,127.3,188.1,127.4z"
      />
      <path
        class="st3"
        d="M122.4,115.4c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C122.5,115.2,122.4,115.3,122.4,115.4z"
      />
      <path
        class="st3"
        d="M253.9,112.9c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C254,112.9,254,112.8,253.9,112.9
		C254,112.8,253.9,112.9,253.9,112.9z"
      />
      <path
        class="st3"
        d="M245.4,115c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0S245.4,114.9,245.4,115z"
      />
      <path
        class="st3"
        d="M76.9,178c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C77.1,178,77,178,76.9,178z"
      />
      <path
        class="st3"
        d="M109.7,145.8L109.7,145.8C109.6,145.8,109.6,145.9,109.7,145.8c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C109.9,145.8,109.8,145.8,109.7,145.8L109.7,145.8z"
      />
      <path
        class="st3"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st3"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.5,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st3"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st3"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st3"
        d="M71.5,155.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C71.6,155.2,71.6,155.2,71.5,155.2z"
      />
      <path
        class="st3"
        d="M71.4,155.3L71.4,155.3c0.1,0,0.1,0,0.1-0.1C71.5,155.3,71.5,155.3,71.4,155.3L71.4,155.3z"
      />
      <path
        class="st3"
        d="M71.1,155.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C71,155.6,71,155.6,71.1,155.7z"
      />
      <path
        class="st3"
        d="M248.6,82.8c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C248.6,82.9,248.6,82.8,248.6,82.8z"
      />
      <path
        class="st3"
        d="M228.8,143.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C228.9,143.6,228.8,143.5,228.8,143.5z"
      />
      <path
        class="st3"
        d="M160.1,97.8c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C160,98,160.1,97.9,160.1,97.8z"
      />
      <path
        class="st3"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st3"
        d="M277.3,114.2c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C277.2,114.2,277.3,114.2,277.3,114.2z"
      />
      <path
        class="st3"
        d="M277.6,132.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2
		C277.7,132.4,277.6,132.5,277.6,132.6z"
      />
      <path
        class="st3"
        d="M144.5,100.2c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1-0.1C144.5,100.3,144.5,100.3,144.5,100.2z"
      />
      <path
        class="st3"
        d="M249,138.3c-0.2,0-0.4,0.1-0.6,0.1v0.1c0.2,0,0.4-0.1,0.6-0.1C249,138.4,249,138.3,249,138.3z"
      />
      <path
        class="st3"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st3"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1C27.6,125.1,27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st3"
        d="M144.3,99.1l-0.1-0.1l-0.1,0.1l0.1,0.1C144.3,99.1,144.3,99.1,144.3,99.1z"
      />
      <path
        class="st3"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st3"
        d="M96.6,107.9c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C96.5,107.9,96.5,107.9,96.6,107.9z"
      />
      <path
        class="st3"
        d="M96.3,107.7L96.3,107.7L96.3,107.7C96.2,107.6,96.2,107.6,96.3,107.7C96.3,107.6,96.3,107.7,96.3,107.7z"
      />
      <path
        class="st3"
        d="M172.9,90.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C172.8,90.2,172.9,90.1,172.9,90.1z"
      />
      <path
        class="st3"
        d="M69,174.5v0.1c0,0,0,0.1,0.1,0.1v-0.1C69,174.6,69,174.6,69,174.5z"
      />
      <path
        class="st3"
        d="M269.9,130.1C269.9,130.1,269.9,130,269.9,130.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C269.7,130.1,269.8,130.1,269.9,130.1z"
      />
      <path
        class="st3"
        d="M119.9,101.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C119.9,100.8,119.8,100.9,119.9,101.1
		C119.7,101,119.8,101.1,119.9,101.1z"
      />
      <path
        class="st3"
        d="M228.5,128.6c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1
		C228.4,128.8,228.5,128.7,228.5,128.6z"
      />
      <path
        class="st3"
        d="M244.3,135.3c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C244.2,135.2,244.3,135.3,244.3,135.3z"
      />
      <path
        class="st3"
        d="M157.6,144.7C157.6,144.6,157.5,144.7,157.6,144.7c-0.1,0.1,0,0.2,0,0.2l0.1-0.1
		C157.6,144.7,157.6,144.7,157.6,144.7z"
      />
      <path
        class="st3"
        d="M243.1,126.2c0,0.1,0,0.1,0.1,0.2l0.1-0.1C243.3,126.2,243.2,126.2,243.1,126.2
		C243.2,126.2,243.2,126.2,243.1,126.2z"
      />
      <path
        class="st3"
        d="M268.2,120.7c0,0.1,0.1,0.1,0.2,0.2v-0.1C268.4,120.7,268.4,120.7,268.2,120.7
		C268.3,120.7,268.2,120.7,268.2,120.7z"
      />
      <path
        class="st3"
        d="M239.8,127.6l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1C239.8,127.7,239.8,127.6,239.8,127.6z"
      />
      <path
        class="st3"
        d="M286,125c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st3"
        d="M107.1,97.4L107.1,97.4c-0.1-0.1-0.2-0.1-0.2,0C106.9,97.4,106.9,97.5,107.1,97.4
		C107,97.4,107,97.4,107.1,97.4z"
      />
      <path
        class="st3"
        d="M79.9,169l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C79.7,169.1,79.8,169,79.9,169z"
      />
      <path
        class="st3"
        d="M183.5,74.2C183.5,74.2,183.4,74.2,183.5,74.2c-0.1,0.1-0.1,0.2-0.1,0.2C183.5,74.4,183.5,74.4,183.5,74.2
		C183.6,74.3,183.5,74.2,183.5,74.2z"
      />
      <path
        class="st3"
        d="M93.5,159.5c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C93.5,159.4,93.5,159.5,93.5,159.5z"
      />
      <path
        class="st3"
        d="M26.3,174.9C26.4,174.8,26.4,174.8,26.3,174.9c0.1-0.1,0-0.1,0-0.1l-0.1-0.1l-0.1,0.1
		C26.2,174.8,26.2,174.8,26.3,174.9L26.3,174.9z"
      />
      <path
        class="st3"
        d="M154.8,75.1c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C154.7,75.3,154.8,75.2,154.8,75.1z"
      />
      <path
        class="st3"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st3"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st3"
        d="M18.3,176.9c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1C18.3,176.8,18.3,176.9,18.3,176.9z"
      />
      <path
        class="st3"
        d="M140,150.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C140,150.6,140,150.6,140,150.6z"
      />
      <path
        class="st3"
        d="M2.1,207.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0l0,0l0,0C2.1,207.9,2.1,207.8,2.1,207.7z"
      />
      <path
        class="st3"
        d="M277.5,141.5l-0.1-0.1l-0.1,0.1l0.1,0.1C277.5,141.6,277.5,141.6,277.5,141.5z"
      />
      <path
        class="st3"
        d="M0.5,200.2c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C0.6,200.2,0.6,200.2,0.5,200.2z"
      />
      <path
        class="st3"
        d="M0.3,200.5v0.1C0.4,200.6,0.4,200.5,0.3,200.5C0.4,200.5,0.4,200.4,0.3,200.5C0.4,200.4,0.4,200.4,0.3,200.5z"
      />
      <path
        class="st3"
        d="M283.6,135.1c0,0-0.1,0-0.1-0.1l0,0l0,0C283.5,135.1,283.5,135.1,283.6,135.1z"
      />
      <path
        class="st3"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st3"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,180,77,179.9,76.9,179.9z"
      />
      <path
        class="st3"
        d="M254.7,140.5l-0.1,0.1C254.6,140.6,254.6,140.6,254.7,140.5C254.7,140.6,254.7,140.6,254.7,140.5z"
      />
      <path
        class="st3"
        d="M70.4,179.3C70.4,179.3,70.4,179.2,70.4,179.3c0.1-0.1,0-0.2,0-0.2C70.3,179.2,70.3,179.2,70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3z"
      />
      <path
        class="st3"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st3"
        d="M280.9,131.9c0-0.1,0.1-0.2,0.1-0.3C280.9,131.7,280.9,131.8,280.9,131.9c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.1,0,0.1,0.1,0.2,0.1C280.8,132.1,280.8,132,280.9,131.9z"
      />
      <path
        class="st3"
        d="M249.4,138.9C249.4,138.9,249.5,138.9,249.4,138.9c0.1,0.1,0.1,0.1,0.2,0.1l0,0c0,0,0,0,0.1,0l0,0
		C249.5,138.9,249.5,138.9,249.4,138.9z"
      />
      <polygon class="st3" points="273.5,130.8 273.6,130.8 273.5,130.7 	" />
      <path
        class="st3"
        d="M270,131.6c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C270,131.5,270,131.5,270,131.6z"
      />
      <path
        class="st3"
        d="M79.4,172.1c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C79.5,172.1,79.4,172.1,79.4,172.1z"
      />
      <path
        class="st3"
        d="M79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.4,172.1,79.3,172.1,79.3,172
		C79.3,172.1,79.3,172.1,79.3,172z"
      />
      <path
        class="st3"
        d="M79.1,172c0.1,0,0.1,0,0.2,0.1V172C79.2,172,79.2,172,79.1,172z"
      />
      <path
        class="st3"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,187,8.3,187,8.3,187.1z"
      />
      <path
        class="st3"
        d="M273.4,129.1v0.1C273.4,129.2,273.4,129.2,273.4,129.1c0.1,0,0.1-0.1,0.1-0.1
		C273.4,129,273.4,129.1,273.4,129.1z"
      />
      <polygon class="st3" points="270.6,129.3 270.6,129.2 270.5,129.3 	" />
      <path
        class="st3"
        d="M83.2,166.7L83.2,166.7C83.2,166.7,83.3,166.7,83.2,166.7c0.1,0,0.2,0,0.2,0.1
		C83.4,166.7,83.4,166.7,83.2,166.7C83.3,166.6,83.3,166.7,83.2,166.7z"
      />
      <path
        class="st3"
        d="M83.5,166.8L83.5,166.8c0.1,0.1,0.1,0.1,0.1,0.1C83.6,166.8,83.5,166.8,83.5,166.8L83.5,166.8z"
      />
      <polygon class="st3" points="66.2,170.3 66.1,170.4 66.2,170.4 	" />
      <polygon class="st3" points="32.6,175.6 32.5,175.5 32.4,175.5 	" />
      <path
        class="st3"
        d="M233,131.3c0,0.1,0,0.2-0.1,0.2C233,131.4,233,131.4,233,131.3c0.1-0.1,0.1-0.1,0.1-0.2
		C233.1,131.1,233,131.2,233,131.3z"
      />
      <polygon class="st3" points="28.8,172.6 28.9,172.5 28.9,172.5 	" />
      <polygon class="st3" points="87.9,159.5 87.9,159.4 87.8,159.4 	" />
      <polygon class="st3" points="153.2,144.6 153.4,144.6 153.3,144.5 	" />
      <path
        class="st3"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st3"
        d="M274.5,117.1c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C274.4,117.2,274.5,117.2,274.5,117.1z"
      />
      <path
        class="st3"
        d="M242.7,124.1c0.1,0,0.1,0,0.2,0C242.8,124.1,242.8,124,242.7,124.1C242.7,124,242.7,124,242.7,124.1z"
      />
      <path
        class="st3"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st3"
        d="M101.9,154.1c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2
		C101.9,154.3,101.9,154.2,101.9,154.1z"
      />
      <path
        class="st3"
        d="M235.3,123.7c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C235.5,123.6,235.4,123.7,235.3,123.7z"
      />
      <polygon class="st3" points="155.8,140.9 156,141 155.9,140.9 	" />
      <polygon class="st3" points="242.6,121.9 242.7,121.8 242.6,121.8 	" />
      <path
        class="st3"
        d="M235.6,123.3c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C235.6,123.4,235.6,123.4,235.6,123.3z"
      />
      <path
        class="st3"
        d="M75.7,157.7l-0.1-0.1l-0.1,0.1l0.1,0.1C75.7,157.7,75.7,157.7,75.7,157.7z"
      />
      <polygon class="st3" points="246.2,115.5 246.2,115.4 246.1,115.4 	" />
      <path
        class="st3"
        d="M290.3,103.6c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C290.2,103.7,290.3,103.7,290.3,103.6z"
      />
      <path
        class="st3"
        d="M186.8,124.3c-0.1,0.1-0.2,0.2-0.3,0.4l0,0c0,0,0,0,0.1,0C186.7,124.6,186.8,124.5,186.8,124.3L186.8,124.3
		c0.1-0.1,0.1-0.1,0.1-0.2C186.9,124.2,186.9,124.2,186.8,124.3z"
      />
      <path
        class="st3"
        d="M178.4,126c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1C178.4,126.1,178.4,126,178.4,126z"
      />
      <polygon class="st3" points="103.4,141.3 103.3,141.3 103.4,141.4 	" />
      <path
        class="st3"
        d="M182.7,122.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C182.6,123,182.6,122.9,182.7,122.9z"
      />
      <path
        class="st3"
        d="M138.3,132.4L138.3,132.4c0-0.1-0.1-0.1-0.1-0.1C138.1,132.3,138.2,132.3,138.3,132.4z"
      />
      <path
        class="st3"
        d="M208.5,113.6c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2C208.4,113.6,208.5,113.6,208.5,113.6z"
      />
      <path
        class="st3"
        d="M74.3,142.5l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1S74.4,142.5,74.3,142.5z"
      />
      <path
        class="st3"
        d="M74.5,142.4L74.5,142.4c0.1,0,0.1-0.1,0.1-0.1C74.6,142.3,74.5,142.3,74.5,142.4z"
      />
      <path
        class="st3"
        d="M207.9,113.1l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C207.8,113.1,207.9,113.1,207.9,113.1z"
      />
      <polygon class="st3" points="242.8,103.3 242.7,103.3 242.8,103.4 	" />
      <path
        class="st3"
        d="M94.3,135.1c0,0-0.1,0.1,0,0.1l0.1,0.1C94.4,135.2,94.4,135.2,94.3,135.1C94.4,135,94.4,135.1,94.3,135.1z"
      />
      <polygon class="st3" points="27.3,149.6 27.3,149.7 27.4,149.7 	" />
      <polygon class="st3" points="242.4,102.8 242.3,102.7 242.3,102.8 	" />
      <polygon class="st3" points="127.1,124.3 127.2,124.3 127.2,124.2 	" />
      <path
        class="st3"
        d="M128.7,116.9l0.1-0.1l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C128.6,116.8,128.6,116.9,128.7,116.9z"
      />
      <path
        class="st3"
        d="M269.5,84.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C269.4,85.1,269.4,85,269.5,84.9z"
      />
      <polygon
        class="st3"
        points="227,93.9 227,93.8 227,93.8 226.9,93.8 227,93.8 	"
      />
      <polygon class="st3" points="132.3,114.3 132.1,114.4 132.3,114.4 	" />
      <path
        class="st3"
        d="M195,100.3C195.1,100.3,195.1,100.3,195,100.3C195.1,100.3,195,100.3,195,100.3c-0.1,0.1-0.1,0.1-0.1,0.2
		C195,100.5,195,100.4,195,100.3L195,100.3z"
      />
      <path
        class="st3"
        d="M195.2,100c0,0.1-0.1,0.2-0.1,0.2C195.2,100.1,195.3,100.1,195.2,100C195.3,100.1,195.2,100,195.2,100z"
      />
      <polygon class="st3" points="139.8,112.2 139.9,112.2 139.8,112.1 	" />
      <polygon class="st3" points="242.5,89.5 242.4,89.5 242.5,89.6 	" />
      <polygon class="st3" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st3"
        d="M115.4,116.8L115.4,116.8h-0.2H115.4C115.3,116.9,115.3,116.9,115.4,116.8z"
      />
      <polygon class="st3" points="2.6,141.3 2.6,141.2 2.5,141.3 	" />
      <path
        class="st3"
        d="M269.6,80.3c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C269.5,80.3,269.6,80.3,269.6,80.3z"
      />
      <path
        class="st3"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,121,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st3"
        d="M106.5,110.2C106.5,110.2,106.6,110.2,106.5,110.2h0.2H106.5C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <path
        class="st3"
        d="M159.2,97.6l-0.1-0.1l-0.1,0.1l0.1,0.1C159.2,97.7,159.2,97.6,159.2,97.6z"
      />
      <polygon class="st3" points="121.2,105.4 121.2,105.6 121.3,105.5 	" />
      <polygon class="st3" points="139.3,101 139.2,100.9 139.2,101 	" />
      <path
        class="st3"
        d="M157.1,96.5l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C157,96.5,157,96.5,157.1,96.5z"
      />
      <path
        class="st3"
        d="M96,107.5L96,107.5c0.1,0.1,0.1,0.1,0.2,0.1C96.1,107.5,96.1,107.5,96,107.5z"
      />
      <path class="st3" d="M155.9,92.6l0.1-0.1v-0.1L155.9,92.6L155.9,92.6z" />
      <polygon class="st3" points="134.6,97.2 134.6,97.3 134.7,97.3 	" />
      <path
        class="st3"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st3"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st3"
        d="M171.9,293.6c0-0.1-0.1-0.3-0.2-0.4c-0.7,0.1-1.4,0.2-2.1,0.5c0.6,0.5,0.9,0.7,1.1,1c0.3,0.5,0.6,1,0.5,1.5
		c0,0.2-0.8,0.5-1.3,0.5c-3.7-0.1-7.5,0.3-10.9-0.7c-2.7-0.8-5.3-0.7-8-1.3c0.9-0.3,1.8-0.7,2.7-1c0-0.2,0-0.4,0-0.5
		c-1.2,0-2.4,0.1-3.7,0.1c-0.4,1.2-0.4,2.3,0.3,3.4c0.7,1,1.6,1.5,2.8,1.8c1.6-0.3,3.1-0.6,4.7-0.8c3.2-0.5,6.5-0.3,9.8,0
		c0.8,0.1,1.5,0.3,2.2,0.6c0.4-0.2,0.7-0.4,1-0.7l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4
		C172,294.2,172,293.9,171.9,293.6z"
      />
      <path
        class="st3"
        d="M51.1,314.7c0.5,0.7,1.1,1.4,1.6,2c0.7,0.3,1.5,0.5,2.4,0.4c0.1,0,0.1,0,0.2-0.1c-1.1-1.7-2.1-3.2-3.2-4.8
		C51.3,312.9,51,313.8,51.1,314.7z"
      />
      <path
        class="st3"
        d="M285.7,128.9c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4
		c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1c0.3,0.9,0,2-0.2,3.1c1.2-2,2.3-3.9,3.5-5.8
		c1.1-1.7,2.4-3.1,3.8-4.4l0,0c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5
		c1.6-0.6,2.4-2.3,1.6-3.6c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3
		c-1.5,0.9-2,1.6-1.7,2.7c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2
		c-0.5,0-1.1,0.2-1.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3
		c-0.3-1.1-1-1.6-2.4-1.6c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0C286.2,128.4,286,128.7,285.7,128.9z"
      />
      <path
        class="st3"
        d="M167.1,291.7c0.9,0,1.8-0.1,2.7-0.1c-0.6-0.2-1.3-0.4-2.1-0.5C167.6,291.3,167.3,291.5,167.1,291.7z"
      />
      <path
        class="st3"
        d="M228.2,269c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9
		c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1
		c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c0-0.3-0.1-0.5-0.2-0.9c-4.6-5.2-5.2-16.4-0.6-21.2c-0.4,1.8-0.7,3.6-1.1,5.4
		c0.4,0.3,0.6,0.9,1.2,1.2c0.1-0.2,0.2-0.4,0.3-0.6c0-0.4,0-0.8,0-1.2c0.1-2.3,0.6-4.3,1.5-6.2c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.3-0.1-0.7-0.2-1.1-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.2,0,0.5,0,0.7
		c-0.1,1-0.8,1.8-2.1,2.4c0.1-0.3,0.2-0.5,0.3-0.8c-0.8,1.1-1.6,2.2-2.5,3.3c-2.2-1.6-4.7-3.3-7.2-5.2c-0.4-0.3-0.7-0.9-0.7-1.4
		c0-0.1,0-0.1,0-0.2c-0.3-0.1-0.6-0.3-1-0.4c-0.5,8.2,1,15.9,4.4,23.4c0.1-0.3,0.2-0.6,0.6-0.7c0.4,0.4,0.7,0.8,1,1.1
		c-0.7-1.6-1.4-3.3-2.1-5c2.4,1.1,4.3,2.4,5.7,4c0.1-0.1,0.3-0.1,0.4-0.2C228.8,269.7,228.4,269.4,228.2,269z M221,252.9
		c2.3,1.6,4.6,3.3,6.9,4.9c-0.1,0.2-0.3,0.4-0.4,0.7c-2.4-1.6-4.7-3.1-7.1-4.7C220.6,253.5,220.8,253.2,221,252.9z M221.2,256.5
		c2,1.6,4,3.2,6.1,4.8c-0.2,0.2-0.4,0.5-0.6,0.7c-2.1-1.5-4.1-3-6.2-4.5C220.7,257.2,221,256.9,221.2,256.5z M226.9,265.8
		c-1.8-1-3.6-2.1-5.4-3.1c0.2-0.4,0.5-0.7,0.7-1.1c1.7,1.2,3.5,2.3,5.2,3.5C227.3,265.3,227.1,265.5,226.9,265.8z"
      />
      <path
        class="st3"
        d="M364.7,245.5v-0.1c-0.1,0-0.3,0.1-0.4,0.1C364.5,245.4,364.6,245.4,364.7,245.5z"
      />
      <path
        class="st3"
        d="M240.1,271.7c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.3,0.1-0.6,0.2-1c-0.5-0.5-0.9-1.3-1.1-2.1c-0.2,0-0.3-0.1-0.5-0.1
		c-0.3,0-0.6-0.1-1.1-0.1c0.5-0.6,0.9-1.2,1.4-1.8c0-0.1,0-0.1,0-0.2c-0.2,0.1-0.3,0.1-0.5,0.2c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9l0,0c0-1,0-1.9,0.1-2.9
		c-0.4,0.1-0.8,0.3-1.2,0.5c-0.3,0.1-0.5,0.2-0.8,0.3c-0.1,0.5-0.3,1.1-0.4,1.6c-1.4,4.6,0.2,8.2,3,11.5c0.2-0.1,0.4-0.2,0.5-0.2
		c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6
		c0.2,0.2,0.7,0.1,1.2,0.1C241.6,272.7,241.3,271.9,240.1,271.7z"
      />
      <path
        class="st3"
        d="M159.3,270.3c0.1,0.2,0.3,0.5,0.4,0.7c1.9-1,3.8-1.9,5.7-2.9c-0.1-0.2-0.2-0.4-0.3-0.6
		C162.9,267.8,160.8,268.4,159.3,270.3z"
      />
      <path
        class="st3"
        d="M446.3,184.3L446.3,184.3c-0.5,0.4-1.1,0.8-1.7,1.2c0.3,0,0.6-0.1,0.9-0.2C445.8,184.9,446,184.6,446.3,184.3z
		"
      />
      <path
        class="st3"
        d="M452.9,128.9c-1.7,0.2-3.2,0.4-4.8,0.4c-1.5,0-3-0.1-4.6-0.1C446,131.1,451,130.7,452.9,128.9z"
      />
      <path
        class="st3"
        d="M216.3,266.3c-1.9-3.9-3.9-7.8-5.8-11.6c-0.4,0.6-0.7,1.3-1.1,2c-0.1,0.1-0.1,0.2-0.2,0.3
		c0,0.1,0.1,0.2,0.1,0.2c0.2,0,0.4-0.1,0.6-0.1c0.1,0.2,0.2,0.4,0.3,0.7c-0.2,0-0.3,0.1-0.4,0.2c0.7,1.2,1.4,2.5,2.1,3.7
		c0.1-0.2,0.2-0.3,0.4-0.5c0.3,0.6,0.3,0.8-0.2,0.9c0.5,0.9,1,1.8,1.5,2.7c0.2,0,0.5,0.1,0.7,0.1c0.4,0,0.7,0.3,1,0.5
		c0.2,0.1,0.3,0.3,0.4,0.5C215.8,266.1,216,266.3,216.3,266.3z"
      />
      <path
        class="st3"
        d="M370,103.4c-0.2,0-0.4,0-0.6,0c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.1,1,0.2,1.5,0.1
		C370.5,103.5,370.2,103.4,370,103.4z"
      />
      <path
        class="st3"
        d="M208.4,258.7c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6,0c1.1,1.6,2.1,3.5,3.2,5.5c0.1,0,0.2,0,0.3-0.1
		c-0.1-0.4-0.1-0.9-0.2-1.4c0.1,0,0.2,0,0.3,0C210.1,261.4,209.2,260.1,208.4,258.7z"
      />
      <path
        class="st3"
        d="M198.9,256.6c0,0.2,0.1,0.4,0.3,0.6C199.1,256.9,199,256.8,198.9,256.6z"
      />
      <path
        class="st3"
        d="M310.9,139.7c0.7-0.5,1.2-1,1.6-1.7c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0-0.7,0c-0.3,0.5-0.6,1-0.9,1.5
		C310.6,139.6,310.8,139.6,310.9,139.7z"
      />
      <path
        class="st3"
        d="M363.3,183.9c-1.2,0.4-3.2,0.6-3.3,1.2c-0.3,1.2,0.4,2.7,0.8,4c0.3,0.7,1,1.2,1.4,1.9c1.5,2.7,3.8,3.7,6.7,3.5
		c1.9-0.1,2.8-1.1,2.9-3C371.9,188.1,367.5,184.3,363.3,183.9z"
      />
      <path
        class="st3"
        d="M203.8,260.2c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5s1.1,0.6,1.7,0.8c-1.1-1.5-2-3.1-2.9-4.8
		C204.9,259.5,204.3,259.8,203.8,260.2z"
      />
      <path
        class="st3"
        d="M475.5,144.7c2,0.8,4.1,1.5,6.1,2.3c0.1-0.3,0.2-0.6,0.3-0.9c-2-0.8-4-1.7-6-2.5
		C475.8,144,475.7,144.3,475.5,144.7z"
      />
      <path
        class="st3"
        d="M510.4,84.5c2.2,0.4,4.4,1.3,6.7,0.4c0-0.3,0-0.6,0-0.8c-2.2-0.1-4.4-0.1-6.6-0.2
		C510.4,84.1,510.4,84.3,510.4,84.5z"
      />
      <path
        class="st3"
        d="M198.2,252.9c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c0.9,0.7,1.7,1.1,2.3,1.1c-0.1-0.7,0-1.4,0.3-2.2
		c0-0.1,0-0.2,0-0.3C198.7,252.8,198.4,252.9,198.2,252.9z"
      />
      <path
        class="st3"
        d="M352.6,189.3c-1.5-0.7-3.3-0.9-4.3,0.8c-1.2,2.1-2.1,4.3-3.1,6.5c0.5,3.6,2.2,5.7,4.7,5.4
		c2.2-0.3,5.1-3.4,5.7-6.2C355.9,194,354.2,190.1,352.6,189.3z"
      />
      <path
        class="st3"
        d="M366.5,198.9c-3.9-0.3-7.4,1.2-10.5,3.4c-1.8,1.3-1.5,2.9,0.4,3.9c1.3,0.7,2.8,1,4.2,1.5
		c3.1-0.1,6.3-2.3,7.7-5.4C369.4,200.2,368.8,199.1,366.5,198.9z"
      />
      <path
        class="st3"
        d="M493.6,132.1c-2.6-1.4-4.8-2.6-6.9-3.8C489,132.9,489.9,133.4,493.6,132.1z"
      />
      <path
        class="st3"
        d="M149.2,292.1c0.1-0.5,0.2-1,0.3-1.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4,0.5-0.8,1-1.1,1.5c0.3,0.1,0.6,0.2,0.9,0.2
		C149,292.1,149.1,292.1,149.2,292.1z"
      />
      <path
        class="st3"
        d="M202.2,257.1c0,0.5,0,1,0,1.4c0.3,0.2,0.5,0.5,0.8,0.9c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8
		c0,0.3,0.1,0.6,0.1,0.9c0,0.1-0.3,0.3-0.5,0.5C202.3,257.2,202.3,257.2,202.2,257.1z"
      />
      <path
        class="st3"
        d="M143.3,274.5c0.2,0.3,0.5,0.5,0.8,0.8c-0.1,0.4-0.2,0.8-0.4,1.2c1.3-2.3,2.8-4.5,4.4-6.6
		c-1.1-0.4-2.5-0.3-3.7,0.4C142.8,271.3,142.4,273.1,143.3,274.5z"
      />
      <path
        class="st3"
        d="M147.2,283.8c0.3,0,0.7-0.1,1-0.1c0.2-0.4,0.4-0.7,0.6-1.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.7,0.8-1.3,1.6-2,2.4
		C146.7,284.5,147,284.2,147.2,283.8z"
      />
      <path
        class="st3"
        d="M141.7,283.7c0.2-0.5,0.4-1,0.7-1.6c-0.1,0-0.2,0-0.3,0C141.7,282.6,141.6,283.1,141.7,283.7z"
      />
      <path
        class="st3"
        d="M429.1,88.7c1.6,0.2,3.2-0.6,4.9-0.8c2.3-0.2,4.6-0.2,6.9-0.3c0-0.3,0.1-0.6,0.1-0.8c-2.7-0.3-5.4-0.5-8.2-0.8
		c0.1-0.5,0.3-0.9,0.5-1.4c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6c-0.7-0.1-1.3-0.2-2.1-0.4l0,0
		c-0.8,0.1-1.7,0.1-2.5,0.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-0.6-0.2-1.2-0.2-1.8-0.2
		c-2.1,0.7-4,2-5.6,3.9c0.7-0.2,1.5-0.3,2.2-0.6C419.3,88.4,424.1,88,429.1,88.7z"
      />
      <path
        class="st3"
        d="M145.8,288.1c-0.4,1.5,0.2,2.8,1.6,3.5c0.6-1.1,1.1-2.2,1.7-3.3c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.7,0.7-1.4,1.4-2.1,2.2c-0.1-0.1-0.2-0.1-0.3-0.2c0.8-1.3,1.5-2.7,2.3-4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1,0-0.2,0.1-0.3,0.1
		c-0.4,0.6-0.9,1.3-1.3,1.9c-0.2-0.1-0.3-0.3-0.5-0.4C146,287.6,145.9,287.8,145.8,288.1z"
      />
      <path
        class="st3"
        d="M292.8,247.1c-0.6,0-1.2,0.1-1.8,0.1c-0.1-0.2-0.2-0.3-0.3-0.5c1.1-0.8,2.3-1.6,3.9-2.8
		c-1.5,0.3-2.4,0.6-3.4,0.8c-0.1-0.1-0.1-0.2-0.2-0.3c1.1-0.7,2.1-1.3,3.4-2.1c-0.3-0.2-0.6-0.3-0.9-0.5c-0.6,0-1.1,0-1.7-0.1
		s-1.2-0.1-1.7,0c0.4,2-0.3,2.4-3.9,3.2c-0.2,0.8-0.1,1.6,0.3,2.4c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1
		c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.1,0.4,2.1,0.3,2.9-0.2
		C289.6,249.6,291,248.5,292.8,247.1z"
      />
      <path
        class="st3"
        d="M177.8,255.9c-0.8,0.1-1.5,0.4-2.3,0.6c0.2,0.4,0.4,0.8,0.6,1.2c0,0.1,0.1,0.1,0.1,0.2c2.3-0.4,4.7-0.7,7-1
		c0.6-0.6,0.4-1.2,0.3-1.8C181.6,255.3,179.7,255.5,177.8,255.9z"
      />
      <path
        class="st3"
        d="M351.1,163.1c0.2,0.3,0.4,0.6,0.6,0.9c1.3-3,3-0.5,4.2-1.1c0.9-0.8,1.9-1.7,3.1-2.8c-2.4,0.4-4.3,0.6-6.2,1.2
		C352.2,161.5,351.7,162.5,351.1,163.1z"
      />
      <path
        class="st3"
        d="M165.4,197c11.3,6.3,22.8,12.4,32.8,20.8C189.3,207.7,177.6,202,165.4,197z"
      />
      <path
        class="st3"
        d="M154.5,234.2c0,0.3-0.1,0.6-0.1,1c7.5,0.5,15,1,22.5,1.6C169.7,233.1,162.1,233.5,154.5,234.2z"
      />
      <path
        class="st3"
        d="M309.6,138.5c0.2-0.3,0.5-0.5,0.7-0.8c0-0.3,0-0.6,0-0.9c-0.1-0.3-0.3-0.5-0.5-0.6c-0.3,0.7-0.6,1.4-0.9,2.2
		C309.1,138.5,309.3,138.5,309.6,138.5z"
      />
      <path
        class="st3"
        d="M209.8,253.2c-0.1,0-0.3,0.1-0.4,0.1c0.4,0.4,0.7,0.7,1,1C210.1,254,209.9,253.6,209.8,253.2z"
      />
      <path
        class="st3"
        d="M518.4,196.4c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0,0,0,0.1c0.1,0.5,0.2,0.9,0.4,1.1
		C518.5,196.8,518.4,196.6,518.4,196.4z"
      />
      <path
        class="st3"
        d="M420.9,227.9c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1
		c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.3-0.4-0.6-0.6-0.9
		C428.5,229.8,424.2,229.7,420.9,227.9z"
      />
      <path
        class="st3"
        d="M302,224.7c4.4-1.2,9.8-8.3,10-12.6C308.8,216.1,305.6,220.1,302,224.7z"
      />
      <path
        class="st3"
        d="M516.9,79c-0.9-0.2-1.6-0.4-2.7-0.7c0.6,1.8,1.1,3.3,1.6,4.7c1-0.7,1.9-1.3,3.5-2.4c-0.6-0.2-1.2-0.3-1.8-0.5
		c0.1-0.1,0.3-0.3,0.4-0.4c0.9-0.2,1.9-0.5,2.4-0.6c-0.6-0.8-1.1-1.6-1.7-2.3c-0.3-0.3-1-0.5-1.5-0.4c-0.2,0-0.5,0.7-0.5,1.1
		C516.6,77.9,516.8,78.4,516.9,79z"
      />
      <path
        class="st3"
        d="M291.2,235.3c-0.2,0.2-0.4,0.3-0.5,0.5C290.9,235.7,291.1,235.5,291.2,235.3z"
      />
      <path
        class="st3"
        d="M292,237.2C292.1,237.2,292.1,237.2,292,237.2c0.5-0.1,0.7-0.1,0.9-0.1c-0.1-0.4-0.2-0.8-0.2-1.2
		c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3
		c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.1,0.9,1.4
		c0.8-0.5,1.5-1,2.3-1.6c0.1-0.3-0.1-0.6-0.3-0.9c-0.3,0.1-0.7,0.2-1,0.4c0.3-0.2,0.6-0.4,0.8-0.6c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.4-0.7,0.4-1.3,0.3-2c-0.6,0.3-1.2,0.6-1.7,1
		c0,0.2,0,0.3,0,0.5c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2C292.1,237.1,292.1,237.2,292,237.2z M294.5,237.5
		c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5C294.3,237.6,294.4,237.6,294.5,237.5z"
      />
      <path
        class="st3"
        d="M512.2,191.6C512.1,191.6,512.1,191.6,512.2,191.6c-0.5,0.8-1,1.7-1.5,2.5c0.1,0.1,0.3,0.2,0.5,0.3
		c0.7,0.3,1.3,0.9,1.6,1.5c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c0.4-0.1,0.7-0.1,1.1-0.2
		c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.5-1.2-1-2.4-1.6-3.6c-0.1-0.1-0.2-0.3-0.4-0.4c-0.5,0.3-0.9,0.7-1.6,0.7
		c-0.4,0.9-0.7,1.9-1.6,2.7c0-0.8,0-1.6,0.1-2.4C512.4,191.8,512.3,191.7,512.2,191.6z"
      />
      <path
        class="st3"
        d="M370.9,226.6c-2.5,1.6-4.9,3.2-7.5,4.9C366.7,231.8,370.1,229.5,370.9,226.6z"
      />
      <path
        class="st3"
        d="M443.3,74.8c0,0.2,0,0.5,0,0.6c0.2,0.3,0.3,0.7,0.5,1c4.1-1.7,8.7-2.8,12.9-2.9c0-0.1,0-0.2,0-0.4
		c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3
		c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4
		c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1c-0.6,0.2-1.4,1.4-1.8,2.4C443.4,74.4,443.3,74.6,443.3,74.8z"
      />
      <path
        class="st3"
        d="M375.1,218c-0.4-0.6-1.1-1-1.7-1.4c-0.5,0.6-1.3,1.2-1.5,2c-0.3,0.7-0.1,1.7-0.1,2.7c1.8,0.1,3.5,0.1,5.7,0.2
		C376.6,220.2,375.9,219,375.1,218z"
      />
      <path
        class="st3"
        d="M296.4,239.8c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4,0.2-0.9,0.3-1.3,0.5c0.2,0.3,0.2,0.6,0.2,0.9
		C295.4,240.3,295.9,240,296.4,239.8z"
      />
      <path
        class="st3"
        d="M238.8,240.8c-0.7,0.8-1.3,1.7-2,2.5c0.1,0.1,0.2,0.2,0.4,0.4c0.2,0.1,0.3,0.2,0.5,0.3
		c0.6,0.3,1.3,0.2,1.8-0.1c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.8,0.2-1.6-0.5-2.1c-0.3-0.2-0.5-0.5-0.5-0.7
		C239.2,240.2,239,240.5,238.8,240.8z"
      />
      <path
        class="st3"
        d="M516.7,72.5c-0.1-0.2-0.3-0.4-0.4-0.7c-1,0.7-2,1.4-3.3,2.2C515.3,75.2,515.5,75,516.7,72.5z"
      />
      <path
        class="st3"
        d="M364.4,234.4c0.4,0.7,0.8,1.4,1.2,2.1c0.2,0.3,0.6,0.4,0.9,0.7c0.2-0.1,0.5-0.3,0.7-0.4
		c-0.4-0.8-0.7-1.6-1.2-2.2C365.7,234.2,364.9,234.4,364.4,234.4z"
      />
      <path
        class="st3"
        d="M357.3,247.7c0,0.2,0.1,0.4,0.2,0.5c0.6,1.1,2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.2-0.2,0.4-0.5,0.5-0.8
		C361.9,247.4,359.6,247.4,357.3,247.7z"
      />
      <path
        class="st3"
        d="M261,227.5c-0.2,0.1-0.3,0.2-0.4,0.3l0.1,0.1C260.8,227.8,260.9,227.6,261,227.5z"
      />
      <path
        class="st3"
        d="M502,144.5c-0.3,0.1-0.6,0.2-0.8,0.3c0.7,2.2,1.4,4.3,2.1,6.5c0.3-0.1,0.7-0.2,1-0.3
		C503.5,148.8,502.7,146.7,502,144.5z"
      />
      <path
        class="st3"
        d="M359.5,243.9L359.5,243.9c-0.4,0.3-0.8,0.6-1.1,0.9c-0.3,0.3-0.5,0.5-0.7,0.8c2.2-0.3,4.3-0.3,6.6-0.2
		c-0.1-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5c0.2-0.1,0.4-0.2,0.6-0.3
		C363.7,243.6,361.6,243.6,359.5,243.9z"
      />
      <path
        class="st3"
        d="M508.7,191.5c0.2,0.2,0.3,0.4,0.5,0.6c0.2-0.1,0.4-0.3,0.6-0.4c0-0.7-0.1-1.4-0.1-2.2
		C509.3,190.3,509,190.9,508.7,191.5z"
      />
      <path
        class="st3"
        d="M504.7,80.3c1.5,0,3,0.1,4.9,0.2C506.6,78.2,506.2,78.2,504.7,80.3z"
      />
      <path
        class="st3"
        d="M610.2,56.6c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.4,0.5-0.7,1-1.1,1.4
		c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2c-0.4,0-0.8-0.4-1-0.7
		c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7
		c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6
		c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0c-0.3,0.3-0.6,0.5-0.8,0.8c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2
		c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		c-0.9-0.1-1.6-0.8-2.7-1.3c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.4-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1c0.3,0.1,0.6,0.2,1,0.3
		c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7
		c0.2-0.2,0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1
		c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2
		c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6
		l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1
		c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7
		c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0
		c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3
		c-0.3-0.6-0.6-1-1.7-0.8c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.6-0.6,1.1-0.8,1.6
		c-0.1,0.2,0.1,0.7,0.3,0.8s0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5
		c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5
		c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6
		c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0
		c-0.2,0.3-0.5,0.5-0.7,0.8c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6
		c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6
		c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3
		c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5
		c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2
		c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3
		c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8
		c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6
		c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8
		c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1
		c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4
		c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5c-0.7-0.6-0.7-1.6-0.9-2.6c-1.1,0-2.6,0.8-2.7-1c-0.4,0.4-0.6,0.6-1,0.8
		c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3
		c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2
		c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4c0.2,0.3,0.4,0.6,0.6,0.9c0.5,0.8,1.1,1.5,1.6,2.2c0.8-0.2,0.8-1,1.2-1.4
		c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8
		c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0
		c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.5-0.1-1-0.3-1.5-0.5c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4
		c1.2-0.4,2.4-0.9,2.8-1.9c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1
		c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1
		c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4
		c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4
		c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9
		c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3
		c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4
		c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
		c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1
		c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8
		c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9
		l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0
		c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6
		s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6
		c-0.2,0.5-0.2,1-0.4,1.5c-0.2,0.5-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0
		c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1
		c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2
		c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3
		c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.3-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6
		c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1
		c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1
		c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2
		c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5c-0.8-0.4-1.5-0.7-2.4-1.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0
		c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4
		c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1
		c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1
		c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9
		c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1
		c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9
		c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4
		c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9
		c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2
		c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2
		c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1
		c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3
		c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3
		c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0,0.1,0.1,0.3,0.2,0.5s0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3
		c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2
		c0,0.1,0,0.1-0.1,0.2c0.5,0.2,1.1,0.4,1.6,0.6c0.6,0,1.2,0,1.8,0.1c0.1,0.3,0.2,0.4,0.2,0.6c0.6-0.6,1.5-1.1,2.3-1.2
		c4.6-0.3,11.3,5.5,12,10.8c-1.1-0.4-2-0.6-2.8-1c-1.1-0.7-1.8-0.5-2.1,0.8c-0.4,2.3-0.8,4.6-1.3,7.5c-0.3-1.4-0.5-2.4-0.7-3.4
		c-0.2,0-0.5,0-0.7,0c-0.1,2.3-0.1,4.7-0.2,7c-0.3,0-0.6,0-0.9-0.1c0-1.2,0.1-2.4,0.1-3.7c-0.2,0-0.4-0.1-0.6-0.1
		c-0.5,2.3-1,4.6-1.5,6.9c-0.3,0-0.5-0.1-0.8-0.1c0-0.6-0.1-1.1-0.1-1.7c-0.2,0-0.3-0.1-0.5-0.1c-0.3,0.9-0.6,1.8-0.7,2
		c-1.4,1-2.3,1.7-2.8,2c-1.8,0.6-3.2,1.3-4.7,1.4c-1.4,0.1-2.8-0.5-4.4-0.9c0.1-0.7,0.2-1.6,0.4-3.2c-0.8,0.9-1.2,1.4-1.6,1.9
		c-0.1,0-0.2-0.1-0.3-0.1c0.5-1.6,1-3.2,1.7-5.3c-0.7,0.5-1.1,0.7-1.5,1c-0.2-0.1-0.3-0.1-0.5-0.2c1.2-3,2-6.3,3.6-9
		c1.2-1.9,2.5-3.8,3.8-5.6c-0.2,0-0.5,0.1-0.7,0.1c0.5-0.5,0.7-0.7,1-0.9c0.1-0.1,0.3-0.1,0.5-0.1c0.3-0.4,0.7-0.9,1-1.3
		c-0.1-0.3-0.4-0.6-0.7-0.6c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1,0.1-0.1,0.2-0.2,0.2
		c-2.9,3.5-4.4,8.1-10.2,8.6c-4.6,0.5-9,2.2-13.7,0.9c-0.1,0-0.3,0.1-0.9,0.5c1.7,1.2,3.1,2.3,4.5,3.3c-3.3,5-6.7,10.1-10.1,15.2
		c0.1,0.1,0.1,0.2,0.2,0.2c1-1.2,2.2-2.3,3.1-3.6c3.7-4.8,7.2-9.9,12.5-13.1c2.3-1.4,5-2.1,7.8-2.8c-2.1,4-2.2,8.9-6.6,11.5
		c-2.1,1.3-3.8,3.4-5.9,5.4c1.9,0.1,2.9,0.1,4.2,0.1c-1,1.8-1.9,3.4-2.9,5.3c3.8,0.5,3.9-3.6,6.2-4.4c1.8,2.9,3.5,5.6,5,8.3
		c0.3,0.6,0.1,1.6-0.2,2.3c-1.5,3.1-1.4,4.2,1.2,6.4c1.8,1.5,1.4,3.4,1.5,5.3c0,0.4-1.4,1.1-2.1,1.2c-3,0.4-6,0.6-9,0.8
		c-1.7,0.1-3,0.5-2.5,3c-1.5-0.3-2.7-0.6-3.9-0.7c-0.7-0.1-1.5,0.2-2.2,0.3c0.2,0.7,0.4,1.3,0.7,2c-0.7,0-1.6,0-2.8-0.1
		c0.4,0.9,0.8,1.5,1.3,2.6c-1.4-0.5-2.3-1.1-3.3-1.3c-2.1-0.4-1.2,1.1-1.2,2.3c-1.1-0.5-2.1-1.2-3.1-1.3c-0.5-0.1-1.2,0.9-1.8,1.4
		c0.1,0.3,0.2,0.5,0.3,0.8c-1.1-0.3-2.2-0.6-3.5-0.9c-0.2,0.7-0.4,1.3-0.6,1.9c-0.3-0.1-0.5-0.1-0.8-0.2c0.5-2.5,0.7-5.1,1.7-7.3
		c0.6-1.3,2.5-2.1,3.7-3c0.7,0.7,1.2,1.4,1.5,1.3c4.2-1.4,8.4-2.8,12.6-4.2c0,0,0.1-0.1,0.2-0.8c-3.6,0.9-6.9,1.7-10.7,2.6
		c2.3-2,4.3-3.8,6.4-5.5s4.3-3.2,6.3-5.2c-2.1,1-4.3,1.9-6.5,2.9c0.1-0.8,0.2-1.6,0.3-2.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.5,1-0.9,2.1-1.4,3.1c-0.2-0.1-0.3-0.1-0.5-0.2c0.2-1.4,0.5-2.9,0.7-4.3c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,1.5-1.1,3-1.6,4.5
		c-0.2,0-0.4-0.1-0.5-0.1c0.2-1.3,0.4-2.7,0.6-4c-0.1-0.1-0.3-0.2-0.4-0.2c-1.2,1.6-2.4,3.3-3.8,5.2c-0.2-1.2-0.4-2.3-0.8-4.2
		c-0.6,2.2-0.9,3.7-1.4,5.8c-2.2-8.1-4.3-15.4-7.8-22.4c-2.6-5.1-6.1-9.1-10.4-12.8c-1.1-0.2-2.2-0.8-3.1,0.6
		c-0.2-0.1-0.4-0.1-0.5-0.1c7.3,5.8,12.9,12.9,15.7,22.1c2.6,8.5,1.4,16.9-0.8,25.3c-0.9,3.5-1.8,7-2.3,10.5s0.8,5.3,4.1,6.4
		c2.1,0.7,4.4,1.1,7,1.7c-3.4,1.8-6.8,3.5-10.1,5.2c-0.1-0.2-0.3-0.4-0.4-0.7c1.2-1,2.4-2,3.6-3c-0.1-0.1-0.2-0.2-0.3-0.3
		c-7,2.8-14.1,5.6-21.1,8.3c-0.2-0.3-0.3-0.6-0.5-0.9c5-3.6,9.3-7.8,12.5-13.1c3.7-6.2,4.5-13,3.4-19.9c-1.1-7-2.5-14-4.8-20.7
		c-2-5.8-4.8-11.1-8.7-15.6l0,0c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1
		c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.4s0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3
		c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.1,0.1-0.1,0.3-0.2,0.4c0.8,0.4,1.6,0.9,2.3,1.5
		c1.9,1.4,3.9,2.7,6,3.8c4.7,2.5,7.2,6.7,8.7,11.6c0.8,2.7,1.2,5.4,1.8,8.5c-1.5-0.2-2.8-0.5-4.3-0.7c0.2,0.5,0.4,0.9,0.5,1.1
		c-2.7,0.8-5.5,1.7-8.8,2.7c1.4,0.2,2.2,0.4,3,0.5c0.1,0.2,0.1,0.3,0.2,0.5c-1,0.4-2,0.9-3.1,1.3c0.7,1.7,0.7,3.2-1.5,4.1
		c0.6,0.1,1.2,0.1,1.8,0.2c0.1,0.2,0.1,0.3,0.2,0.5c-1.4,0.6-2.9,1.2-4.3,1.8c0.2,0.3,0.5,0.6,0.8,1.1c-7.3,1.4-14.3,1.4-21.5,0.1
		c0-0.6,0-1.1,0.1-2c-0.7,0.4-1.1,0.8-1.6,0.9c-0.5,0.2-1,0.2-1.8,0.4c0.1-0.9,0.1-1.5,0.2-1.9c-1,0.4-2,0.8-3,1.1
		c0-1.1,0.1-2.2,0.1-3.4c-0.7,0.8-1.5,1.7-2.3,2.5c-0.2-0.1-0.3-0.1-0.5-0.2c0.2-1.1,0.4-2.2,0.5-3.2c-0.1-0.1-0.2-0.2-0.4-0.2
		c-0.9,1.5-1.8,3-2.6,4.5c-0.2-0.1-0.3-0.2-0.5-0.2c0.5-1.4,1-2.9,1.4-4.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5,0.6-0.9,1.2-1.4,1.8
		c-0.5,0.7-1,1.3-1.4,2c-0.2-0.1-0.4-0.2-0.6-0.3c0.6-2,1.2-3.9,1.8-5.9c-0.1-0.1-0.2-0.1-0.3-0.2c-1.2,1.8-2.4,3.6-3.6,5.4
		c-0.3-0.2-0.5-0.3-0.8-0.5c0.8-2,1.6-4,2.4-6c-0.1-0.1-0.3-0.2-0.4-0.3c-1.2,1.8-2.4,3.5-3.6,5.3c-0.2-0.1-0.4-0.2-0.6-0.3
		c1-2.2,2-4.4,3-6.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.9-1.7,1.8-2.5,2.7c-0.1,0-0.2-0.1-0.2-0.1c0.6-1.2,1.1-2.5,1.7-3.7
		c-0.2-0.1-0.4-0.2-0.5-0.4c-1.5,2.3-2.9,4.6-4.4,6.8c-0.2-0.1-0.4-0.3-0.7-0.4c2-3.7,4.1-7.3,6.1-11c0.2,0.1,0.4,0.2,0.6,0.3
		c-0.1,0.6-0.2,1.2-0.3,1.8c0.2,0.2,0.3,0.4,0.5,0.6c3.2-4.9,7.7-7.6,12.7-9.6c0-0.1-0.1-0.1-0.1-0.2c-0.3-0.4-0.6-0.8-1.1-1.1
		c-0.1,0-0.2,0-0.3,0c-2.6,1.2-5.5,3.1-8.6,5.7c0.3-1.2,1.2-2.5,2.6-3.8c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.5-0.4l0,0
		c0.2-0.1,0.4-0.2,0.7-0.4c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.4-0.5,0.8-0.7,1.1c0.9-0.8,1.9-1.6,3.1-2.3c-0.2-0.1-0.4-0.2-0.6-0.4
		c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2
		c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.1-0.6,0.3-0.9c-0.5,0.2-1,0.5-1.5,0.7c-0.2-0.2-0.3-0.5-0.5-0.7c0.7-0.7,1.3-1.3,2-2l0,0
		c-0.4,0-1,0.4-1.4,0.7c-0.4,0.3-0.8,0.5-1.1,0.4c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1-0.1-0.2-0.2-0.4-0.3c0.2-0.2,0.4-0.5,0.6-0.7
		c-0.3-0.3-0.7-0.6-1.1-0.7c-0.3,0.3-0.6,0.6-1,0.8c-0.1-0.1-0.3-0.2-0.4-0.3c0.2-0.3,0.4-0.6,0.6-0.8c-0.4-0.1-0.8-0.2-1.2-0.3l0,0
		c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1c-0.1-0.2-0.2-0.5-0.2-0.8c0.1-1.4-0.8-2.4-2-3.2
		c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5
		c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3
		c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.5,1-0.2,2,0.7,3c-1.5,0-2.7,0.3-3.5,1.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6
		l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.5,0.5,0.8
		c6.1-5,16.1-7.9,24.8-4.5c-3.1,3.4-6.7,6.3-8.9,10c-2.3,3.8-3.3,8.4-5,12.9c-3.4-0.7-6.7-1.3-10.3-2c0.2-0.8,0.3-1.3,0.5-2.2
		c-0.9,0.5-1.7,0.9-2.5,1.3c-0.1-0.1-0.3-0.3-0.4-0.4c0.9-1.1,1.7-2.2,2.6-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-1.3,0.9-2.5,1.8-3.8,2.8
		c-0.1-0.1-0.2-0.3-0.4-0.4c1.3-1.3,2.6-2.6,3.8-3.9c-0.1-0.1-0.2-0.3-0.3-0.4c-1.4,1-2.8,1.9-4.3,2.9c-0.1-0.1-0.2-0.2-0.4-0.3
		c1.1-1.4,2.1-2.8,3.2-4.2c-0.1-0.1-0.2-0.3-0.3-0.4c-1,0.6-2,1.3-3,1.9c-0.1-0.1-0.2-0.2-0.4-0.2c1.8-2.4,3.7-4.7,5.5-7.1
		c-0.1-0.1-0.2-0.2-0.2-0.3c-1.7,1.4-3.5,2.9-5.3,4.4c0.9-2,2.4-4,4.4-5.7c-0.7-0.2-1.6,0.1-2.9,0.7c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.1-0.3-0.2-0.4c-1,0.6-2,1.2-3,1.7c-2.1,1.2-4.3,2.4-6.4,3.7c-0.7,0.4-1.1,1.2-1.3,2.1
		c2.7-1.6,5.5-3.2,8.2-4.8c0.1,0.2,0.2,0.4,0.3,0.5c-1.2,0.7-2.4,1.4-3.6,2.2c-1.2,0.9-2.2,2-3.4,2.9c-0.2,0.2-0.5,0.3-0.8,0.5
		c0.2,0.1,0.4,0.3,0.7,0.3c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8
		c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4s0-0.2-0.1-0.3
		c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.4-0.1-0.8-0.5-1c-1.8,0.7-3.7,1.4-5.4,2.4c-1.2,0.7-1.9,0.8-3.2,0c-2.4-1.6-4.8-2-7.6-0.8
		c-0.3,0.4-0.6,0.8-1,1.2c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5
		c0.3-0.4,0.5-0.7,0.7-1c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-0.4-0.1-0.6-0.3-0.9-0.5
		c-4.7,2.9-8.3,6.8-10.4,12.5c-1.3,3.6-3.8,6.8-5.9,10c-0.3,0.5-1.7,0.4-3,0.6c1.9-3,3.4-5.5,4.9-8c1.4-2.2,2.7-4.5,4-6.8
		c-1.9-0.8-2.7-2.4-4.8-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6c0.3,0.7,0.9,0.5,1.5,0.3l0,0
		c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.2-0.3-0.5-0.4-0.7
		c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.5-0.4-1-0.4-1.6
		c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5c-0.9-0.1-1.6-0.8-2.7-1.3
		c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3c0.5,0.6,0.7,0.9,1.1,1.4
		c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7c0.1,0.1,0.2,0.3,0.4,0.4
		c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1c0.2-0.2,0.5-0.3,0.9-0.5
		c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.4-1.1c-0.3,0.3-0.5,0.4-0.8,0.8
		c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4c-0.1-0.3,0.2-0.7,0.1-1
		c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1c0.3,0.1,0.6,0.2,1,0.3
		c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7
		s0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1
		c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2
		c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6
		l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1
		c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7
		c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4s0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5
		c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8
		c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.6-0.6,1.1-0.8,1.6c-0.1,0.2,0.1,0.7,0.3,0.8
		c0.2,0.1,0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3
		c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5
		c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2
		c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3
		c0,0.1,0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5
		c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8
		c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3
		c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5
		c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1
		c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1
		c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1
		c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9
		c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5
		c-0.7-0.6-0.7-1.6-0.9-2.6c-1.1,0-2.6,0.8-2.7-1c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3
		l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4
		c0.2,0.3,0.4,0.6,0.6,0.9c0.5,0.8,1.1,1.5,1.6,2.2c0.8-0.2,0.8-1,1.2-1.4c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1
		c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8
		c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3
		c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.5-0.1-1-0.3-1.5-0.5c-0.3-0.1-0.6-0.2-0.8-0.2
		c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4c1.2-0.4,2.4-0.9,2.8-1.9c0.2-0.5,0.2-1.2,0.1-1.6
		c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2
		c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1
		c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8
		c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1
		c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1
		c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2
		c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0
		c0-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2
		c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4
		c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5
		c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1
		c-0.1-0.1-0.2-0.1-0.3-0.2s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6
		c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5
		c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6
		c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6
		c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6c-0.2,0.5-0.2,1-0.4,1.5s-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2
		c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1
		c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1
		c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1
		c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9
		c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8c-0.1,0-0.2-0.1-0.3-0.1s-0.2-0.1-0.3-0.1
		c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7
		c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5
		c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1
		c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2
		c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0
		c-0.1-0.1-0.1-0.2-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4
		c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1
		c-0.4-0.1-0.7-0.3-0.9-0.4s-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4
		c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6
		c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9
		c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4
		c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5
		c-0.8-0.4-1.5-0.7-2.4-1.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1
		c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2
		c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1
		c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0
		c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0,0.1,0.1,0.3,0.2,0.5
		c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3
		c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8
		c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3
		c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9c0.3,0.2,0.7,0.4,1,0.6c-0.5,0.5-1,1.1-1.6,1.7c-0.5,0.1-1.1,0.1-2.2,0.2
		c0.5-0.5,0.7-0.7,1-0.9c0.3-0.1,0.7-0.1,0.9-0.3c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2
		c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3s0-0.2,0-0.4s0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1
		c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.3-1-0.4-1.5c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9
		c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3
		c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4
		c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1c-0.6,0.2-1.4,1.4-1.8,2.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.2,0,0.5,0,0.6
		c0.7,1.4,1.1,2.8,2.4,3.9c0.5,0.4,0.7,1,1,1.5c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4
		c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8
		c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9c-1.3-0.3-2.6-0.5-2.7-2c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5
		s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2
		c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1
		c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7
		c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3
		c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1
		c-0.1-0.4-0.4-0.8-1-1.1c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3
		c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6
		c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8
		c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4
		c-0.7,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7
		c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.6
		c-0.1,0.1-0.1,0.1-0.1,0.2c-0.5,0.6-0.3,1.2,0.4,2c-0.3,0.9-0.7,1.7-0.6,2.5c0,0.1,0.1,0.2,0.1,0.3s0.1,0.2,0.1,0.3
		s0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4
		c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.2,0-0.3,0-0.5,0V164c0-0.1,0-0.1,0-0.2
		c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.2,0.2-0.2,0.3-0.2,0.4c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0
		c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5
		c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9c-0.3,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c0.5,0.7,0.4,1.5,0.5,2.3c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7c-0.9-0.3-1.5-0.3-1.9-0.1c-0.3,0.2-0.6,0.5-0.9,1.1
		c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3c-0.3,0.2-0.5,0.4-0.5,0.7c-0.1,0.5-0.3,0.6-0.8,0.9
		c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0c0,0,0,0,0.1,0.1h-0.1c0,0,0,0-0.1,0
		c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1c-0.1,0-0.2-0.1-0.1-0.4
		l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1-0.1-0.2-0.2-0.2-0.3
		c-0.2-0.5-0.6-0.8-1-1c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8c0.1,0.5,0.2,0.8,0.3,1.3c0.5-0.1,1-0.1,1.8-0.2
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6c-0.4-0.5-0.7-1-1.1-1.6
		c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2
		c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0
		c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1
		c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7
		c1.1,0.2,1.4-0.7,2.2-1.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5
		c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.8-0.9-2.1-1.2-3.3-1.4l0,0
		c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1c-0.1-0.2-0.2-0.5-0.2-0.8c0.1-1.4-0.8-2.4-2-3.2
		c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.8,2.1c-0.2,0.4-0.3,0.8-0.4,1.2c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5
		c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3
		c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.5,1-0.2,2,0.7,3c-1.5,0-2.7,0.3-3.5,1.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6
		l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1c0.2,0.5,0.6,1,1.3,1.3
		c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9
		c-0.3-0.6-0.8-1.1-1-1.7c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.5-0.5-0.8
		c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1
		c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1
		c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2
		c-0.4,0.8-1,1.3-1.7,1.8c-0.8,0.5-1.6,1.2-2,1.9s-0.5,1.6-0.6,2.3c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3
		c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1
		c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1c-0.2-0.1-0.3-0.4-0.4-0.6
		c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7-0.2-1.4-0.1-2.5,0.3
		c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1
		c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v6.7c1.1,0.6,2.2,1.1,3.2,1.7
		c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8c0.9,0.2,2.2-0.4,3,0.7
		c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2c-0.5,0-1.1,0-1.6,0
		c-0.6,0-1.3,0-1.9,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1
		c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8c0.6,0.4,1.2,0.6,1.9,0.4
		c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.2-0.4-0.6-0.7-1-1c-0.8-0.2-1.5-0.5-2-0.9v2.5v2.1v0.7v3v82.1c0.5,0.3,1.1,0.6,2,0.2c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8
		c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0
		c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6
		c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3
		c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3s0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3
		c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5
		c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2
		c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7
		c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1
		c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8c0.2,0.7,0.6,1.6,0.4,2.5c2.4-4.5,6.7-7,11.5-8.8c-5.3,2.7-9.6,6.6-12.8,11.7
		c0.3-1,0.7-1.9,1.1-2.7c-2.5,0.2-3.5,0.7-3.8,2.1c-0.2,0.8,0.1,1.4,0.8,1.9c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4
		c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2
		c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0.4,0.1,0.7,0.2,1.1,0.3
		c0.7-0.3,1.5-0.6,2.2-0.5c3,0.8,4.1,3.4,4.8,6v-0.1c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.3-0.1,0.6-0.2,0.8-0.3c-0.8-1.4-1.6-2.7-2.4-4.1
		c0.1-0.1,0.1-0.3,0.2-0.4c1.2,1.2,2.5,2.4,3.8,3.6c0.5-0.4,0.8-1,0.9-1.5c-1.9-1.5-3.9-2.9-5.9-4.5c0.2-0.9,0.9-1.7,2.4-1.2
		c2.4,0.8,4.6,1.9,6.5,3.6c0.1-0.1,0.2-0.2,0.4-0.3c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7l0,0c-1.5-1.4-2.8-2.8-4.4-3.8
		c-1.7-1.1-3.7-1.8-5.8-2.8c2.3-4.1,5.8-6.8,9.9-9c0.4-0.2,0.7-0.3,1.1-0.5c6.4-2.9,6.9-2.7,11.2,3c0.1,0,0.1,0,0.2,0
		c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9
		c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2
		c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.5,0.5,0.9,0.7c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.9,0,1.3,0c0.2,0,0.3,0,0.4,0.1
		c0.4-0.3,0.8-0.7,1.2-1.2c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4
		c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c0.8-0.2,1.5-0.4,2.4-0.6
		c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.1,0,0.2,0,0.2
		c2.1,0.1,4.2,0.3,6.2,0.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8
		c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2
		c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2
		c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1c0.3-0.3,0.7-0.5,1.1-0.8
		c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1
		c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9
		c-0.5-0.2-1-0.3-1.4-0.6c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3
		c0.1-0.1,0.1-0.4-0.1-0.5c-0.3-0.3-0.6-0.5-0.9-0.7c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-1-0.2-1.6,0.3-2.4,0.9c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0
		c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1
		s1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1
		c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2s0.4,0.2,0.7,0.3
		c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2
		c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4
		c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5c-0.2,0.8-0.1,1.5,0.8,1.8
		c1,0.4,1.9-0.1,2.6-0.8c1.9,0.9,3.2,0.1,4.4-0.9c-6.5-8.8-12.9-17.7-19.2-26.6c-1.4-1.9-2.2-4.2-3.2-6.4c-0.2-0.4,0.1-1.1,0.2-1.6
		c0.5,0.2,1.3,0.3,1.6,0.7c0.6,0.9,1.1,2,1.4,3c2.7,8.3,8.6,14.6,13.5,21.5c2.1,3,4.3,5.9,6.5,8.8c0.2-0.1,0.4-0.3,0.6-0.4
		c0.9,0.7,1.6,1.5,1,2.6c0.1,0.2,0.2,0.3,0.4,0.5c0,0,0,0,0.1,0c0.2,0,0.3,0.1,0.5,0.2c0.2,0.3,0.3,0.7,0.4,1.1
		c0.4,0.6,0.9,1.2,1.3,1.8c0-0.3-0.1-0.5-0.2-0.8c-0.4-1.1-0.9-2.2-1-3.4c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2
		c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5
		c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8
		c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7c1-0.8,1.3-2,0.8-3c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2
		c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2
		c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1c-0.3-0.3-0.6-0.5-1-0.6c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3
		l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.3-0.3-0.5-0.4
		c-2.1,0.5-4.3,1.2-6.4,1.7c-6.9,1.7-13.1-0.1-18.6-4.3c-0.6-0.4-0.8-1.4-1.4-2.4c-0.2,0-1,0.1-2.1,0.2c0.4-0.8,0.7-1.2,1-1.6
		c-0.6-0.3-1.3-0.6-2.3-1c0.9-0.8,1.4-1.2,2.1-1.8c-1-0.1-1.8-0.2-3.2-0.4c1.1-0.9,1.7-1.4,2.6-2.1c-0.9-0.1-1.5-0.2-2.8-0.4
		c1.6-0.9,2.7-1.6,3.8-2.2c0-0.1-0.1-0.2-0.1-0.3c-0.7,0.1-1.4,0.2-2.1,0.2c-0.1-0.1-0.1-0.3-0.2-0.4c0.8-0.4,1.6-0.8,2.3-1.2
		c0-0.1-0.1-0.3-0.1-0.4c-1,0.1-2.1,0.1-3.1,0.2c-0.1-0.2-0.1-0.3-0.2-0.5c1.1-0.5,2.1-1,3.2-1.6c0-0.2-0.1-0.3-0.1-0.5
		c-1,0.2-2,0.3-3,0.5c-0.1-0.2-0.1-0.4-0.2-0.6c1.3-0.6,2.6-1.1,4.4-2c-1.6-0.6-2.8-1-4.3-1.5c1.2-0.4,2.2-0.8,3.9-1.3
		c-1.4-0.2-2.1-0.3-3.4-0.5c1.1-0.6,1.8-0.9,2.8-1.3c-0.8-0.3-1.2-0.4-2.3-0.8c1.4-0.5,2.4-0.9,3.3-1.2c0-0.2,0-0.3,0-0.5
		c-0.8,0-1.7,0.1-2.5,0.1c-0.1-0.2-0.1-0.3-0.2-0.5c1.2-0.5,2.3-1,3.6-1.6c-0.5-0.2-0.8-0.3-1.4-0.6c0.9-0.4,1.7-0.7,2.7-1.1
		c-0.5-0.3-0.9-0.5-1.5-0.9c1-0.4,1.8-0.7,2.7-1.1c0-0.1,0-0.3,0-0.4c-0.8,0-1.5,0-2.8,0.1c1.9-1.1,3.4-1.9,4.8-2.8
		c0-0.1-0.1-0.3-0.1-0.4c-0.7,0-1.5,0-2.7-0.1c2.4-1.3,4.3-2.8,6.4-3.4c2.4-0.6,5.1-0.3,7.6-0.6c3.9-0.4,7.8-0.8,11.4-1.2
		c0.6,3.1,0.7,6.1,1.8,8.5c2.2,4.6,5,8.8,7.6,13.2c1.7,2.9,3.6,5.7,5.4,8.5c0.4,0.6,0.8,1.4,1.4,1.6c3.1,0.9,4.6,3.5,6.4,5.9
		c1.8,2.4,3.6,4.8,5.5,7.3c0.3-0.2,0.6-0.5,0.9-0.7c-3-3.9-6-7.9-9.4-12.4c4,0.1,7.3,0.2,10.6,0.3c0-0.3,0.1-0.7,0.1-1
		c-2.1-0.4-4.1-0.9-6.2-1c-2.1-0.1-4.1,0.2-6.2,0.2c-0.7,0-1.7-0.3-2-0.8c-2.3-3.2-4.4-6.4-6.6-9.9c7.4-1.5,14.7-2.8,22.1-1
		c3,0.7,6,1.5,9,2.3c2.1,0.5,2.6,1.8,2.2,3.8c-0.2,0.9,0.2,1.9,0.5,2.8c0.4,1.3,0.9,2.5,1.6,3.7c0.8,1.5,1.7,3,2.8,4.3l0,0
		c0.1-0.7,0.2-1.3,0.4-2c-0.7-1.1-1.3-2.2-2-3.4c-0.1-0.2,0-0.5-0.2-0.7c-1.9-2.5-1.5-5.6-1.8-8.4c-0.1-1-0.8-1.9-1-3
		c4,2.5,5.3,6.7,7,10.8c-0.8-0.7-1.7-1.4-2.7-2.2c-0.1,0.5-0.2,0.7-0.2,0.8c2.2,2.5,4.2,5.1,5.6,8.2c0.3,0.2,0.6,0.5,1,0.7
		c0.3-0.6,0.7-1.1,1.1-1.7c-0.1-0.7,0-1.5,0.2-2.3c0.1-0.3,0.1-0.7,0.1-1.1c-0.2-0.2-0.2-0.5,0.1-0.8c0-0.2,0.1-0.3,0.1-0.5
		c0.4-0.8,1.2-1.4,1.8-2c0.5,0.5,1.1,1,1.6,1.6c0.3,0.1,0.7,0,1.1,0c0.5,0.9,1,1.8,1.2,2.7c-0.3-1.3-0.5-2.7-0.9-4
		c-0.3-1.2-0.6-2.3-1.1-3.4c-0.4-0.9-1.1-1.6-1.7-2.4c-1,0.7-2,1.4-2.8,2.3c-0.5,0.6-0.6,1.5-0.9,2.3c-0.2-0.1-0.5-0.2-0.7-0.4
		c0.9-1.6,1.6-3.5,2.8-4.8c1.9-2,3.6-1.6,4.5,1c1.3,3.5,2.4,7,3.5,10.5c0-0.1,0.1-0.2,0.1-0.2c0.3-0.1,1-0.2,1.1-0.4l0,0
		c-0.1-0.4-0.2-0.8-0.3-1.2c-0.4,0.3-0.7,0.6-0.9,0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-5.9c-0.1-0.5-0.3-1-0.4-1.6
		c0.2-0.1,0.4-0.2,0.7-0.2c0.2,0.6,0.4,1.2,0.6,1.8c0.7,0.1,1.5,0.2,2.3,0.2l0,0l0,0h-0.1c0.4,0.1,0.6,0.2,0.8,0.4c0,0,0,0,0-0.1
		c-0.6-2.2-0.9-4.5-1.4-6.8c-0.7-2.7-0.3-3.3,2.3-3.6c4.1-0.4,7.9,0.5,11.7,1.9c1.6,0.6,2.3,1.6,2.4,3.1c0.1,3.7,0.5,7.4,0.1,11
		c-0.1,0.7-0.1,1.4-0.2,2c0.4-0.8,0.4-1,1-1.1c0.1-4.2,0.2-8.3,0.4-12.2c3.8,1,7.8,2.1,11.8,3.1c0.1-0.1,0.1-0.1,0.2-0.2
		c0.8,0.3,1.1-0.1,1.4-0.6c0.6,0.3,0.8,0.7,0.8,1.2c0.6,0.1,1.2,0.1,1.8,0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.7-0.5,1.6-0.9,2.3-1.3
		c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7
		c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3
		c0.5-0.4,0.9-0.6,1.2-0.8c1.3-2.1,2.9-4,4.8-5.6c2.6-2.3,5.1-4.8,7.7-7.2c1.3-1.2,2.9-2.2,4.3-3.3c0.2,0.1,0.4,0.3,0.6,0.4
		c-0.8,2.5-1.6,4.9-2.4,7.4c0.4-0.3,0.8-0.3,1.2-0.2c0.2-0.3,0.4-0.6,0.6-0.9c2.3-4,4.3-8.2,6.9-12c1.4-2,3.9-3.1,6-4.6
		c0.1,0.2,0.3,0.3,0.4,0.5c0.2-0.9,0.4-1.9,0.7-2.9c0.6-0.6,1.4-1.5,2.2-2.4c-0.6-0.2-1-0.4-1.7-0.7c2.5-2,4.9-3.9,7.4-5.9
		c-0.6-0.2-1-0.4-1.5-0.6c0.3-2.2,2.7-3.7,2-7c-1.6,2.2-2.9,4-4.1,5.6c-2.2,2.8-3.5,2.9-5.9,0.3c-1.6-1.8-3.1-3.8-4.7-5.7
		c-1.2-1.5-2.3-2.9,0.4-4.4c-0.7-0.3-1.1-0.5-1.5-0.7c0.3-0.6,0.6-1.1,0.9-1.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.9,0.7-1.7,1.4-2.6,2.1
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-0.6,0.8-1.3,1.2-1.9c-2.2,0.4-4.3,2.5-4.6,4.7c0.3,0.3,0.5,0.6,0.8,0.9c0.1-0.5,0.2-1.1,0.4-1.6
		c0.2-0.4,0.5-0.7,1.3-0.9c-0.3,0.8-0.5,1.6-0.7,2.1c2.2,2.1,4.2,4.1,6.2,6.1l0,0l0,0l0,0c1.6,1.9,3.1,3.9,4.7,5.8
		c-0.2,0.1-0.3,0.3-0.5,0.4c-1.5-2-3.7-3.5-4.2-6.2l0,0l0,0c-1.2,0.8-0.5,1.6,0.1,2.4c1.3,1.7,2.5,3.5,3.8,5.2
		c-0.2,0.2-0.5,0.3-0.7,0.5c-1.2-1.6-2.4-3.2-3.6-4.8c-0.2,0.1-0.4,0.2-0.5,0.3c1.1,1.7,2.1,3.5,3.2,5.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.5-0.4-1-0.9-1.8-1.4c-0.6,4.2-2.9,6.9-6.4,9.2c0,0.1,0.1,0.5,0.1,1c0,0-0.1,0.1-0.5,0.3c-0.7-0.6-1.5-1.3-2.4-2.1
		c-0.2,0.2-0.3,0.5-0.5,0.8c-1.3-1.3-2.6-2.6-4.2-4.2c0.4,1,0.6,1.6,1,2.6c-7.1-5.2-13.9-10.2-20.8-15.2c0.1-0.2,0.2-0.4,0.3-0.7
		c0.6-0.2,1.2-0.3,2.2-0.6c-1.9-5.5,1-10.5,1.9-15.8c-0.5,0.7-1.1,1.5-1.6,2.2c-0.2,0-0.4-0.1-0.6-0.1c0.3-1.4,0.6-2.7,1-4.1
		c-0.1,0-0.3-0.1-0.4-0.1c-0.6,1.3-1.2,2.6-1.8,3.9c-0.3-0.1-0.5-0.2-0.8-0.3c0.9-2.4,1.9-4.7,2.7-7.1c1-3.1,3.8-3.2,6.8-4
		c-1.1-0.3-1.6-0.4-2.1-0.6c0-0.2-0.1-0.3-0.1-0.5c1.6-0.5,3.2-1,4.8-1.4c1.7-0.4,3.4-0.7,5-1.1c0-0.2-0.1-0.5-0.1-0.7
		c-1.2,0.1-2.4,0.1-4,0.2c5.6-2.9,11.3-2.5,17-1.9c0-0.2,0-0.5,0-0.7c-0.4-0.2-0.7-0.3-1.3-0.6c2.1,0.1,4,0.1,5.8,0.2
		c0-0.1,0-0.2,0-0.3c-1.4-0.3-2.8-0.7-4.2-1c0-0.1,0-0.2,0-0.3c1.2,0,2.3,0.2,3.5,0.1c1.3-0.2,2.7,1.3,4.2-0.8
		c0.6-0.8,3.7,0.1,5.7,0.4c0.8,0.1,1.6,0.8,2.4,1c3.2,0.7,5.1,2.8,6.4,5.7c0.4,0.8,1.5,1.3,2.4,1.6c3.2,1.3,6.7,2.1,9.8,3.8
		c7.9,4.3,11,11.3,10.2,20.1c-0.1,0.6-0.8,1.2-1.3,1.8c-0.2,0.2-0.6,0.2-0.9,0.2c-10.7,1.7-15.7,9.2-18.6,18.6
		c-0.9,2.9-1.4,5.9-2.2,9.2c-1.2-2.4-2.3-4.5-3.4-6.6c-0.2,0.1-0.4,0.2-0.5,0.3c0.6,1.8,1.2,3.7,1.7,5.5c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.9-1.1-1.8-2.2-2.6-3.3c-0.1,0.1-0.3,0.2-0.4,0.2c0.8,1.6,1.7,3.3,2.5,4.9c-0.2,0.1-0.3,0.2-0.5,0.2c-0.4-0.6-0.9-1.3-1.3-1.9
		c-0.1,0-0.3,0.1-0.4,0.1c0.2,1.2,0.5,2.4,0.9,4.2c-0.8-1.1-1.2-1.6-1.4-1.8c-0.3,3.9-0.6,8-1,12.1c-0.2,0-0.3,0-0.5,0.1
		c-0.3-0.6-0.7-1.3-1.2-2.4c-0.1,1.9-0.1,3.3-0.2,5.1c-0.5-0.8-0.8-1.4-1.2-2c-0.1,0-0.3,0-0.4,0c0,1,0,2.1,0.1,2.8
		c-1.6,1.1-3.1,2.2-4.7,3.3c-0.2-0.9-0.5-1.8-0.7-3c-0.6,1.3-1.1,2.6-1.7,3.8l0,0c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9
		c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4c0.2,0,0.4-0.1,0.5-0.1c0.8-0.4,1.5-0.8,2.2-1.2c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1,0-0.2,0-0.3c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c0.6,0.2,1.1-0.1,1.5-0.4
		c0.7-0.7,1.3-1.4,1.9-2.2c0.1-0.2,0.1-0.5,0.2-0.7c0.3-0.2,0.5-0.4,0.8-0.6c1.7-2.7,3-5.8,4-9.2c0.2-0.9,0.6-1.7,1.1-3.3
		c0.6,1.7,1,2.7,1.3,3.7c0.2,0,0.3,0,0.5-0.1c-0.1-1.5-0.3-2.9-0.4-4.4c0.1,0,0.2-0.1,0.3-0.1c0.3,0.9,0.7,1.9,1,2.8
		c0.1,0,0.2,0,0.3,0c-0.2-1.8-0.3-3.5-0.5-5.3c0.1,0,0.3-0.1,0.4-0.1c0.5,1.3,0.9,2.6,1.4,4c0.9-4.7-1.6-9.5,0.8-14.6
		c0.3,1.9,0.5,3.3,0.7,4.8c0.2,0,0.4,0,0.6,0c0-1,0-2.1,0.1-3.1c0.5-3.9,1.9-7.5,4.5-10.4c1.1-1.2,3.2-1.3,5.2-2.1
		c-1-0.2-1.9-0.4-2.8-0.7c2.3-0.4,4.5-0.8,7.1-1.3c-0.6-0.6-1.1-1-1.5-1.3c0-0.2,0.1-0.3,0.1-0.5c1.6,0.2,3.1,0.4,5.1,0.7
		c-0.7-0.6-1.1-1-1.4-1.3c3.3-1.2,4.3-3.9,2.7-7.1c0.5-0.2,1-0.4,2.2-0.8c-0.9-0.5-1.6-0.8-2.2-1.1c0.1-0.2,0.3-0.4,0.4-0.5
		c0.5,0,1-0.1,2-0.1c-1.2-0.8-2.1-1.3-3.2-2c0.7-0.5,1.1-0.7,1.6-1.1c-0.8-0.5-1.4-0.9-2.2-1.5c0.4-0.3,0.6-0.5,0.6-0.5
		c-2.3-2.7-4.6-5.6-7.1-8.2c-3.7-3.9-8.7-5.6-13.4-7.7c-1-0.5-1.7-1.5-2.6-2.3c-1.2-1-2.3-2.4-3.6-2.8c-5-1.5-10-3.3-15.1-3.7
		c-3.9-0.3-8,1.4-12.1,2.3c-2,0.4-3.9,1-5.9,1.5c-0.1-0.2-0.1-0.4-0.2-0.6c0.4-0.2,0.8-0.5,1.3-0.7c6.8-2.4,13.8-3.8,21.1-4.2
		c0.9,0,1.9,0.2,2.8,0.3c3.1,0.6,6.3,0.9,9.3,2c2.9,1,5.6,2.8,8.1,4.1c-0.1-0.2-0.4-0.7-1.1-1.8c2.5,1.1,4.4,2,6.3,2.8
		c-0.2,0.5-0.3,0.9-0.5,1.3c15.1,3.6,25.6,21.4,19.4,31.9c-0.8-0.2-1.5-0.4-2.3-0.5c0.2,0.8,0.4,1.6,0.7,2.4
		c1.9,5.1,2.8,10.4,0,15.2c-5.5,9.3-12.7,17.2-23.4,20.6l0,0c0.2,0.3,0.4,0.6,0.7,1c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6
		c0.6-1.2,1.3-2,2.8-1.9c0.7-0.4,1.4-0.7,2.1-0.9c0.1-0.4,0.4-0.7,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7
		c0.3-0.3,0.6-0.7,1-0.9c0.1,0,0.2,0,0.3,0v1.6h0.1c0.9-0.7,1.7-1.6,2.5-2.3c1.6-1.3,3.5-1.4,5.3-1.3l0,0c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6l0,0c-2,0.2-3.9,0.4-5.8,0.6c-0.1-0.2-0.2-0.4-0.3-0.6c0.6-0.4,1.3-1.3,1.9-1.3
		c4.6-0.1,9.4-2.5,13.8,1.5c-1.1,3.5-2.3,4.2-5.8,3.1c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6
		c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.8-0.4
		c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8c0.1,0,0.1,0.3,0.1,0.4v0.1
		c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.6,0.1,0.9,0.1
		c0.2,0,0.3-0.1,0.5-0.1c0.7-0.9,1.5-1.7,2.2-2.6c-0.3-0.1-0.6-0.3-1-0.5c0.5-0.5,0.9-1,1.4-1.5c-0.1-0.2-0.3-0.3-0.4-0.5
		c-1.5,1.2-3,2.5-4.5,3.7c-0.2-0.2-0.3-0.3-0.5-0.5c1.2-1.2,2.4-2.6,3.7-3.7c1.2-1,1.9-1.9,0.9-3.5c-0.3-0.5-0.3-1.8,0-2
		c0.6-0.4,1.8-0.6,2.3-0.3c1.8,1.3,3.4,2.8,4.9,4.4c0.3,0.4,0.3,1.5,0,2c-1.1,1.7-2.4,3.2-3.7,4.8c0.2,0,0.3,0,0.3,0.1
		c0.1,0.1,0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7c0,0.1,0.1,0.2,0.1,0.3c0.5-0.6,0.9-1.1,1.3-1.7c0.2,0.8,0.5,1.6,0.7,2.4
		c0.3,0.2,0.6,0.3,0.9,0.2s0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3c0.2-0.3,0.4-0.3,0.7-0.4c-0.1-2.7,0.4-5.4,1.6-8.1
		c-0.3-0.1-0.6-0.1-1-0.2c0.5-0.2,0.8-0.5,1-0.8c0.3-0.3,0.5-0.6,0.8-0.8c0-0.1,0.1-0.2,0.1-0.2c-0.6,0.5-1.2,1-1.7,1.4
		c1.7-3.6,3.8-6.9,8-7.7c-0.1,0.2-0.1,0.4-0.2,0.6c1.5,0.7,3.1,1.3,4.6,2c0.1-0.2,0.2-0.5,0.4-0.7c-0.5-0.4-1-0.7-2.1-1.5
		c2,0.1,3.4,0.1,4.8,0.1c0-0.2,0.1-0.4,0.1-0.6c-0.9-0.4-1.8-0.8-2.8-1.2c1-0.1,1.8-0.2,2.5-0.3c0.1-0.2,0.3-0.4,0.4-0.5
		c-0.6-0.2-1.2-0.3-1.7-0.5c0.1-0.2,0.3-0.4,0.4-0.6c3-1,6.1-1.8,9-3.1s5.6-3.2,8.5-4.7c0.6-0.3,1.6-0.6,2.2-0.4
		c3.4,1.5,6,4,7.5,7.4c0.4,0.9-0.8,2.4-1.4,4c-2.8-3.6-5.3-6-9.3-5.7c-0.1,0.2-0.2,0.4-0.4,0.6c0.8,0.4,1.6,0.8,2.4,1.2
		c0.8,0.5,1.7,0.8,2.2,1.5c2,2.7,1.8,3.4-1.2,5.2c-3.6,2.2-6.1,5.2-7.4,9.3c-0.7,2.2-2.1,4.3-3.4,6.3c-0.4,0.5-2.1,0.8-2.6,0.4
		c-1.9-1.5-3.4-1.6-4.8-0.7c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1-0.1-0.1-0.1-0.2-0.1c-0.5,0.4-1,1-1.5,1.8c-0.6-1-1.1-1.7-1.6-2.4
		c-0.2,0-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0.1c-0.3,0.1-0.5,0.3-0.7,0.4c0.9,2.1,0.5,3-1.3,3.3c0.1,0.1,0.3,0.2,0.4,0.2
		c0.3,0.2,0.6,0.3,0.9,0.5c0.1,0,0.1,0,0.2,0.1c2-1.1,3.9-2.2,5.9-3.3c0.5-0.3,1.5-0.1,2.1,0.2c0.7,0.3,1.3,0.7,2,1
		c-0.1-0.2,0-0.4,0.2-0.8c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.3,0.3,0.6,0.5,0.9,0.8c0.1,0,0.1,0.1,0.2,0.1c0.5-0.5,1-0.9,1.5-1.4
		c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6
		c0-0.1,0-0.1,0.1-0.2c-0.2-0.6-0.5-1.3-0.7-1.9c0.2-0.1,0.3-0.1,0.5-0.2c-0.1-0.5-0.2-1-0.4-1.5c-1.6-2.5-1.3-5.5,1-7.7
		c1.5,2.8,2.1,5.7,2.4,8.7c0.1-0.5,0.2-0.9,0.2-1.3c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.7-0.1-1c0.2-0.3,0.4-0.6,0.6-0.9
		c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.3,0.4,0.7,0.8,1.1,1.2l0,0c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4
		c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5
		c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7
		s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.3-0.7-0.4
		c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1
		c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2
		c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2
		c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8
		c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2
		c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8
		c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6
		c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5
		c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3c1.1,0.3,2.6-0.1,3.4-0.9
		c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.4-0.4,0.9-0.6,1.4-0.7c0.2-1,0.5-2,1-3c0.7,0.5,1.2,1,1.8,1.3
		c0.1,0,0.2,0.1,0.2,0.1c0.2-0.2,0.3-0.5,0.4-0.7v-0.1c-0.6-0.9-1.1-1.7-1.4-2.6c-0.1-0.1-0.2-0.2-0.4-0.3c0.1,0,0.2,0,0.3,0
		c-1.4-4.1-0.2-8.4,0-12.6c0.3-0.1,0.5-0.1,0.8-0.2c0.4,1.1,0.7,2.2,1.1,3.2c1.8,4,2.9,8.3,6.2,11.6c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.2,0.7-0.5,1.1-0.8c-0.2-0.1-0.3-0.2-0.5-0.3c-0.4-0.3-0.8-0.7-1.4-1.3c0.9-0.2,1.6-0.3,2.3-0.4c-1.2-0.9-2.2-1.7-3.2-2.5
		c0.1-0.2,0.2-0.4,0.3-0.6c1-0.1,2.1-0.3,3.1-0.4c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.3-0.2-0.4-0.3v-0.1c-1.4-0.5-2.7-0.9-4.1-1.4
		c0-0.2,0.1-0.3,0.1-0.5c0.9-0.2,1.7-0.4,3.1-0.7c-0.8-0.3-1.6-0.6-2.3-0.9c-0.1,0.1-0.3,0.2-0.4,0.3c0-0.1-0.1-0.3-0.2-0.5
		c-0.5-0.2-1.1-0.4-1.7-0.7c0.4-0.2,0.8-0.4,1.2-0.5c-0.4-0.7-0.9-0.8-2.6-0.6c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2
		c-0.3-0.2-0.5-0.3-0.8-0.5c-0.2,0.4-0.3,0.8-0.6,1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1-0.2-0.1-0.4-0.2-0.6
		c-0.6,0.3-1.3,0.5-2,0.8c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7c-0.5-0.1-0.8-0.9-1.1-1.3
		c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4
		c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9
		c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3
		c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1c0.7-0.8,1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5
		c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4
		c0.2-0.1,0.3-0.2,0.5-0.3c-0.5-2.6-0.5-5.1,0.9-7.5c0.8-1.5,2.9-2.4,4.1-3.3c-0.8,3.3-1.6,6.7-2.4,10.2c0.4,0.1,0.9,0.1,1.5,0.2
		c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c0.4-0.1,0.8-0.1,1.2-0.1c0.7-0.5,1.3-1,1.8-1.9
		c-1.7,0.6-2.9,1.1-4.1,1.5c-0.1-0.2-0.2-0.3-0.4-0.5c2.3-1.5,4.5-3,6.8-4.5c0-0.1-0.1-0.2-0.1-0.4c-1.4,0.5-2.7,1-4.1,1.5
		c-0.1-0.1-0.1-0.2-0.2-0.4c2.2-1.4,4.3-2.9,6.5-4.3c-0.1-0.1-0.1-0.2-0.2-0.4c-0.5,0.1-0.9,0.2-2,0.4c2.2-1.6,3.9-2.8,5.8-4.2
		c-0.1,1-0.2,1.8-0.4,3.1c0.7-0.9,0.9-1.4,1.4-1.8c1.9-1.6,3.6-3.6,5.8-4.7c3.3-1.7,5.9-3.2,8-4.9c-0.2-0.1-0.4-0.3-0.6-0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3c-6,3.2-12.7,4.2-19.5,5.9c0.4-0.7,0.6-1.1,0.9-1.5c-6,2.9-12,5.9-18,8.8c-0.1-0.2-0.2-0.3-0.3-0.5
		c0.9-2.1,1.4-4.6,2.8-6.2c1.5-1.6,3.8-2.6,6-3.3c4.9-1.6,10.1-2.6,14.9-4.4c7.7-2.9,15.1-6.3,22.7-9.4c1.2-0.5,2.8,0,4.8,0.1
		c0.3-1.3,0.8-3.2,1.3-5.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.5,0.7-0.9,1.3-1,1.4c-0.3-3.2-0.6-6.7-0.9-10.6c2.5,3.3,5.5,6,4.5,10.9
		c-1,4.6-2.9,8.6-5.8,12.1c-0.9,1.1-1.7,2.5-2.3,3.9c-0.2,0.4-0.1,0.8,0,1.3c0.1-0.3,0.2-0.6,0.2-1v-0.1c0-0.1,0-0.1,0.1-0.2
		c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9
		c-0.2-0.2-0.3-0.5-0.4-0.7c-0.2,0.4-0.5,0.7-0.7,1.1c0.3,0.6,0.5,1.1,0.4,1.8c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7
		c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0
		c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3
		c-1.7,0.5-2.7,1.8-2.5,3.2c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6
		c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7
		c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4
		c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6c1.6,0.2,2.7-0.5,3.4-1.6c1.7-0.2,3.3-0.3,5-0.5
		c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3
		c-2.3-0.4-4.6,0.8-5.2,2.7c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1
		c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9
		c1.8,0,3.6-0.2,4.9-1.5l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4c0-0.3-0.1-0.6-0.2-0.9
		c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2
		c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3
		c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1
		c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6s0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1
		c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4c0.3-1.1-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3
		c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5
		c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7s0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7
		c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2
		c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1
		c-1.4-0.6-2.6-0.3-3.6,0.8c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1c0.5-0.8,1.2-1.6,1.5-2.5c0.4-0.8,0.4-1.7,0.7-2.7
		c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1
		c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5
		c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1
		c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5c0.2,0.7,0.5,1.3,1.3,1.8c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4
		c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4
		c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8c-0.1-0.2-0.1-0.4-0.2-0.5c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4
		c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4
		c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2
		c0.1-0.3,0.2-0.6,0.3-1c1.1,0.8,2.2,1.6,3.4,2.5c-0.5-2.5-0.9-5.1-1.4-7.6c-0.3-1.4-0.5-2.9-1.2-4.4c-0.2,1.1-0.5,2.3-0.7,3.4
		c-0.1,0-0.3,0-0.4,0c-0.7-5.4-1.3-10.9-2-16.3c-0.4,0-0.8,0-1.2,0c-0.2,1.7-0.4,3.4-0.6,5.1c-0.7-0.8-1.5-1.7-2.6-3
		c0.6-2.4,3.6-2.8,6.1-4.9c0.7,2,1.5,3.8,1.8,5.7c0.5,3.8,0.7,7.6,0.8,11.5c0.2,4.2,1.3,8,3,11.7c0.1,0.1,0.3,0.2,0.4,0.3
		c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.1,0,0.1,0,0.2,0c-0.1-0.4-0.2-0.8-0.3-1.2l0,0c-0.5-0.3-0.7-0.7-0.2-1.1
		c-0.8-3.4-1.7-6.9-2.5-10.3c0-0.2-0.1-0.3-0.1-0.5c0.7-3.4-0.2-6.8,0.3-10.3c0.4-2.5,0.8-4.9,1.4-7.3c0.2-0.7,0.6-1.4,1-2.5
		c0.8,2.6,1.5,4.8,2.2,7c0.3-0.1,0.6-0.2,0.9-0.3c-0.6-2.3-0.9-4.8-2-6.8c-0.7-1.1-0.5-1.6-0.1-2.4c0.9-2.1,1.9-4.1,2.7-5.8
		c2.8-0.5,5.5-0.9,8.8-1.5c-0.2,5.9-0.4,12-0.6,18.1c0.3,0,0.7,0.1,1,0.1c0.4-1.9,0.9-3.7,1.3-5.7c4.8,2.9,8.1,12.7,5.9,17.5
		c-0.3,0.7-0.9,1.2-1.5,2c0.1,0.3,0.3,1.1,0.7,2.6c-1-0.8-1.4-1.2-2.2-1.8c0.2,1.3,0.4,2.4,0.7,3.6c-0.6-0.2-1-0.3-1.8-0.5
		c1.7,3.5,3.4,6.8,5,10.1l0,0c0,0.1,0,0.1,0,0.2c0.8,1.6,1.6,3.2,2.4,4.8c0.2-0.1,0.4-0.2,0.7-0.2c-1.8-5.6-5.3-11-1.9-17.7
		c0.7,3.7,1.4,7,2,10.3c0.1,0.6,0.3,1.2,0.4,1.8c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2
		c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4
		c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9
		c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3
		c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5
		c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3
		c1,0.4,2.3,0,2.7-1.1c0.4-0.9,0.3-1.7-0.5-2.2c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7
		c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3
		c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7
		c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3
		c1.2-0.9,1.9-1.2,3.3-1.4c1.3-0.1,1.9-0.5,2.9-2.1c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9
		c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1
		c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8c0.3-0.2,0.6-0.5,0.9-0.7l0,0
		c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0-0.2-0.4-0.3-0.6-0.5c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3
		c-0.2,0.8-0.3,1.3-0.4,1.8c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5
		c-0.4,0.3-0.8,0.6-1.1,0.8c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3
		c-1.1,0.2-1.8,0.7-2.4,1.4c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.2,0.8l0,0
		c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4
		c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7
		c-0.8,0.1-1.2,0.6-1.3,1.2c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.2-0.3,0.5-0.6,0.8
		c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1
		c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9
		c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7V177
		l0,0c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1.1,0.4
		c0.1,0,0.2,0.1,0.4,0.1c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9
		c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7
		c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8s0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1
		s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3
		c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3
		c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8
		c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2
		c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3
		c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6h-0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5
		c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4
		c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3
		c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1
		c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4c1.4,0.6,3,0.6,4.4,0.1v-8.4
		c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3c0.5-1,0.6-1.9,0.3-2.6c-0.2-0.5-0.6-1-1.2-1.4
		c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9
		c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8
		c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8
		c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9
		c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5
		c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1V74V57.1
		c-0.5,0-1-0.1-1.4-0.4C610.6,56.6,610.4,56.5,610.2,56.6z M589.9,72.1L589.9,72.1C589.9,72,589.9,72,589.9,72.1
		C589.9,72,589.9,72.1,589.9,72.1z M572.8,57.5c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C572.6,57.6,572.7,57.5,572.8,57.5z M556.5,63.8c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C556.5,63.6,556.5,63.8,556.5,63.8z M565.9,54.6L565.9,54.6h0.2H565.9z M567.7,70.1
		L567.7,70.1L567.7,70.1L567.7,70.1z M541.2,57.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C541.1,57.7,541.1,57.6,541.2,57.6z
M457.6,62L457.6,62h0.1H457.6z M457.8,59.9c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0.1,0.2,0.1C458,59.7,457.9,59.8,457.8,59.9z M475.8,53
		c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C475.6,53.2,475.7,53.1,475.8,53z M398.3,99
		c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C398.6,99,398.4,99,398.3,99z M361.2,118.2c0.2,0.1,0.4,0.3,0.6,0.4
		c-1.8,2.7-3.5,5.4-5.3,8.1c-0.2-0.2-0.3-0.3-0.5-0.5C357.8,123.5,359.5,120.8,361.2,118.2z M283.7,139.4L283.7,139.4
		C283.7,139.3,283.8,139.3,283.7,139.4C283.8,139.3,283.8,139.4,283.7,139.4z M266.7,124.7c0.1,0,0.2,0,0.3,0.1
		c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C266.5,124.9,266.6,124.8,266.7,124.7z
M250.3,131.1c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C250.4,130.9,250.3,131.1,250.3,131.1z
M259.8,121.9l0.1-0.1l0.1,0.1H259.8z M261.5,137.4L261.5,137.4C261.5,137.4,261.6,137.4,261.5,137.4
		C261.6,137.4,261.5,137.4,261.5,137.4z M235.1,124.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C234.9,125,235,124.9,235.1,124.9z
M151.5,129.3L151.5,129.3h0.1H151.5z M151.7,127.2c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0.1,0.2,0.1C151.8,127,151.7,127.1,151.7,127.2z
M61.2,173.3L61.2,173.3L61.2,173.3L61.2,173.3z M34.7,184.4C34.7,184.4,34.7,184.3,34.7,184.4L34.7,184.4
		C34.8,184.4,34.8,184.4,34.7,184.4z M7.4,189.8L7.4,189.8l0.1-0.1L7.4,189.8z M41.6,291.2c-0.1,0-0.1,0-0.2,0
		c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1C43.1,290.8,43,291,41.6,291.2z M60.8,182.9c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0c0.2-0.1,0.4-0.2,0.7-0.4c0.4-0.2,0.7-0.4,1.2-0.7
		C61.3,182.1,61,182.5,60.8,182.9z M86.6,180.6c-0.3-0.7,0.9-1.1,1-1.8c0.6,0.3,1.3,0.6,1.3,1.4C88.2,180.3,87.5,180.5,86.6,180.6z
M92.1,166.3c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C92.4,166.3,92.2,166.3,92.1,166.3z M98.2,295.6c0.2-0.5,0.3-1,0.5-1.5
		c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0c1,0.1,1.5,0.4,2.2,1.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2
		c-0.3,0.3-0.7,0.5-1.2,0.7C98,296.2,98.1,295.9,98.2,295.6z M130.9,275.8C130.9,275.8,130.9,275.9,130.9,275.8
		c0,0.1-0.1,0.1-0.1,0.2c0-0.1,0-0.1,0-0.2C130.7,275.8,130.8,275.8,130.9,275.8z M263.7,136.4c-0.7,0.6,0.1,0.4,0.5,0.6
		c-0.6,0.4-1.1,0.7-1.8,1.1c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1C262.8,136.2,263.2,136.3,263.7,136.4z M268.3,149.3
		c0,0.3,0,0.6,0,0.9c-3.3,0.7-6.4,1.7-10.1,0.3c-3.3-1.3-7.2-1-10.8-1.5c-0.4,0-0.8-0.1-1.1-0.4
		C253.6,148.8,260.9,149.1,268.3,149.3z M236.4,138c0-0.2-0.1-0.4-0.1-0.6C236.7,137.6,237,137.7,236.4,138z M229,146.6L229,146.6
		C229,146.6,229,146.7,229,146.6C229,146.7,229,146.6,229,146.6z M240.6,148.6c-12,0.7-24.2,0.6-36,2.4c-11.8,1.8-23.4,5.6-34.6,8.5
		C192.1,148.7,216.2,147.8,240.6,148.6z M169.6,120.3c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		l-0.3-0.1C169.5,120.5,169.5,120.4,169.6,120.3z M162.3,142.9c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1L162,143
		C162.2,143,162.3,142.9,162.3,142.9z M163.9,178.8c7.5,2,15.1,3.3,22.6,5.3c3.9,1,7.6,2.9,11.4,4.3c0.7,0.3,1.4,0.6,2.3,0.6
		c-11.6-7-24.8-9.1-37.8-12.2c0.8,0,1.6,0,2.4,0.1c0-0.2,0.1-0.3,0.1-0.5c-1.8-0.4-3.5-0.9-5.3-1.3c0-0.2,0.1-0.4,0.1-0.6
		c1.5,0,3.1,0.1,4.6,0.1c0-0.1,0.1-0.3,0.1-0.4c-0.6-0.4-1.3-0.8-1.9-1.2c0-0.1,0-0.3,0-0.4c1.3,0.1,2.6,0.3,4,0.4
		c0-0.1,0.1-0.3,0.1-0.4c-0.6-0.3-1.3-0.7-2.3-1.3c1.7,0.1,3,0.1,5,0.2c-1-0.7-1.5-1-2.4-1.5c1.3-0.1,2.3-0.2,3.3-0.3
		c0-0.1,0-0.3,0.1-0.4c-0.8-0.2-1.7-0.4-2.5-0.6c0-0.2,0-0.3,0-0.5c1.2-0.2,2.5-0.3,4-0.5c-0.3-0.4-0.5-0.8-0.5-0.8
		c2.1-0.9,4.1-2.1,6.3-2.6c7.8-2,15.4,0,23,1.7c3.2,0.7,6.4,1.1,9.6,0c1.4-0.5,2.8-0.9,4.4-1.5c0,0-0.3-0.4-0.7-1.1
		c1.4,0,2.7,0.1,4.4,0.1c-0.8-0.7-1.2-1.1-2-1.9c1.3-0.1,2.3-0.1,3.1-0.1c0.3-3.6,3.2-0.4,4.4-1.9c-0.5-0.3-1-0.6-1.4-0.9
		c0.1-0.2,0.1-0.4,0.2-0.4c0.7-0.2,1.4-0.4,2-0.6c1-0.3,1.8-0.1,2.7-1.4c0.8-1.2,3.7-1.1,5.7-1.4c0.9-0.1,2.2,1.1,2.7-0.8
		c0-0.1,0.6-0.1,0.9-0.1c3-0.2,6-0.3,9.4-0.5c-0.6-0.3-1.1-0.5-1.5-0.7c-0.5-0.2-1-0.2-1.5-0.4c0-0.2,0.1-0.5,0.1-0.7
		c2.8,0.6,5.6,1.2,8.4,1.8c0.1-0.1,0.1-0.3,0.2-0.4c-0.8-0.4-1.5-0.9-2.3-1.3c0-0.1,0.1-0.2,0.1-0.3c1.2,0.3,2.3,0.6,4,1
		c-0.7-0.7-1.1-1.1-1.6-1.7c2.7,0.4,5.1,0.8,8.1,1.3c-0.9,0.5-1.3,0.8-1.7,1c-4.3,2.2-8.7,4.1-12.7,6.6c-4.4,2.8-7.4,6.9-9.3,11.9
		c-1.4,3.8-3.4,7.4-4.5,11.3c-1.3,4.4-4.5,5.1-8.2,5.4c-4.1,0.3-8.2,0.7-12.4,0.8c-1.3,0-2.8-0.3-4-1c-2.1-1.1-4-2.5-5.7-4.3
		c3.7,1.4,7.5,2.8,11.2,4.2c0.1-0.2,0.1-0.4,0.2-0.7c-11.1-5.3-22.8-8.1-34.8-10c-0.1,0.3-0.3,0.7-0.4,1c0.9,0.4,1.9,0.9,2.8,1
		c9.1,1.3,17.1,5.2,25.1,10c-3.9,0.5-7.7,1.1-11.6,1.5c-0.5,0.1-1.2-0.4-1.7-0.7c-8.6-5.9-18.6-7.9-28.6-9.6c-2.8-0.5-5.7-0.7-8.5-1
		c-0.1,0.4-0.2,0.8-0.3,1.1c12.5,1.2,24.3,4.4,36,10.1c-0.9,0.3-1.3,0.5-1.8,0.5c-5.7,0.7-11.5,1.4-17.3,2c-0.7,0.1-1.4-0.2-2.1-0.5
		c-3.8-1.2-7.5-2.8-11.4-3.6c-7-1.4-14.2-2.2-21.2-3.3c-1.5-0.2-3-0.1-4.5-0.4c6.7-1.5,13.4-1.8,20.2-0.7c0-0.3,0.1-0.6,0.1-1
		c-3.2-0.5-6.4-1-10-1.6c2.4-0.7,4.5-1.3,6.7-1.9c-0.1-0.3-0.3-0.6-0.4-0.7C153.6,176.3,158.6,177.5,163.9,178.8z M120.3,197.3
		c-0.4,0-0.8,0-1.1,0c7.4-3.7,15.3-2.7,23.1-3c-4.7-1.8-10.1-0.5-14.5-3.4c0-0.3-0.1-0.5-0.1-0.8c1.8-0.5,3.7-1.5,5.5-1.5
		c6.9,0.2,13.8,0.5,20.7,1.1c2.8,0.3,5.5,1.3,8.3,2.1c0.9,0.2,1.6,0.8,2.4,1.2c0,0.2-0.1,0.4-0.1,0.6c-0.9,0-1.9-0.1-2.8-0.1
		c-1.5,0.1-3.1,0.1-4.6,0.3c-2.1,0.3-4.2,0.7-6.2,1.2c-0.8,0.2-1.4,0.9-2.2,1.2c-1.2,0.5-2.6,1.4-3.6,1.1
		C136.8,195.7,128.6,196.2,120.3,197.3z M144.3,199.1c-0.7,3.1-1,3.1-4.1,2.8c-7.9-0.7-15.9-1-23.8,1.2
		C118.9,197.9,137.2,197.4,144.3,199.1z M106,195.3c-4.7,5.3-5.8,12.1-7,18.8c-0.9,5.1-1.6,10.3-0.5,15.5c0.1,0.4,0,0.8,0,1.2
		c0,0.1-0.2,0.2-0.5,0.6c-0.3-0.7-0.7-1.2-0.9-1.8c-2.1-5.8-2.1-11.6-0.9-17.7c1.9-9.7,7.7-17.1,14.2-24c4.1-4.4,9.8-6.4,15.2-8.8
		c7.8-3.4,15.6-7,23.4-10.4c0.2-0.1,0.4-0.1,0.7-0.1c0.1,0.1,0.2,0.3,0.3,0.4c-4,2.3-7.8,4.9-12,6.9c-4.5,2.2-9.2,4.2-13.9,5.7
		C116.4,184.1,111.1,189.6,106,195.3z M121,208.2c-2.2,0.6-4.3,0.5-6.7-1.1c8.8-3.2,17.4-4.3,26.6-4c-0.9,1.9-1.6,3.1-3.6,2.9
		C131.7,205.6,126.3,206.8,121,208.2z M135.5,210.7c-1.9,0-3.8,0.3-5.9,0.5c-0.1-0.4-0.3-0.7-0.3-1c-0.2-0.7-0.3-1.4-0.6-2.6
		c3.2,0,6.2-0.1,9.3-0.1C138.5,209.7,137.8,210.7,135.5,210.7z M203.3,237.8c-0.2,0.1-0.4,0.1-0.6,0.2c-1.2-2.3-2.4-4.6-3.4-6.9
		c-0.2-0.4,0.2-1,0.4-1.4c0.5,0.2,1.5,0.3,1.6,0.6C202,232.7,202.6,235.2,203.3,237.8z M220.1,228.6c-3.9-2-7.8-4-11.7-6
		c0,0-0.1,0.4-0.3,1c-1.3-0.9-2.6-1.8-3.8-2.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.5,0.7,1,1.4,1.6,2.1c-0.1,0.1-0.2,0.2-0.3,0.3
		c-1.6-1.2-3.3-2.3-4.9-3.5c-0.1,0.1-0.2,0.2-0.3,0.3c1.1,0.9,2.2,1.7,3.3,2.6c-0.2,0.2-0.4,0.5-0.7,0.7c-2.7-0.5-4.1-4-7.5-3.7
		c0.4,0.8,0.7,1.3,1.2,2.3c-1.1-0.5-1.8-0.8-2.6-1.2c0.1,0.9,0.3,1.7,0.5,2.8c-10.1-13.6-34.8-23.1-41.6-23.7
		c9.7,3.4,18.7,8,27,14.2c-3.8-1.9-7.6-3.9-11.5-5.7c-3.8-1.7-7.6-3.2-11.5-4.8c-0.2,0.4-0.4,0.7-0.5,1.1c1.3,0.7,2.6,1.5,3.9,2.1
		c5.6,2.6,11.3,4.8,16.7,7.8c4.9,2.7,9.3,6.1,14,9.1c0.3,0.2,0.5,0.5,0.5,1.1c-0.6-0.2-1.2-0.4-1.7-0.7c-4.9-3.1-9.6-6.5-14.7-9.2
		c-3.9-2.1-8.2-3.5-12.3-5c-2.4-0.9-4.9-1.3-7.4-1.9c-0.9-0.2-1.8-0.2-2.6-0.3c0,0.2-0.1,0.5-0.1,0.7c3,0.9,6,1.8,9.1,2.6
		c8.3,2.2,14.8,7.4,20.8,13.2c0.5,0.5,0.7,1.3,1,2c-0.2,0.2-0.3,0.5-0.5,0.7c-1.5-0.6-3.1-0.9-4.4-1.7c-3.2-2.2-6.2-4.7-9.4-7
		c-1.1-0.8-2.6-1.1-4.2-1.3c4,4.6,10.8,6.5,12.6,13.5c-4.4-1.5-8.6-2.9-13.1-4.4c0.3,0.7,0.5,1.2,0.5,1.3
		c-6.1,0.7-12.2,1.5-18.3,2.1c-0.7,0.1-1.6-0.4-2.1-0.9c-3.8-4.1-5.3-9.2-5.9-14.6c-0.2-1.5,0.4-2.5,2.1-2.5
		c2.6,0.1,5.1,0.2,7.7,0.3c0.8,0,1.5,0.1,2.3,0.2c0-0.2,0.1-0.5,0.1-0.7c-2-0.3-4-0.6-6-0.8c-1.3-0.1-2.7,0.1-4.1-0.1
		c-0.6-0.1-1.1-0.8-1.7-1.3c0.6-0.4,1.3-1.2,1.8-1.2c3.3,0.3,6.6,0.8,10,0.7c-3.5-0.8-6.9-1.5-10.4-2.3c0.3-4,3.2-2.6,5.4-3.1
		c-0.8-0.3-1.5-0.6-2.3-0.9c2-2.9,2-2.9,6.2-3.1c-0.8-0.4-1.2-0.7-1.7-1c-0.1-0.3-0.1-0.5-0.2-0.8c1.6-0.5,3.2-1,4.9-1.4
		c0.5-0.1,1.1,0.1,1.4-0.1c3.3-2.2,7-1.3,10.6-1.4c1.2,0,2.5,0.5,3.6,1.1c9.7,5.4,19.2,11.2,29.1,16.1c8.1,4,15.1,9.5,21.8,15.4
		c0.4,0.3,0.7,0.7,1,1C220.3,228.2,220.2,228.4,220.1,228.6z M242.1,230.4c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7
		c-0.9,0.2-1.7,0.4-2.9,0.6c0.9-0.9,1.5-1.5,2.1-2.1c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3
		C242.7,230.9,242.4,230.6,242.1,230.4z M243.5,232l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2C243.7,232,243.6,232,243.5,232z M248.5,210.8
		c-1.2-1-2.3-1.9-3.4-2.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.9,0.9,1.8,1.7,2.7,2.6c-0.1,0.1-0.2,0.3-0.2,0.4c-7.1-3.7-14.3-7.4-21.4-11.1
		c-0.1,0.2-0.3,0.4-0.4,0.6c0.7,0.6,1.4,1.1,2.2,1.7c-0.1,0.1-0.1,0.3-0.2,0.4c-1.1-0.4-2.2-0.8-3.3-1.2c-0.1,0.2-0.2,0.4-0.4,0.6
		c3.3,2,6.4,4.2,9.8,6c6.6,3.5,13.6,6.5,19.4,12.5c-5.6-1.9-10.7-3.5-15.4-6.2c-3.1-1.8-6.5-3.2-9.8-4.7c-1.5-0.7-3-1.5-4.5-2.2
		c-0.6-0.3-1.6-1.5-2.2,0.2c0,0.1-0.9,0-1.3-0.2c-1.1-0.4-2.1-1-3.3-1.3c5.7,3.7,11.5,7.5,17.2,11.2c-0.1,0.2-0.3,0.5-0.4,0.7
		c-3.8-2-7.5-4-11.3-6c-0.2,0.2-0.3,0.5-0.5,0.7c1.1,1.1,2.2,2.2,3.2,3.3c-0.1,0.1-0.2,0.3-0.3,0.4c-3-2-6-4-9.1-6.2
		c0,0.6,0,1.1-0.1,1.7c-0.5-0.2-1-0.4-1.5-0.6c-0.1,0.1-0.1,0.2-0.2,0.3c1.2,1.1,2.5,2.3,3.7,3.4c-0.1,0.2-0.2,0.3-0.3,0.5
		c-3.9-2.2-7.8-4.5-11.8-6.7c0.3,0.4,0.6,0.9,0.8,1.4c-0.1,0.1-0.2,0.2-0.3,0.3c-1.4-1.2-2.9-2.4-4.3-3.5c-0.1,0.1-0.2,0.2-0.3,0.2
		c0.6,0.7,1.2,1.4,1.8,2.1c5.6,5.4,12.2,9.5,19.1,13.1c2.9,1.5,5.6,3.5,8.3,5.3c-0.2,0.3-0.5,0.6-0.7,0.9c-1.6-1.2-3.2-2.5-4.8-3.7
		c-0.1,0.1-0.2,0.2-0.4,0.3c0.8,1,1.7,2,2.5,2.9c-0.1,0.1-0.2,0.3-0.4,0.4c-1.4-1.2-2.9-2.5-4.3-3.7c-0.1,0.1-0.2,0.2-0.3,0.2
		c0.5,0.8,1,1.6,1.6,2.4c-15.1-14-33-23.7-50.9-34.2c1-0.3,1.8-0.6,2.6-0.7c5.2-0.5,10.5-1.1,15.7-1.4c1.3-0.1,2.7,0.8,4,1.3
		c0.8,0.3,1.5,0.8,2.2,1.2c0.1-0.2,0.3-0.4,0.4-0.5c-0.9-0.6-1.7-1.3-2.6-1.9c5.6-0.2,11.1-4,16.9-0.5c-0.2-0.4-0.4-0.8-0.8-1.5
		c1.3-0.2,2.6-0.4,3.8-0.6c4.3-0.5,8.7-0.8,12.9-1.5c1.6-0.3,2.2,0.2,2.6,1.5c1.9,5.6,5.3,10,10.4,13.2c4.9,3.1,9.4,6.7,13.9,10.5
		c-2.1-1.3-4.1-2.5-6.3-3.8C248.5,209.8,248.5,210.2,248.5,210.8z M277,152.3c-3.5,0.5-7,1-10.5,1.6c-8.4,1.5-16.1,4.8-22.4,10.6
		c-3.8,3.5-5.5,8.3-7.3,13.1c-0.8,2.2-1.9,4.4-2.5,6.7c-0.9,3.7,0.1,7.4,2.6,10c3.3,3.4,7.4,6.1,11.2,9c4.8,3.7,9.7,7.3,14.8,11.1
		c-0.9,1.1-1.5,1.8-1.9,2.3c-6.8-6.2-14.3-11-21.5-16.2c-4.4-3.2-6.9-7.4-8.5-12.3c-0.2-0.6-0.2-1.5,0.1-2.1
		c2.5-5.9,4.9-11.8,7.7-17.5c2.5-5.4,7.2-8.8,12.5-11c5.2-2.2,10.5-4.1,16-5.4c3.1-0.8,6.6-0.3,9.9-0.4
		C277.1,151.8,277,152,277,152.3z M404.4,228.3c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0
		c1,0.1,1.5,0.4,2.2,1.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6
		c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7C404.2,228.9,404.3,228.6,404.4,228.3z
M463,222.6c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9C463.4,221.2,463.2,221.9,463,222.6z M520.2,180.2
		L520.2,180.2C520.2,180.2,520.2,180.2,520.2,180.2L520.2,180.2z M488.8,65.4c0,0.7,0,1.5-0.1,2.8c2.8-3.6,8.4-5.2,10.3-3.2
		c2.3-0.7,4.4-1.3,6.5-2c0.1,0.2,0.1,0.4,0.2,0.5c-0.5,0.3-1,0.6-1.5,0.9c2.5,1.2,4.9,2.3,7.9,3.6c1.5,2.3,1.6,2.4,4,0.6
		c0.4,0.4,0.9,0.8,1.7,1.5c-1.1,0-1.6,0-2.1-0.1c-0.1,0.2-0.1,0.4-0.2,0.5c1.4,0.6,2.8,1.3,4.3,2c-0.7,1.9-1.1,3.6,2,3.6
		c0.5,0,1.3,2,1.6,3.2c0.1,0.6-0.8,1.3-1.3,2.1c0.4,0.7,1.1,1.7,1.8,2.8c-0.2,0.2-0.4,0.4-0.7,0.7c-0.9-0.7-1.7-1.4-2.8-2.2
		c-0.5,0.2-1.4,0.7-2.7,1.3c0.8,0.3,1.2,0.4,2,0.7c-0.7,1-1.3,2-1.7,2.6c-1.8-0.5-3.2-0.9-4.5-1.3c-0.1,0.3-0.1,0.6-0.2,0.8
		c0.7,0.2,1.4,0.3,2,0.5c-0.1,0.3-0.1,0.5-0.2,0.8c-0.7-0.2-1.5-0.3-2.1-0.7c-0.7-0.4-1.3-1.2-2-1.6c-1.8-0.9-3.7-1.7-5.7-2.5
		c-0.3,0.2-1.1,0.7-2.2,1.4c-0.1-3.1-2.1-4.9-4.3-4.9c-1.2,0-2.4-0.7-3.5-1.1c0.3-1,0.7-1.9,1-2.9c-2,0.2-4.2,0.5-6.4,0.7
		c-0.1-0.4-0.3-0.8-0.4-1.2c1.9-1.2,3.8-2.5,5.7-3.7c-1.3-1.8-1.3-1.9,0.8-2.7c0,0.7,0,1.3-0.1,2.3c0.9-0.8,1.7-1.4,2.4-2
		c-0.2-0.7-0.4-1.5-0.7-2.2c-2,0.3-4,0.6-6,0.8c0,0.2,0,0.4,0,0.5c0.4,0.1,0.7,0.2,1.2,0.4c-2.2,3.4-4.4,6.8-6.5,10.1
		c-2.2-0.4-1.5-1.5-1.3-2.7c0.2-1,0.1-2,0.3-3.1c0.2-1,0.4-2,0.7-3c0.3-0.9,0.6-1.8,1.2-3.2c-0.1-0.3-0.5-1.2-1-2.4
		C487.3,64.9,488,65.1,488.8,65.4z M524.5,86.2c0.1,0.1,0.3,0.2,0.4,0.4c-1.8,0.5-3.6,0.9-5.8,1.5c0.4-0.9,0.8-1.8,1.1-2.3
		C521.9,85.9,523.2,86.1,524.5,86.2z M501,83.4c-0.8-0.1-1.7,0-2.5-0.2c-0.8-0.3-1.5-0.9-2.2-1.3c0.3-0.4,0.6-0.8,0.8-1.2
		c0.8,0.3,1.8,0.4,2.4,0.9C500.2,81.9,500.5,82.7,501,83.4z M495,80.3c-1.9,0.6-3.2,1-4.6,1.4c0-0.9,0.1-2.1,0.1-3.7
		C491.9,78.7,493.2,79.4,495,80.3z M485.8,66c0.1,0.2,0.2,0.3,0.3,0.5c-0.3,0.6-0.7,1.2-1,1.7c-0.5,0.7-1,1.3-1.4,1.9
		c-0.5-0.7-1.1-1.5-1.8-2.5C483.5,66.8,484.7,66.4,485.8,66z M503.2,87.5c3.3,0.7,6.5,1.6,9.7,2.6c4.1,1.3,4.5,2.8,2.2,6.8
		c-2.4-0.9-4.9-1.8-7.3-2.7c-7.1-2.6-14.4-3.4-21.9-2.6c-2.3,0.3-3.4-0.4-4.2-2.3c-0.4-0.9-0.9-1.8-1.6-3
		C488.1,86.1,495.7,85.8,503.2,87.5z M515,112.4c-1-0.6-2-1.3-3-2c0.1-0.6,0.2-1.2,0.3-2.3c0,0-0.1,0-0.1-0.1
		c-0.8,0.9-1.2,1.4-1.9,2.2c-0.2-1-0.3-1.6-0.4-2.2c-1-0.1-2-0.2-3.1-0.3c0.4-0.8,0.6-1.4,1-2.1c1.5,0.8,2.9,1.6,4.4,2.4
		c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.2,0,0.3c1.1,0.6,2.2,1.2,3.2,1.8C515.3,111,515.1,111.7,515,112.4z M517,112.6
		c0.4,1.4,0.6,2.1,0.9,3c-1-0.3-2.2-0.6-3.4-0.9C515.3,114,516.2,113.3,517,112.6z M499.1,102.5c-4.8-0.2-9.6,0.3-14.3,0.4
		c-1.3,0-2.5-0.1-3.7-0.1c0-4.6,1.5-6.5,5.5-7.1c9.2-1.3,18.3-1.5,27.1,1.9c0.8,0.3,1.8,1.4,1.7,2c-0.1,1.5-0.7,3-1.3,4.5
		c0,0.1-0.8-0.1-1.3-0.1C508.3,103.5,503.7,102.7,499.1,102.5z M453.3,109.8c-0.2-0.7,0.4-1.6,0.7-2.4c0.2,0,0.4,0,0.6,0.1
		c0.2,1,0.3,2,0.5,3c0.1,0,0.3,0,0.4,0c0.2-0.6,0.4-1.2,0.9-2.5c0.4,1.7,0.7,2.7,0.9,3.8c0.1,0,0.2,0.1,0.4,0.1
		c0.2-0.6,0.3-1.3,0.5-1.7c3.6,0.1,7.1,0.2,10.4,0.3c0.9-1.2,1.7-2,2.7-3.3c0.3,1.1,0.5,1.6,0.7,2.5c0.9-1.7,1.7-3.2,2.7-5
		c0.4,1,0.5,1.4,0.8,2.1c0.6-1.5,1.1-2.6,1.4-3.5c1.2,0.4,2.2,0.7,3.5,1.1c-5.6,5.1-10.8,10.9-19,12.1c-0.2,0-0.5,0.2-0.7,0.1
		C457.7,114.8,454.3,113.5,453.3,109.8z M480.5,106.7c-2.5,2.2-5,4.3-7.5,6.5c-0.1-0.2-0.3-0.3-0.4-0.5c2.5-2.2,5-4.4,7.5-6.6
		C480.2,106.3,480.3,106.5,480.5,106.7z M466,128c0.8,1,1.3,1.6,1.7,2.1c0.4-0.6,0.9-1.2,1.3-1.8c0.8,0.6,1.6,1.2,2.3,1.8
		c0.7,0.6,1.2,1.4,2,2.2c-2.4,0.9-4.9,1.8-7.4,2.6c-0.3,0.1-1.2-0.7-1.2-1.2c-0.3-1.7-0.4-3.5-0.5-5.3c0.2-0.1,0.3-0.1,0.5-0.2
		c0.4,1.4,0.9,2.8,1.3,4.2c0.2,0,0.4-0.1,0.6-0.1C466.4,131.2,466.2,129.9,466,128z M456.8,123.8c-0.8-0.9-1.4-1.7-1.7-2.1
		c1.6-1.3,2.9-2.5,4.3-3.6C460.1,118.7,460.1,118.7,456.8,123.8z M399.6,162.8c-3.5,2-7.3,3.4-11.1,4.9c-0.7,0.3-2-0.3-2.7-0.8
		c-0.9-0.6-1.5-1.6-2.5-2.7c1.3-0.1,2.3-0.2,3.4-0.4c0-0.1,0-0.3,0-0.4c-0.7-0.1-1.4-0.3-2.1-0.4c7.7-1.9,16-1.9,22.7-7.2
		c0.2,0.3,0.4,0.7,0.5,1C405.1,158.8,402.5,161.2,399.6,162.8z M391.6,192.9c-0.7-0.3-1.5-0.4-1.6-0.7c-0.3-0.7-0.3-1.5-0.5-2.5
		c-0.5-0.2-1.3-0.5-2-0.7c0-1-0.1-2-0.1-2.9c-0.2,0-0.4,0-0.6,0c-0.4,0.9-0.8,1.7-1.2,2.6c-0.3,0-0.5-0.1-0.8-0.1
		c0-1.1,0.1-2.2,0.1-3.9c-0.6-0.1-1.6-0.5-2.6-0.5c-1.7,0.2-4.3-1-5-2.6c-0.1-0.2,0.2-0.6,0.3-0.9c0-0.3,0-0.8-0.2-1
		c-0.1-0.1-0.6,0-0.9,0.1c-0.7,0.1-1.4,0.2-2.7,0.4c1.5-1.1,2.3-1.8,3.4-2.5c-0.6-0.5-1.1-0.8-1.5-1.1c-0.9,2.1-0.9,2.1-3.6,1.3
		c0-1,0.1-1.9,0.1-2.9c-0.2,0-0.4,0-0.5-0.1c-0.1,0.4-0.2,0.8-0.3,1.4c-2.2-1-5.1-0.8-5.7-4.1c0-0.2-1-0.2-2.3-0.4
		c0.9,1,1.3,1.5,2,2.3c-1.6,0.2-2.9,0.3-4.4,0.5c0.3-0.9,0.5-1.5,0.6-1.6c-0.7-1.2-1.2-2.1-1.8-3.1c-0.1,0-0.3,0-0.4,0
		c0.1,0.8,0.2,1.5,0.4,2.3c-0.9,0.4-1.9,0.9-3.2,1.6c-0.5-0.4-1.1-1-1.9-1.7c-0.6,1.2-1.2,2.3-2,3.8c-0.6-0.6-1.3-1.1-1.7-1.6
		c0.9-0.5,1.6-0.9,2.3-1.3c-0.1-0.2-0.2-0.5-0.3-0.7c-0.8,0-1.6-0.1-2.5-0.1c0.1-0.2,0.2-0.3,0.3-0.5c-0.7-0.5-1.5-1-2.2-1.5
		c-0.2,0.2-0.3,0.4-0.5,0.6c0.5,0.6,1,1.3,1.5,1.9c-0.1,0.2-0.2,0.4-0.4,0.7c-1.2-0.6-2.4-1.2-3.1-1.5c0.7-2.4,1.3-4.7,2.1-7.5
		c-1,0.8-1.7,1.4-2.5,2.1c-0.5-0.5-1.1-1.1-1.7-1.7c-0.1,1.3-0.3,2.5-0.4,4.1c0.8-0.7,1.5-1.2,2.1-1.7c0.2,0.2,0.4,0.4,0.6,0.5
		c-0.5,0.5-0.9,1.2-1.4,1.6c-0.9,0.6-1.9,1-3.1,1.6c1.9,1,3.4,1.8,4.8,2.6c-0.1,0.2-0.2,0.4-0.3,0.6c-1.7-0.8-3.5-1.7-5.4-2.6
		c0.5-0.8,0.9-1.5,1.4-2.4c-0.6-0.2-1.1-0.4-1.7-0.7c-0.1,0.8-0.1,1.4-0.2,2.2c-2.5-0.7-1-3.2-2.2-4.4c-1,0.6-2,1.3-3.1,1.9
		c-0.2-0.3-0.4-0.6-0.6-0.9c1.9-1.2,3.7-2.4,5.6-3.5c0.2-0.1,0.5,0.2,0.8,0.2c0.5,0.1,0.9,0.2,1.4,0.3c-0.3-0.4-0.5-0.9-1-1.6
		c2.3-0.9,4.7-1.9,7.1-2.8c0.2-0.1,1,0.9,1,1.4c-0.1,1.1-0.4,2.1-0.7,3.2c0.3,0.1,0.5,0.2,0.8,0.3c0.2-0.7,0.3-1.5,0.6-2.2
		c0.4-0.8,0.9-1.5,1.3-2.3c-0.3-0.2-0.8-0.5-1.4-0.9c4.4-1.7,10.3-1.5,11.9,0.7c0.7-0.9,1.3-1.8,2.1-2.9c0.7,1,1.1,1.5,1.6,2.3
		c0.3-0.5,0.6-1,0.9-1.6c0.2,0.4,0.4,0.8,0.7,1.2c0.4-0.3,0.8-0.6,1.4-1.1c-0.1,1-0.2,1.6-0.3,2.3c-0.6-0.2-1-0.3-1.5-0.5
		c0.6,2.8,2.6,0.7,3.9,1.2c-0.5-0.6-0.9-1.2-1.4-1.8c0.1-0.2,0.2-0.3,0.2-0.5c1.8,0.6,3.6,1.2,4.9,1.6c0.1,1.3,0.1,2.2,0.2,3.1
		c0.3,0,0.6-0.1,0.9-0.1c0-0.5-0.1-1-0.1-2.1c1.3,0.8,2.3,1.4,3.5,2.1c-0.6,0.7-1,1.2-1.3,1.7c0.2,0.1,0.4,0.3,0.4,0.2
		c1.6-1.5,2.8-1.7,4.1,0.6c0.7,1.3,2,2.5,3.3,3.2c2.6,1.3,1.6,2.8,0.9,4.7c0.6-0.4,1.1-0.8,1.8-1.3c0.8,0.9,1.5,1.8,2.3,2.7
		c-0.9,1.5,0,4.7,1.8,5.2c-0.4,0.6-0.7,1.1-0.9,1.4c3.8,2.5,2,6.4,3,9.7c-1.4-0.2-2.5-0.3-4.1-0.5
		C390.8,191.6,391.2,192.1,391.6,192.9z M343.5,184.2c-0.5,1.1-1,1.9-1.5,3c-4.6-3.7-7.9-8.2-10.4-13.8
		C337.1,175.5,338.5,181.7,343.5,184.2z M329.4,173.4c-1.3,0-2.5-0.1-4.4-0.1c2.1-4.2,4-8.1,6-11.9c0.6-1.1,1.5-1.3,2.6-0.6
		c1.8,1.1,3.5,1.6,5.5,0.1c1.1-0.8,2.9-0.7,4.3-1C338.3,164.1,331.1,165.9,329.4,173.4z M338.2,173.5c0.1-0.2,0.2-0.4,0.2-0.6
		c4.3,1.5,8.7,2.9,13,4.5c0.6,0.2,0.9,1.4,1.3,2.1c-0.8,0.1-1.8,0.6-2.4,0.3C346.2,177.8,342.2,175.6,338.2,173.5z M303.4,159.9
		c-4.6-2.1-9.5-4.2-14.4-6.4c0.3-0.3,0.8-0.8,1.4-1.4c-0.8-0.1-1.3-0.1-2.3-0.2c1.5-0.9,2.7-1.6,3.8-2.3c0-0.2-0.1-0.3-0.1-0.5
		c-0.8,0.2-1.6,0.4-2.4,0.6c-0.1-0.1-0.2-0.2-0.2-0.3c1.3-1.2,2.7-2.3,4.3-3.7c-0.6,0-1,0.1-1.4,0.1c-0.1-0.1-0.3-0.3-0.4-0.4
		c1.2-0.8,2.4-1.6,3.5-2.4c-0.1-0.2-0.3-0.4-0.4-0.6c-0.8,0.4-1.5,0.8-2.8,1.4c2.3-3.3,4.2-6.1,6.1-8.8c0.9,0.6,1.4,1,2.3,1.6
		c-1.2,1.1-2.3,2.1-3.3,3c0,0.1,0.1,0.2,0.1,0.2c1.2-0.8,2.5-1.7,3.7-2.5c0.2,0.1,0.3,0.3,0.5,0.4c-0.6,0.8-1.2,1.6-1.9,2.3
		c-0.8,0.9-1.6,1.6-2.8,2.8c1-0.2,1.4-0.3,2.2-0.4c-0.8,1.1-1.4,1.9-2,2.7c0.2,0.1,0.4,0.3,0.6,0.4c0.8-1.8,3.3-2.1,3.3-4.8
		c0-0.9,1.7-1.8,2.4-2.7c0.6-0.8,1.3-1.8,1.6-2.8c0.3-1,0.9-1.8,1.6-2.5v-1.8h0.1c0.5,0.2,0.9,0.5,1.4,0.7c1.2-0.6,2.6-0.8,4.1-0.4
		c-0.1,0.3-0.2,0.6-0.4,0.9c0.1,0,0.3,0,0.4,0.1c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8c0.6,0.1,1.4-0.1,2.1,0.1
		c1.3-1.3,2.6-2.5,4-3.6c1.5-1.1,3.1-1.4,4.8,0.2c0.7,0.7,2,0.9,3.2,1.5c-0.7,0.5-1.3,0.9-2.3,1.7c2.2,0.1,3.7,0.1,5.3,0.2
		c0,0.2,0,0.3,0.1,0.5c-0.5,0.2-1,0.3-1.5,0.5c-1.4,0.5-3,0.7-2.4,3c0.6,2.2,1.8,3.6,3.8,3.5c1.1,0,2.2-0.2,3.5-0.3
		c0.2,0.5,0.3,1,0.6,1.9c2.4-1,4.6-2,6.8-2.9c-0.1-0.2-0.3-0.5-0.4-0.7c-1.6,0.4-3.2,0.9-4.8,1.3c-0.1-0.1-0.1-0.2-0.2-0.3
		c1.1-0.6,2.2-1.2,3.9-2.2c-1.4,0-2.1-0.1-2.9-0.1c-0.1-0.2-0.1-0.4-0.2-0.5c0.9-0.3,1.7-0.7,2.6-0.7c1.5-0.1,3-0.1,4.5-0.1
		c2.8-0.1,5.3-0.2,7.3,2.7c1.3,1.8,3.7,3.1,5.9,4c7.7,3.2,15.5,6.3,23.4,9c5.8,1.9,11.8,2.1,17.4-1.2c2.6-1.5,4.7-3.4,5.6-6.4
		c-3.7,0.2-7,0.4-10.4,0.6c0-0.3,0-0.5-0.1-0.8c2.9-0.4,5.8-0.8,8.7-1.1c2.5-0.2,4.2-1.6,5.8-3.3c0.6-0.6,1.3-1.2,2-2
		c-0.3-0.2-0.8-0.5-1.9-1.1c1.4-0.1,2.3-0.2,3.1-0.2c0-0.1,0.1-0.2,0.1-0.3c-0.9-0.3-1.7-0.6-2.7-1c1-2.3,2.9-1.2,4.6-1.6
		c-0.8-0.3-1.6-0.7-2.4-1c0.1-0.2,0.1-0.4,0.2-0.7c1.2,0.2,2.3,0.4,3.7,0.7c-0.2-0.4-0.3-0.8-0.5-1.2c0.2-0.2,0.3-0.3,0.5-0.5
		c0.7,0.7,2.1,1.3,2.2,2c0.8,7.7,0.3,15.2-5,21.5c-0.5,0.7-1.4,1-2.1,1.6c-0.1-0.1-0.3-0.3-0.4-0.4c0.3-0.3,0.5-0.7,0.8-0.9
		c0.4-0.3,0.8-0.6,1.5-1.1c-0.8-0.1-1.2-0.1-1.8-0.1c0.3-0.5,0.6-0.9,0.9-1.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4,0.2-0.8,0.3-1.1,0.6
		c-3.7,3.1-7.6,5.8-12.4,7c-6.2,1.5-12-0.3-17.8-2c-8.8-2.6-16.6-6.9-23.5-13c-0.2-0.2-0.5-0.3-1.3-0.7c0.8,3.3,3,4.8,5,6.4
		c2,1.6,4,3.3,6.4,5.3c-3.2,0.1-5.9,0.3-8.6,0.4c-9.6,0.3-19.2,0.3-28.5-2.4c-2.1-0.6-4-1.5-6-2.4c-0.5-0.2-0.7-1-1.1-1.8
		c-0.2,0.1-0.8,0.2-1.6,0.4c0.2-0.8,0.4-1.4,0.7-2.4c-0.9,0.4-1.4,0.7-2.3,1.1c0.4-0.9,0.7-1.5,1.1-2.3c-0.6-0.3-1.2-0.6-1.9-0.9
		c-0.4,0.6-0.8,1.2-1.3,1.7c-0.9,0.9-1.9,1.8-2.8,2.7c-1.5,1.4-3.2,2.6-4.4,4.3C306.1,154.8,304.9,157.3,303.4,159.9z M313.1,164.8
		c-0.3,0.3-1.3,0.4-1.7,0.1c-2-1.3-4-2.8-6.4-4.4c1.2-0.6,2.4-1.3,3.8-2c0-0.1-0.2-0.4-0.4-0.9c0.8-0.1,1.5-0.2,2.5-0.3
		c-0.4-0.6-0.6-0.9-1-1.5c1.1,0,2.1-0.1,3.4-0.1c-0.4-0.5-0.6-0.8-1.1-1.3c1.1-0.7,2.2-1.4,3.3-2.1c0-0.2-0.1-0.3-0.1-0.5
		c-1.3,0.3-2.6,0.6-3.9,0.9c1.7-3.4,4.8-3.6,9.8-0.5c-2.6,0.3-2.6,2-2.7,3.8C318.2,159.9,315.7,162.4,313.1,164.8z M317.7,170.3
		c2.4-5.1,4.7-10.2,7.3-15.8C325.9,157.4,320.5,169.1,317.7,170.3z M334.3,218.8c-0.6,2.1-3.1,1.4-4.8,1.2c-0.7-0.1-1.3-0.5-1.9-0.8
		c0.1-1,0.3-2,0.4-3c-2.7,0.9-5.5,1.9-8.3,2.9c-0.1-0.2-0.2-0.3-0.3-0.5c1.1-2,2.2-3.9,3.1-5.9c2.3-4.7,3.1-9.5,1.3-14.6
		c-0.2-0.5-0.2-1.1,0-1.6c2.9-6,2.1-12.1,0.2-18.1c-0.3-0.9,0-2.4,0.6-3.1c0.6-0.7,1.9-1.2,2.5,0.6c0.1,0.3,1.6,0.1,2.3,0.4
		c2.7,1.2,2.9,3.8,3,6.3c0.1,1.1,0,2.2-0.1,3.3c0.2,0,0.4,0,0.6,0c0.3-1.5,0.6-3.1,0.8-4.2c1.5,1.3,3.2,2.8,4.6,4
		c-1.4,3-2.7,5.5-3.7,8.2c-2.5,6.8,0.3,12.5,3.9,18c1.2,1.8,0.8,3.8-1.4,4.3C335.6,216.5,334.8,217,334.3,218.8z M342.8,224.1
		c-1.9-1.7-3.8-3.3-5.7-5c0.2-0.2,0.3-0.4,0.5-0.6c2.5,0.9,4,3.1,5.8,4.9C343.2,223.6,343,223.8,342.8,224.1z M342.4,220
		c-1.1-0.6-2-1.6-3.2-2.6c1.6-2.2,3-4.2,4.5-6.1c1.2-1.5,2.4-0.6,3.5,0.1c1.2,0.8,1.1,1.8,0.4,2.9c-1.1,1.8-2.2,3.7-3.5,5.4
		C344,220,342.9,220.2,342.4,220z M344.7,222.2c-0.5-1-0.2-1.7,2.6-5.5c0.7,0.2,1.4,0.5,2.1,0.8C347.8,219,346.3,220.6,344.7,222.2z
M369.2,211.1c-4.7,1.6-9.4,3-14.2,4.1c-1.9,0.4-4-0.2-6.7-0.4c1.9-1.9,2.1-3.1,0.6-4.4c-2.1-1.9-3.6-2-6.7-0.2
		c-7-4.6-6.7-14.6-2.5-21.8c1.2-0.2,2.7,0,3-0.5c1-1.6,3.3-3,1.7-5.4c1.7-1.8,3.4-2.9,6.1-1.7c0.9,0.4,2.7-0.4,3.8-1.2
		c0.4-0.3,0.1-1.7,0.2-2.7c5.5-2.7,22.4,3.7,25.4,10c-0.9,0.1-1.7,0.2-2.5,0.3c-0.6,4.4,0,5.4,3.9,7.1c-0.1,1.1-0.1,2.3-0.3,3.4
		c-0.2,1.1-0.5,2.2-0.8,3.6c-1.8-0.7-3.2-1.2-4.1,0.9c-0.7,1.7-1.5,3.3,1.8,4.6C374.4,208.5,371.9,210.1,369.2,211.1z M388.3,214
		c-2.4-4.8-6.7-7.3-11.4-9.2c0.5-2,1.4-2.7,3.3-1.9c3.5,1.5,6.6,3.4,8.9,6.5C390.5,211.3,390,212.5,388.3,214z M391.6,209.4
		c-3.4-2.7-6.7-5.3-10.1-8c0.1-0.3,0.4-1,0.7-2c0.4,0.5,0.5,0.9,0.8,1c0.5,0.2,1.1,0.1,1.6,0.1c-0.2-0.4-0.4-0.8-0.7-1.2
		c-0.1-0.2-0.4-0.3-0.5-0.5c-0.3-0.4-0.6-0.9-0.9-1.4c0.5,0.1,1.1,0,1.6,0.3c1.1,0.7,2.2,2.2,2.9-0.4c0-0.1,0.5,0,0.8,0
		c-0.1,0.5-0.2,1.1-0.3,2c2.8-0.8,3.7,1.5,5.2,2.7c0.3,0.3,0.6,0.8,0.5,1.2C392.8,205.3,392.1,207.4,391.6,209.4z M385.2,194.6
		c-1.3-0.7-2.7-1.5-4.2-1.8c-2.5-0.6-2.4-2.3-2.3-4.6c2.8,1.2,5.5,2.2,8.1,3.5c2,1,3.8,2.4,5.7,3.4c1.9,1.1,2.2,2.5,1.4,4.7
		C390.9,197.9,388.1,196.2,385.2,194.6z M395.1,204.9c-0.2-0.1-0.5-0.2-0.7-0.2c0.4-1.8,0.8-3.7,1.4-5.5c2.1-6.3,4.6-12.6,6.5-18.9
		c0.8-2.5,0.5-5.4,0.2-8.1c-0.2,7.5-4.4,13.7-6.3,20.6c-0.3-0.1-0.6-0.2-0.8-0.3c1.3-4.3,2.6-8.6,4-12.9c-0.2-0.1-0.3-0.1-0.5-0.2
		c-0.8,1.9-1.6,3.9-2.3,5.8c-0.2-0.1-0.3-0.1-0.5-0.2c0.5-1.5,1-3.1,1.4-4.6c-0.2-0.1-0.5-0.2-0.7-0.2c-0.5,1.3-1.1,2.7-1.6,4
		c-2.8-4.1-2.7-6.7,1.3-9.4c3.6-2.4,7.6-4.3,11.5-6.4c1.7,2.9,1.3,5.4,0,7.6c-3.1,5.1-4.6,10.6-5.4,16.4
		C401.9,197.5,398.1,201,395.1,204.9z M412.2,173.8c-2.8,6.4-4.3,13.1-5.7,19.9c-1,4.8-4.2,8.2-8.7,10.1c0.8-1.1,1.3-1.9,2-2.7
		c3.1-3.7,5-7.8,5.9-12.6c0.7-3.6,2.2-7.1,3.6-10.6c1.2-2.9,2.1-5.8,1.6-9c-0.1-0.7,0.4-1.4,0.8-2.7
		C413.6,169.2,413.1,171.7,412.2,173.8z M451.3,169.7c0.1-1.7,0.1-2.9,0.1-4.1c-1.4,1.9-0.9,4.6-3.6,6.2c0.3-1.3,0.4-2.2,0.7-3.6
		c-1.8,2.4-3.3,4.4-4.8,6.3c-0.3-0.2-0.5-0.3-0.8-0.5c0.1-0.6,0.2-1.2,0.3-1.9c-0.1-0.1-0.2-0.3-0.4-0.4c-1.2,1.6-2.4,3.3-3.7,4.9
		c-0.3-0.3-0.7-0.6-1-0.9c0.1-0.7,0.3-1.4,0.5-2.5c-1.5,1.5-2.8,2.7-4.1,4c-0.2-0.1-0.4-0.3-0.6-0.4c0.3-0.9,0.7-1.8,1.2-3.1
		c-2.5,1.4-3,4.6-6.4,4.3c0.9-1.4,1.6-2.6,2.4-3.8c-0.1-0.1-0.3-0.2-0.4-0.3c-1.5,1.5-3,3.1-4.4,4.6c-0.1-0.1-0.3-0.2-0.4-0.3
		c0.6-1.1,1.1-2.3,1.7-3.4c-0.1-0.1-0.3-0.2-0.4-0.3c-1.2,1.4-2.4,2.8-3.6,4.2c-0.2-0.1-0.3-0.2-0.5-0.3c0.5-1.3,1-2.6,1.5-3.9
		c-0.1-0.1-0.3-0.2-0.4-0.2c-1,1.4-2.1,2.7-3.1,4.1c-0.2-0.1-0.4-0.2-0.6-0.3c0.9-1.6,1.8-3.2,3-5.3c-1,0.5-1.5,0.8-1.9,1
		c-0.1-0.1-0.3-0.3-0.4-0.4c2.2-2.6,4.3-5.3,6.5-7.8s5.5-3.9,6.9-7.2c-0.2-0.2-0.3-0.3-0.5-0.5c-0.8,0.9-1.5,1.8-2.5,2.8
		c0-0.8-0.1-1.3-0.1-2.1c-1.2,1.5-2.2,2.7-3.2,4c-0.1-0.1-0.2-0.1-0.3-0.2c0.2-0.7,0.4-1.3,0.6-2c-0.1-0.1-0.3-0.2-0.4-0.3
		c-0.8,1.1-1.6,2.2-2.5,3.5c0-0.7-0.1-1.1-0.1-2.2c-1.2,1.9-2.1,3.3-3,4.7c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.8,0.2-1.5,0.4-2.3
		c-0.1-0.1-0.3-0.1-0.4-0.2c-0.7,1.2-1.5,2.4-2.5,4.2c0-1.2,0.1-1.8,0.1-2.4c-0.1,0-0.3-0.1-0.4-0.1c-0.7,1.3-1.4,2.6-2.2,4
		c-0.2,0-0.3-0.1-0.5-0.1c0-0.7,0-1.3,0-2c-0.1,0-0.2-0.1-0.4-0.1c-0.5,1.1-1,2.1-1.7,3.5c-0.5-1.5-0.9-2.7-1.4-4
		c0.4-0.3,0.9-0.8,1.4-1c6.8-3.8,13.6-7.7,20.6-11.2c2.6-1.3,5.3-1.7,8,0.5c1.6,1.3,3.8,1.9,5.7,2.9
		C454,160.2,454.9,164.7,451.3,169.7z M453.4,144.6c-5.6,2.1-11.5,3.7-16.4,6.9c-5.1,3.4-9.9,2.1-14.8,1.1c-1.1-0.2-2.2-1.8-2.6-3
		c-0.2-0.7,0.9-1.8,1.5-2.8c0.2,0.1,0.4,0.1,0.7,0.2c0.3,2.8,3,1.3,4.5,2.5c-0.8,0.3-1.4,0.6-2,0.9c2.7,0.8,5.2,0,7.3-1.5
		c4.7-3.3,9-7.1,13.6-10.5c2.4-1.8,4.9-3.3,7.5-4.9c0.3-0.2,0.7,0,1.3,0c-1.2,2.6-5,3.3-4.9,6.8c2.7-0.6,5.1-1.1,7.6-1.6
		c2.7-0.5,4.6,0.4,5.2,3.6C459,143.1,456.1,143.6,453.4,144.6z M470,189.7c0.4-0.5,0.7-0.3,1-0.1C470.6,189.7,470.3,189.7,470,189.7
		z M470.4,151c-2-1.3-3.8-2.8-4.9-5.2c-2.8-5.8-5.2-11.6-6.4-17.9c-0.6-2.9-0.9-5.7,1.9-7.9c0.4,1.7,0.8,3.4,1.2,5
		c-0.3-0.1-0.9-0.2-1.9-0.4c0.3,0.6,0.4,1.1,0.6,1.2c1.8,1.4,2.4,4.2,2,6.3c-0.3,1.9-0.3,4,0.4,5.8c1.1,2.7,2.7,5.1,4.2,7.6
		c1.1,1.7,2.4,3.1,3.6,4.7C470.9,150.5,470.7,150.8,470.4,151z M499.8,138.8c-1,2.3-2.1,4.4-3,6.7c-1,2.3-3.6,3.1-5.7,1.5
		c-1.8-1.4-3.4-2.9-5-4.4c-1.1-1-0.5-1.6,0.5-2.1c0.8-0.4,1.5-0.8,2.6-1.4c-2.2-0.8-5,0.2-5.4,1.7c-0.2,0.6,0.4,1.5,0.8,2
		c0.6,0.8,1.3,1.4,2,2s1.4,1.3,2.2,1.9c-0.9,0.7-1.5,1.2-2.6,2.1c1.5,0.3,2.5,0.4,3.5,0.6c0,2-0.9,3-2.8,2.5
		c-2.9-0.7-6.1-0.8-8.5-3.2c-1-1-2.5-1.5-3.8-2.3c-0.1,0.2-0.3,0.4-0.4,0.6c1.9,1.7,3.8,3.3,5.9,5.2c1.3,0.3,3.1,0.6,4.9,1
		c0,0.3,0,0.7,0,1c-1.3,0.1-2.9,0.6-4,0.2c-3.3-1.3-7-2.1-8.7-6c-0.9-2-2.7-3.5-4-5.3c-1-1.3-1.6-2.7,0.9-3.9
		c-1-0.3-1.5-0.4-2.9-0.8c2-0.9,3.4-1.5,5.2-2.3c-1-0.2-1.7-0.3-3.1-0.5c3.3-1,5.9-1.7,9.2-2.7c-3.3-2.6-6.5-5.1-4-9.3
		c0.8-1.4,2.1-2.6,3.6-4.3c0.6,1.1,1,1.7,1.4,2.5c0.6-0.8,1-1.4,1.6-2.1c0.1,0.5,0,0.9,0.2,1.1c2.3,2.3,4.4,4.7,7.7,6.1
		c4,1.7,7.8,4,11.4,6.4C501.3,134.6,500.6,136.9,499.8,138.8z M516.6,124.7c-2,2.3-4,4.8-6.4,6.7c-1.4,1.2-3.6,1.6-5.4,2.3
		c-0.2,0.1-0.6,0-0.7-0.2c-1.2-2.3-3.5-1.6-5.3-2.2c-0.9-0.3-1.5-1.5-2.2-2.3c-0.8-0.8-1.5-1.7-2.4-2.1c-2.3-1.2-4.7-2.1-7-3.2
		c-0.8-0.4-1.5-0.9-2.1-1.5c-1.3-1.4-1.4-2.5,1-2.6c-0.2-1.5-0.4-2.8-0.5-4.1c0.1,0,0.2-0.1,0.4-0.1c0.3,0.8,0.6,1.6,0.8,2.4
		c0.2,0,0.3-0.1,0.5-0.1c-0.5-3.9-1-7.9-1.5-11.8c-0.3-0.1-0.6-0.2-0.9-0.3c-1.5,2.4-3.3,4.8-4.4,7.4c-0.9,2-1.8,3.5-3.9,4.4
		c-1.1,0.4-2,1.5-3.1,2.2c-0.3,0.2-0.9,0.1-1.7,0.1c-0.4,1.3-0.9,3-1.4,4.7c-0.2,0-0.4-0.1-0.5-0.1c0-0.6-0.1-1.3-0.1-2.2
		c-0.6,0.7-1,1.1-1.4,1.5c-2.3-2-2.3-3-0.1-4.8c2.1-1.6,4.3-3.1,6.3-4.8c2.9-2.6,5.7-5.3,8.6-7.9c1-0.9,2.2-1.4,3.5-2.3
		c0.3,2.8,0.4,4.8,0.7,6.9c0.3,2,0.8,4,1.8,6c-0.2-1.7-0.3-3.4-0.5-5.1c0.2-0.1,0.3-0.3,0.5-0.4c1.6,1.4,3.2,2.7,5.4,4.6
		c-0.5-1.1-0.7-1.6-1-2c-1.8-2.5-2.8-5.1-2.2-8.2c0.1-0.5,0.8-1.3,1.3-1.3c2.3-0.2,4.7-0.5,6.9,0c1.2,0.3,2.2,2.1,3,3.3
		c2.8,4.5,7,7.7,11.2,10.7c1.5,1.1,3.7,1.5,5.9,2.3C518.7,121.8,517.8,123.4,516.6,124.7z M522.1,115.2c-1.2-1.2-2.2-2.5-3.6-4.1
		c1.8-0.6,2.9,0,3.7,1.2c0.3,0.5,0.7,1,1,1.6c0.3,0.5,0.5,1,0.8,1.5C523.3,115.4,522.5,115.5,522.1,115.2z M525.3,96.9
		c-0.3,2.4-0.4,4.8-0.7,7.1c-0.2,1.7-1.1,2.9-3.1,2.4c-1.9-0.5-3.8-1.1-5.4-1.6c0.8-4.5,1.5-8.9,2.3-13.6c1.7,0.6,3.3,1,4.7,1.8
		C524.6,93.7,525.5,95,525.3,96.9z M523.9,83.4c0.2-1.4,0.3-2.8,0.5-4.2c0.3,0,0.6,0,0.8,0c0.1,1.4,0.1,2.8,0.2,4.2
		C524.9,83.4,524.4,83.4,523.9,83.4z M530.3,102.1c0.2,1.5,0,3.4-0.8,4.5c-0.6,0.7-2.6,0.2-3.7,0.2c0.4-4.4,0.8-8.3,1.2-12.3
		c0.7-0.2,1.7-0.5,3.2-0.9c0.2,1.9,0.3,3.5,0.5,5.1c-1.2,0.4-2,0.7-2.9,1C528.8,100.6,530.2,101.3,530.3,102.1z M535.1,79.4
		C535.1,79.4,535.1,79.3,535.1,79.4C535.2,79.3,535.2,79.3,535.1,79.4C535.2,79.3,535.1,79.4,535.1,79.4z M542.6,70.7
		c0-0.2-0.1-0.4-0.1-0.5C542.9,70.3,543.1,70.4,542.6,70.7z M548.2,163.1c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7
		c-0.9,0.2-1.7,0.4-2.9,0.6c0.9-0.9,1.5-1.5,2.1-2.1c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3
		C548.9,163.6,548.6,163.3,548.2,163.1z M549.7,164.7l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2C549.8,164.7,549.8,164.7,549.7,164.7z
M560.8,168.3L560.8,168.3L560.8,168.3C560.8,168.2,560.8,168.3,560.8,168.3z M560.8,166.1C560.8,166.1,560.7,166,560.8,166.1
		c0-0.1,0-0.1,0.1-0.1l0.1,0.1C560.9,166.1,560.8,166.1,560.8,166.1z M561.8,165.8C561.9,165.7,561.8,165.7,561.8,165.8
		C561.9,165.7,561.9,165.7,561.8,165.8C561.9,165.7,561.9,165.7,561.8,165.8z M564.3,167.2c0-0.6,0-1.1,0.1-1.8
		c0.7-0.5,1.2-0.3,1.5,0.3C565.3,166.3,564.8,166.8,564.3,167.2z M567.9,159.9c-1.6,0.5-2.2,1.5-2.1,2.9c0,0.1-0.1,0.3-0.2,0.5
		c-1.6,0.2-2.7,1-3.4,2.2c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2c0.3-1,0.5-2,2-2.4c0.7-0.2,1.3-0.8,1.9-1.3
		c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.3,0.9-0.2,1.4-0.2
		C568.5,159.2,568.5,159.7,567.9,159.9z M568.6,70.8c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1c0.7,0.1,1.2,0.2,1.6,0.3
		c-0.7,0.6,0.1,0.4,0.5,0.6C569.8,70,569.3,70.3,568.6,70.8z M600.6,170.2c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.1-0.4-0.2-0.5C600.5,170.3,600.5,170.3,600.6,170.2z M611.7,59.2c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2
		c-0.1,0.1-0.3,0.1-0.4,0.2C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st3"
        d="M505.8,190.1c0.1,0,0.2,0.1,0.2,0.1c-0.1-0.8-0.3-1.4-0.4-2c-0.1-0.1-0.2-0.1-0.3-0.3c0.1,0,0.1-0.1,0.2-0.1
		c-0.1-0.4-0.1-0.7-0.2-1.1c-1.4,0.7-1.7,0-1.9-1.1c-0.6,0.1-0.8,0.3-1.2,1.2l0.1,0.1c1.1,0.9,2.1,1.2,2.9,1
		C504.8,189.2,505,189.8,505.8,190.1L505.8,190.1z"
      />
      <path
        class="st3"
        d="M506.1,190.2c0.8,0.3,1.3,0.5,1.7,0.6c-0.1-0.7-0.1-1.5-0.2-2.5c-0.1,0-0.2,0.1-0.3,0.1
		C507,189,506.7,189.4,506.1,190.2z"
      />
      <path
        class="st3"
        d="M505.3,146.2c-0.3,0.1-0.6,0.3-1,0.4c0.9,2,1.7,4,2.6,6c0.3-0.1,0.6-0.3,0.9-0.4
		C507,150.2,506.2,148.2,505.3,146.2z"
      />
      <path
        class="st3"
        d="M450.4,198.6c-0.4-0.8-1.2-1.3-2.2-1.5c-1,1.6-2,3.3-3,5h0.1c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7
		C450.6,200.8,450.9,199.6,450.4,198.6z"
      />
      <path
        class="st3"
        d="M271.4,243.3c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.3-0.1-0.5-0.2-0.8C271.4,242.5,271.5,242.8,271.4,243.3z"
      />
      <path
        class="st3"
        d="M207.2,247.9c-0.2,0.5-0.2,1,0.1,1.6c0.2-0.1,0.3-0.2,0.5-0.3C207.6,248.8,207.4,248.4,207.2,247.9z"
      />
      <path
        class="st3"
        d="M420.6,57c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3
		c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6
		c0.2,0.2,0.3,0.5,0.3,0.8c0.6-0.2,1.3-0.4,1.9-0.5c0-0.1,0-0.2,0-0.2c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7
		c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.1-0.1-0.5,0.1-0.7,0.1
		c-0.8,0.1-1.2-0.1-1.2-0.7c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4
		c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1C421.4,57.7,421.2,57.3,420.6,57z
		"
      />
      <path
        class="st3"
        d="M127,286.5c0.3-0.3,0.5-0.5,0.7-0.8c-0.2-0.3-0.5-0.6-0.7-0.9c0,0,0-0.1-0.1-0.1
		C126.9,285.3,126.9,285.9,127,286.5z"
      />
      <path
        class="st3"
        d="M380.5,112.9c-0.2-0.2-0.4-0.4-0.6-0.5c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-1,0.3-1.4,0.7
		c-0.5,0.5-0.8,1.1-1.8,0.8c0,0.2,0.1,0.4,0.1,0.6C377.4,113.9,378.9,113.4,380.5,112.9z"
      />
      <path
        class="st3"
        d="M85.5,305c0,0,0.1,0,0.1,0.1c0.2-1.3,0.8-2.7,1.6-3.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.3-0.4-0.6-0.5-0.9
		c0-0.1,0-0.2,0-0.4c-0.8,1-1.5,2-2.1,3.1c-0.9,1.4-2.5,2.8-4.2,3.5C81.9,306.6,83.7,306,85.5,305L85.5,305z"
      />
      <path
        class="st3"
        d="M511.4,73.4c0.2-1,0.5-2,0.8-3.3c-0.7-0.4-1.5-0.9-2.5-1.3c-0.3-0.1-0.9,0.1-1.3,0.3c-0.1,0.1-0.1,0.8,0.1,1
		C509.5,71.3,510.5,72.4,511.4,73.4z"
      />
      <path
        class="st3"
        d="M451.4,127c-2.1,0.2-4.2,0.4-6.3,0.6c0,0.3,0.1,0.6,0.1,0.9c2.1-0.3,4.2-0.6,6.3-0.9
		C451.4,127.4,451.4,127.2,451.4,127z"
      />
      <path
        class="st3"
        d="M546.3,204.4c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8
		c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9c1.1-0.8,1.1-0.7,3.4,0
		c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6s-1.3,0.5-1.8,0l0,0l0,0
		c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4
		c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3V188c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4l-0.1-0.1
		c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9
		c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0
		c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2
		c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2
		c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6
		c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7
		c-0.2,0.5-0.3,0.9-0.5,1.4c-0.1,0-0.2-0.1-0.3-0.1c1.8,6.8,4.8,13.1,8.9,19c0.6,0.9,1.1,1.8,1.6,2.8c0.2-0.1,0.4-0.2,0.7-0.3
		c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9
		c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1
		c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.2-0.1,0.7-0.5,0.9-0.5c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6c0.2,0.2,0.7,0.1,1.2,0.1
		C547.8,205.4,547.5,204.6,546.3,204.4z"
      />
      <path
        class="st3"
        d="M140.9,214.1c5.9,0.4,11.8,0.8,17.8,1.3C156.2,213.6,144.3,212.8,140.9,214.1z"
      />
      <path
        class="st3"
        d="M244.5,192c0.1-2.3,0.1-4.6,0.2-6.9c-0.2,0-0.4,0-0.6,0c-0.1,2.3-0.1,4.6-0.2,6.9
		C244.1,192,244.3,192,244.5,192z"
      />
      <path
        class="st3"
        d="M465.8,77.3h0.1c0.1-0.1,0.1-0.2,0.2-0.3C466,77.1,465.9,77.2,465.8,77.3z"
      />
      <path
        class="st3"
        d="M310,121.1c0,0,0-0.1-0.1-0.1c0,0.1,0,0.1-0.1,0.2C309.9,121.1,310,121.1,310,121.1z"
      />
      <path
        class="st3"
        d="M90.8,303c0,0.3-0.1,0.6-0.1,0.9h0.1C90.8,303.6,90.9,303.3,90.8,303L90.8,303z"
      />
      <path
        class="st3"
        d="M98.6,304c-0.7-0.1-1.5-0.2-2.2-0.3c0.2,0.1,0.5,0.2,0.8,0.3C97.6,304.1,98.1,304.1,98.6,304z"
      />
      <path
        class="st3"
        d="M299.5,125.6c-0.1,0.1-0.1,0.3-0.1,0.4c0.8-0.5,1.6-1,2.4-1.5C300.9,124.7,299.9,124.8,299.5,125.6z"
      />
      <path
        class="st3"
        d="M506.6,70.1c-1.1-0.5-1.8-0.9-2.7-1.4c0,1.4,0,2.4,0.1,4.3C505.1,71.8,505.8,71,506.6,70.1z"
      />
      <path
        class="st3"
        d="M461.3,90.9c-0.5-0.3-2.2,0.7-2.5,1.4c-0.5,1.2-0.2,2.7-0.3,4.1c1.4-0.1,2.7-0.2,4.3-0.3
		c0,0.1,0.1,0.7,0.2,1.3c-0.2-0.2-0.3-0.4-0.5-0.6c-1.3,0.7-2.7,1.4-4,2.1c0.6,1,1.1,2.7,1.9,2.9c2,0.5,2.7-1,2.8-2.2
		c1.9-0.9,3.4-1.5,4.7-2.3c0.3-0.2,0.1-1.8-0.3-2c-1.3-0.8-2.7-1.3-4-1.8C463,92.6,462.3,91.3,461.3,90.9z"
      />
      <path
        class="st3"
        d="M145.5,285.3c0,0-0.1-0.1,0-0.1c2.2-4.5,3.6-9.6,7.5-13c-0.9,0.2-1.6,0.2-2.3-0.2c-3.3,3.9-5.9,8.3-8.1,13.1
		c0.3,0.2,0.7,0.4,1.2,0.4C144.5,285.5,145,285.5,145.5,285.3z"
      />
      <path
        class="st3"
        d="M165.7,256.9C165.7,257,165.7,257,165.7,256.9c0.6,1,1.3,1.9,2,2.9c-0.4,0.1-0.7,0.3-1.1,0.5
		c0.8,0.4,1.9,0.2,2.8-0.3c0.2-0.1,0.4-0.2,0.5-0.3c0.8-0.4,1.7-0.7,2.6-1c0.2-0.3,0.4-0.6,0.4-1c0,0,0,0,0-0.1s0-0.2-0.1-0.3
		c-1,0.4-1.9,0.7-2.9,1c-0.7,0.2-1.8,0.2-2.1-0.3c-0.5-0.6-0.9-1.2-1.4-1.8C166.3,256.4,166,256.7,165.7,256.9z"
      />
      <path
        class="st3"
        d="M163.7,262.5c0-0.3-0.1-0.5-0.2-0.7c-4.5,2.3-8.2,5.2-11.4,8.6c0.3,0.1,0.7,0.2,1.1,0.2c1.6,0.1,3-0.8,3.5-2.2
		c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6c0,0.3,0,0.7,0,1c1.9-1,3.7-2,5.6-3.1c0.7-0.4,1.4-0.8,2-1.4
		c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5,0.2-1.1,0.3-1.8,0.5c0.4-0.4,0.7-0.7,1.1-1C164,263.4,163.7,263.1,163.7,262.5z"
      />
      <path
        class="st3"
        d="M461.3,72.1c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.2c0.3,0,0.6,0.1,0.9,0.1
		C461.4,73.4,462,72.6,461.3,72.1z"
      />
      <path
        class="st3"
        d="M154.7,261.1c0.2-0.2,0.3-0.5,0.5-0.7h-0.1C154.9,260.7,154.8,260.9,154.7,261.1z"
      />
      <path
        class="st3"
        d="M153.1,258.3c0.2,0.4,0.5,0.6,0.9,0.8c0.3-0.4,0.7-0.7,1-1.1c-0.1-0.1-0.1-0.3-0.2-0.4
		C154.2,257.9,153.7,258.1,153.1,258.3z"
      />
      <path
        class="st3"
        d="M499,70.2c1.3,0,2.1,0.1,3.1,0.1c-0.4-1.4-0.7-2.5-1.1-3.9c-0.7,0.1-1.4,0.2-2.8,0.4c1,0.7,1.5,1,1.9,1.3
		C499.7,68.8,499.4,69.3,499,70.2z"
      />
      <path
        class="st3"
        d="M145,264.6c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5
		c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0c0.7-2.1,2.1-3,4-2.5c0.2,0.1,0.5,0.2,0.6,0.4c0.2-0.2,0.5-0.4,0.7-0.6
		c0-0.2-0.1-0.3-0.1-0.5c-1.5,0.1-3,0.1-4.5,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c0.6-0.2,1.2-0.4,1.7-0.7c-0.1-0.2-0.2-0.4-0.4-0.6
		c-1.1,0.3-2.2,0.6-3.3,0.8c-0.1-0.1-0.1-0.3-0.2-0.4c0.4-0.5,0.9-0.9,1.3-1.4c0-0.1-0.1-0.2-0.1-0.4c-1.2,0.4-2.5,0.9-3.7,1.3
		c-0.1-0.1-0.2-0.3-0.2-0.4c0.5-0.4,1-0.9,1.5-1.2c-0.8-0.2-1.6-0.2-2.3-0.3c-0.4,0.1-0.8,0.3-1.1,0.4c-0.5,0.2-0.8,0.6-0.4,1
		c0.3,0.4,0.2,0.6-0.1,1c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2
		c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9
		c-0.6-0.6-0.4-1.7-1.6-2.1c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,1.3,1.3,2.3,1.1,3.7C143.6,264.8,144.5,264.9,145,264.6z"
      />
      <path
        class="st3"
        d="M82.2,295.9C82.2,295.9,82.1,295.9,82.2,295.9c-0.1-0.1-0.1-0.1-0.2-0.2s-0.1-0.2-0.3-0.3
		c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6c-0.4,0.9-0.8,1.9-1.3,3.1c1.8-0.9,3.2-1.7,4.9-2.6
		C82.5,296.4,82.3,296.2,82.2,295.9z"
      />
      <path
        class="st3"
        d="M148.5,243.3c-6.7-1.2-12.6,1-18.5,3.3c0.1,0.3,0.2,0.6,0.2,0.8C136.3,246,142.4,244.7,148.5,243.3z"
      />
      <path
        class="st3"
        d="M290.9,167.1c-1.4-1.2-2.7-2.4-3.9-3.5c1,1.3,2.1,2.8,3.2,4.2C290.4,167.6,290.7,167.4,290.9,167.1z"
      />
      <path
        class="st3"
        d="M241.8,192.2c0.1-3.8,0.2-7,0.3-10.4C240.3,184.8,240.1,189.3,241.8,192.2z"
      />
      <path
        class="st3"
        d="M324.3,116.5c-0.4,0.3-0.9,0.6-1.2,1c2.2-0.5,4.3-1.1,6.5-1.7c1.3-0.4,2.6-0.8,3.9-1.3c-0.1-0.3,0-0.7,0.3-1
		s0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9
		c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6
		c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2C325.6,115.5,325.1,116,324.3,116.5z"
      />
      <path
        class="st3"
        d="M121.5,238.6c6.2-1.6,12.4-3.2,18.8-4.9C135.6,232.6,122.6,236.1,121.5,238.6z"
      />
      <path
        class="st3"
        d="M536.8,201.2C536.9,201.2,536.9,201.2,536.8,201.2C536.9,201.1,536.9,201.1,536.8,201.2L536.8,201.2z"
      />
      <path
        class="st3"
        d="M612,20.2c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.2C612.1,20.1,612,20.1,612,20.2z"
      />
      <path
        class="st3"
        d="M412.1,230.3c0.2,0,0.3,0.1,0.5,0.1c-0.1-0.1-0.2-0.3-0.4-0.4C412.3,230.1,412.2,230.2,412.1,230.3z"
      />
      <path
        class="st3"
        d="M419.8,238.9c-0.5,1.2-1,2.4-1.7,3.4c-0.2,0.3-0.3,0.5-0.4,0.8c1.5-0.6,2.5-1.8,2.4-3.1c0-0.1,0-0.2,0-0.4
		C420.1,239.4,419.9,239.2,419.8,238.9z"
      />
      <path
        class="st3"
        d="M405.5,237.2c-0.6,0.5-0.4,1.2,0.3,1.3c0.9,0.1,1.4,0.6,2,1c0.4,0.3,0.8,0.5,1.3,0.6c-0.8-1.6-1.2-3.2-1.3-4.8
		C407.1,235.9,406.3,236.6,405.5,237.2z"
      />
      <path
        class="st3"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9l-0.1-0.1
		c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2c-1.3,1.2-1.3,1.2-0.5,2.5
		c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6
		c0.7-0.3,0.5-0.8,0.4-1.2C393.2,255,393.1,254.5,393,254z"
      />
      <path
        class="st3"
        d="M473.4,207.8c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5s-0.2-0.4-0.3-0.5
		c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9c-0.5-0.1-1.1,0-1.6,0.1C474.1,204.4,473.1,205.8,473.4,207.8z"
      />
      <path
        class="st3"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z"
      />
      <path
        class="st3"
        d="M408.3,241.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.7-0.1-1.4,0-2c0.2,0.2,0.4,0.3,0.7,0.5v-0.1
		c0-0.1,0-0.3-0.1-0.4C408.6,241.6,408.5,241.3,408.3,241.1z"
      />
      <path
        class="st3"
        d="M478.4,199.1c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C476.3,198.2,477.2,198.9,478.4,199.1z"
      />
      <path
        class="st3"
        d="M457.2,271.2c-0.1,0.2-0.1,0.4-0.2,0.7c-0.2-0.5-0.5-1-0.7-1.5c-0.6-0.3-1.3-0.4-2.1-0.3
		c-0.6,0.1-1.2,0.4-1.6,0.7c0.1,0.1,0.1,0.2,0.2,0.3c0.7-0.3,1.2-0.5,1.8-0.8c0.6,0.4,1,1.3,1.5,1.9h1.4c0-0.1,0-0.2,0-0.3
		C457.5,271.6,457.3,271.4,457.2,271.2z"
      />
      <path
        class="st3"
        d="M551.9,169.3c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.3,1.1,0.8,1.9,2.1,2.2
		c1.4,0.3,2.1-0.5,3.1-1.2c0.1,0.5,0.3,1,0.7,1.3c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5
		c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0
		c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.8,0.1-1.5,0.4-2.4,1.1C553.2,169.9,552.3,169.7,551.9,169.3z"
      />
      <path
        class="st3"
        d="M492.3,189.1c1.1,0.4,2.6,0,3.4-0.8s1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C490.5,187.7,491.1,188.7,492.3,189.1z"
      />
      <path
        class="st3"
        d="M496.5,189c-0.8-0.1-1.5,0.1-2,0.7c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3
		c0.3,0.4,0.5,0.8,0.8,1.2c0.3,0,0.7-0.1,1-0.1c-0.5-1.2-1-2.5-1.5-3.7C497.4,189.1,497,189,496.5,189z"
      />
      <path
        class="st3"
        d="M397.6,239.9c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C398.4,237.5,397.4,238.7,397.6,239.9z"
      />
      <path
        class="st3"
        d="M494.2,196.5c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C494.2,197.5,494.4,196.9,494.2,196.5z"
      />
      <path
        class="st3"
        d="M396.2,232.6c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C395.7,231.5,395.8,232.1,396.2,232.6z"
      />
      <path
        class="st3"
        d="M396.8,247c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4
		c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.8,0.3,1.6,0.1,2.9-0.8
		c1.3,1,1.8,1.1,2.6,0.6C397.1,248.2,397.3,247.5,396.8,247z"
      />
      <path
        class="st3"
        d="M579.7,179.8c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C579,180.9,579.5,180.4,579.7,179.8z"
      />
      <path
        class="st3"
        d="M312.8,244c-0.2,1.1-0.2,2.2-0.1,3.3l0,0c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3
		C313.5,244.7,313.2,244.3,312.8,244z"
      />
      <path
        class="st3"
        d="M396.1,229.7C396.1,229.7,396.1,229.8,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.7,396.2,229.7,396.1,229.7L396.1,229.7z"
      />
      <path
        class="st3"
        d="M394.8,228.6c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C395.8,228.9,395.3,228.7,394.8,228.6z"
      />
      <path
        class="st3"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C555,198.3,555.3,198.1,555.5,197.6z"
      />
      <path
        class="st3"
        d="M513.4,201.7c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.7,0.1-1.1,0.4-1.5,0.8c1.3,0.7,2.3,1.7,3,2.8C513.3,202.3,513.6,201.9,513.4,201.7z"
      />
      <path
        class="st3"
        d="M555.9,215.2c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8
		c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7C554.6,215.5,555.3,215.4,555.9,215.2z"
      />
      <path
        class="st3"
        d="M316.5,238.8c-0.4-0.2-1-0.3-1.5-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.4-0.3,0.9-0.4,1.3
		c0.5,0.6,1.3,0.9,2.2,0.7c0.2,0,0.3-0.1,0.5-0.2c-0.1-0.5-0.2-1-0.3-1.5c0.3-0.1,0.5-0.1,0.8-0.2c0.1,0.4,0.2,0.8,0.4,1.2
		c0,0,0.1-0.1,0.2-0.1c0.3-0.4,0.5-0.9,0.4-1.4C317.5,239.5,317.1,239,316.5,238.8z"
      />
      <path
        class="st3"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st3"
        d="M508.2,193c-1.4,1.1-2.7,2.3-1.7,3.9v0.1c0.5,0.7,1.1,1.4,1.7,1.8c0.5-0.2,0.6-0.6,0.5-1c0-0.4-0.2-0.9,0-1.2
		C510,195.2,509.2,194.1,508.2,193z"
      />
      <path
        class="st3"
        d="M321.2,234.5L321.2,234.5v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.8c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9s0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C321.4,235.7,321.5,235,321.2,234.5z"
      />
      <path
        class="st3"
        d="M471.1,236.5c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C473.4,236.8,472.1,236.2,471.1,236.5z"
      />
      <path
        class="st3"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <path
        class="st3"
        d="M563.1,182.6C563,182.6,563,182.6,563.1,182.6c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7
		c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C563.3,182.9,563.2,182.8,563.1,182.6z"
      />
      <path
        class="st3"
        d="M501.2,183.6c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3c0.1,0,0.2-0.1,0.4-0.3
		c-0.5-1.1-1.1-2.1-1.7-3.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.6,0-1.2,0.2-1.7,0.6c-0.1,0.1-0.2,0.1-0.3,0.2
		C498.5,183,498.8,183.4,501.2,183.6z"
      />
      <path
        class="st3"
        d="M589.5,181.9c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C589.9,183,589.9,182.3,589.5,181.9z"
      />
      <path
        class="st3"
        d="M553.8,177.3c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5c-0.3-0.7-0.5-1.5-0.8-2.1c0-0.1-0.1-0.2-0.1-0.2
		c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9c-0.4,0.6-0.5,1.3-0.8,2c-0.2,0.6,0.3,1,0.9,1.4
		C552.8,177.8,553.3,177.6,553.8,177.3z"
      />
      <path
        class="st3"
        d="M566.5,189.7L566.5,189.7c0.6-0.1,1-0.5,1.3-0.9s0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C564.7,189.5,565.6,189.9,566.5,189.7z"
      />
      <path
        class="st3"
        d="M550.8,187.2c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C550.6,187.1,550.7,187.1,550.8,187.2z"
      />
      <path
        class="st3"
        d="M346.2,265.7c0.2,0.8,0.5,1.5,0.7,2.3c0.2,0.1,0.3,0.1,0.5,0.1c-0.1-1-0.2-2-0.3-3
		C346.7,265.3,346.4,265.5,346.2,265.7z"
      />
      <path
        class="st3"
        d="M345.8,267.1C345.8,267.1,345.9,267.1,345.8,267.1c0-0.2,0-0.4,0-0.7C345.8,266.6,345.8,266.8,345.8,267.1z"
      />
      <path
        class="st3"
        d="M342.8,271c-0.8,0.1-1.4,0.6-1.6,1.1h2.7c0-0.2,0-0.5,0.1-0.7c0.2,0.1,0.5,0.2,0.9,0.4
		C344.5,271.3,343.7,270.9,342.8,271z"
      />
      <path
        class="st3"
        d="M446.2,208.7c-0.3-0.1-0.7-0.1-1,0c-0.6,0.1-1.1,0.5-1.4,1c0,0.4-0.1,0.7-0.1,1.1c0.1,0.2,0.2,0.4,0.4,0.6
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C447.2,209.3,446.8,208.9,446.2,208.7z"
      />
      <path
        class="st3"
        d="M327.2,237.6c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C327.3,237.8,327.2,237.7,327.2,237.6z"
      />
      <path
        class="st3"
        d="M482.4,222.5c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C482.4,223,482.5,222.8,482.4,222.5L482.4,222.5z"
      />
      <path
        class="st3"
        d="M582.6,188.4c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C583,186.8,582.4,187.6,582.6,188.4z"
      />
      <path
        class="st3"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st3"
        d="M592.6,220.9c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C591.9,222.5,592.7,221.6,592.6,220.9z"
      />
      <path
        class="st3"
        d="M518.9,248.2c0-0.1-0.1-0.2-0.1-0.2c-0.4,0-0.8-0.1-1.2-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2
		c-0.1,0-0.2,0-0.3,0c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C517.7,249.1,518.3,248.7,518.9,248.2z
		"
      />
      <path
        class="st3"
        d="M584.5,222.1c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C586.2,222.3,585.4,221.9,584.5,222.1z"
      />
      <path
        class="st3"
        d="M418.4,247.3c0.2,0.7,0.1,1.6,0,2.4c0,0.1-0.1,0.2-0.1,0.3c0.1,0,0.1,0,0.2,0c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C419.7,247.8,419,247.4,418.4,247.3z"
      />
      <path
        class="st3"
        d="M517.9,249.8c-0.8,0.2-1.3,0.9-1.2,1.6c0.1,0.7,1,1.2,1.9,1s1.4-1,1.3-1.7
		C519.6,249.9,518.8,249.5,517.9,249.8z"
      />
      <path
        class="st3"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st3"
        d="M544.3,186.4c-0.5,0.4-0.6,0.8-0.2,1.3c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3
		c0.3,0.1,0.6,0.1,0.9-0.1c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7C545.7,186,544.9,186,544.3,186.4z"
      />
      <path
        class="st3"
        d="M317.3,228c0.2,0,0.4,0,0.7,0c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.6,0.1-1.1,0.6-1.1,1.1
		c0.1,0,0.2,0,0.2,0C316.7,226.8,317,227.4,317.3,228z"
      />
      <path
        class="st3"
        d="M306.2,257.5v0.6v1.6c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.3-0.1c0.5-0.3,0.9-0.9,0.8-1.3c0-0.2-0.2-0.3-0.3-0.5
		C306.9,257.7,306.5,257.6,306.2,257.5z"
      />
      <path
        class="st3"
        d="M565.8,190.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C566.5,190.2,566.1,190.1,565.8,190.2z"
      />
      <path
        class="st3"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st3"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st3"
        d="M322,242.6c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4c0.6,0.1,1.2-0.3,1.4-0.9
		C322.7,243.2,322.5,242.8,322,242.6z"
      />
      <path
        class="st3"
        d="M524.7,245.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.2-0.4-0.4-0.6-0.5C524.4,245.2,524.5,245.4,524.7,245.6z"
      />
      <path
        class="st3"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2S490.1,206.5,489.4,206.7z"
      />
      <path
        class="st3"
        d="M567.3,201.5C567.2,201.5,567.2,201.5,567.3,201.5c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C568.8,201.4,567.9,201.2,567.3,201.5z"
      />
      <path
        class="st3"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st3"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C465.6,242.2,464.8,241.9,464.1,242z"
      />
      <path
        class="st3"
        d="M502.1,200c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5c0.4-0.5,0.8-0.9,1.2-1.2c-0.2-0.3-0.3-0.7-0.5-1
		C502.3,199.7,502.2,199.9,502.1,200z"
      />
      <path
        class="st3"
        d="M392.1,252.2c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C390.7,252,391.4,252.4,392.1,252.2z"
      />
      <path
        class="st3"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st3"
        d="M518.6,204.3c0.3-0.2,0.7-0.5,0.8-0.4c0.2,0.2,0.4,0.2,0.6,0.2c0-0.5-0.1-0.9-0.1-1.4
		c-0.3,0.1-0.7,0.3-0.9-0.2c0-0.1-0.6-0.1-0.9-0.1C517.8,203.2,517.7,203.9,518.6,204.3z"
      />
      <path
        class="st3"
        d="M497.1,181.1c0.1,0.2,0.2,0.4,0.3,0.6c0-0.1,0.1-0.2,0.1-0.3C497.4,181.3,497.2,181.2,497.1,181.1z"
      />
      <path
        class="st3"
        d="M495.3,182.7c0.1,0.4,0.3,0.7,0.7,0.8c-0.1-0.6-0.3-1.2-0.4-1.9C495.3,181.9,495.2,182.3,495.3,182.7z"
      />
      <path
        class="st3"
        d="M540.1,218c0.2,0.6,0.4,1.1,0.5,1.7c0.6,0,1.1-0.2,1.3-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.7,217.9,540.4,217.9,540.1,218z"
      />
      <path
        class="st3"
        d="M538.9,204.7c-0.7,0.2-1.5,0.1-1.8,1c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0
		C540.1,205.8,539.5,205.3,538.9,204.7z"
      />
      <path
        class="st3"
        d="M394.1,242.1c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5
		c-0.5,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.2-0.8,0.4C394.6,241.7,394.4,241.9,394.1,242.1L394.1,242.1z"
      />
      <path
        class="st3"
        d="M474,233.8c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C473.3,234.7,473.7,234.3,474,233.8z"
      />
      <path
        class="st3"
        d="M554.9,253.9c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C554.9,252.9,554.7,253.1,554.9,253.9z"
      />
      <path
        class="st3"
        d="M535.5,205.1c0-0.2,0.1-0.4,0.2-0.7c-0.2,0-0.3,0-0.4,0C535.3,204.6,535.4,204.8,535.5,205.1z"
      />
      <path
        class="st3"
        d="M507.6,192.3c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7s-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2
		C507.3,193.1,507.4,192.7,507.6,192.3z"
      />
      <path
        class="st3"
        d="M381.4,258.3c0.3,0.2,0.5,0.4,0.8,0.6c0.5-0.3,0.9-0.5,1.4-0.8C382.4,257.6,381.8,257.6,381.4,258.3z"
      />
      <path
        class="st3"
        d="M381,259.5l-0.1-0.1c0,0.1,0,0.1-0.1,0.2C380.9,259.6,381,259.6,381,259.5z"
      />
      <path
        class="st3"
        d="M334.1,269.1c0.2,0.1,0.3,0.1,0.5,0.2c1-0.4,1.2-0.8,0.8-1.8C334.2,268.1,334.1,268.3,334.1,269.1z"
      />
      <path
        class="st3"
        d="M516.4,200.9c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C517.2,200.8,516.7,200.8,516.4,200.9z"
      />
      <path
        class="st3"
        d="M522,227.6c0,0.3,0.1,0.5,0.3,0.6c0.1-0.4,0.2-0.9,0.4-1.4C522.3,226.9,522,227.1,522,227.6z"
      />
      <path
        class="st3"
        d="M557.8,215.9c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C557.9,215.8,557.9,215.8,557.8,215.9z"
      />
      <path
        class="st3"
        d="M443.7,216.3c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C445.1,215.9,444.5,215.9,443.7,216.3z"
      />
      <path
        class="st3"
        d="M542.3,213.6c-0.3-0.5-0.6-1-0.9-1.5c-0.6,0.1-1.1,0.2-1.8,0.4C540.7,212.8,540.8,214.1,542.3,213.6z"
      />
      <path
        class="st3"
        d="M422.2,242.7c-0.3,0.2-0.6,0.5-0.7,0.8v0.1c0.6-0.2,1.2-0.3,1.8-0.5C423.1,242.8,422.5,242.5,422.2,242.7z"
      />
      <path
        class="st3"
        d="M336.4,235.8c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.2,0-0.3-0.1c-0.2,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.2-0.2,0.4-0.1,0.6c0.1,0.2,0.3,0.3,0.4,0.4c0.1,0.1,0.3,0.2,0.4,0.2C336.4,236.6,336.6,236.2,336.4,235.8z"
      />
      <path
        class="st3"
        d="M459,236.8c-0.3,0.2-0.7,0.6-0.6,0.8s0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C460,236.9,459.4,236.6,459,236.8z"
      />
      <path
        class="st3"
        d="M593.4,208.5c0.6,0.6,0.6,1.5,2.1,1.2C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st3"
        d="M380.6,249.7c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3l0,0c0,0.1,0,0.1,0.1,0.2
		c-0.3,0.2-0.6,0.4-0.9,0.5c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.1,0.1-0.1,0.2-0.2,0.2C379.9,249.5,380.3,249.8,380.6,249.7
		C380.5,249.8,380.6,249.8,380.6,249.7z"
      />
      <path
        class="st3"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st3"
        d="M538.4,210.4c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C539.3,211.2,538.9,210.9,538.4,210.4z"
      />
      <path
        class="st3"
        d="M546.6,196c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C547.3,196.9,546.1,196.5,546.6,196z"
      />
      <path
        class="st3"
        d="M557.8,207.8c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C557,207.5,557.7,207.8,557.8,207.8z"
      />
      <path
        class="st3"
        d="M555.3,167.5c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C556.1,167.8,555.8,167.7,555.3,167.5z"
      />
      <path
        class="st3"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st3"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.7,611.2,162.9z"
      />
      <path
        class="st3"
        d="M385.3,258.4c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C384.9,258.8,385.3,258.6,385.3,258.4z"
      />
      <path
        class="st3"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st3"
        d="M539.5,177.9c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C540,178.1,539.7,178,539.5,177.9z"
      />
      <path
        class="st3"
        d="M547.9,190.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C548.7,190,548.3,190.3,547.9,190.7z"
      />
      <path
        class="st3"
        d="M318.1,260c0-0.1,0.1-0.1,0.1-0.1c-0.1,0-0.1,0-0.2,0C318.1,259.9,318.1,259.9,318.1,260z"
      />
      <path
        class="st3"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9c0,0,0.1,0,0.1,0.1c0.4,0.1,0.7,0.1,0.9,0.1c0.1-0.1,0.2-0.3,0.2-0.4
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st3"
        d="M495,201.2c1.3-0.8,0.1-1.1,0.1-1.7C493.9,200.3,495,200.6,495,201.2z"
      />
      <path
        class="st3"
        d="M583.5,205.5c0.5,0.4,0.3,1.1,1.3,1.3C584.7,205.5,584.7,205.5,583.5,205.5z"
      />
      <path
        class="st3"
        d="M564.4,210.5c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C565,210.1,564.8,210.2,564.4,210.5z"
      />
      <path
        class="st3"
        d="M534.9,174.6c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C535.4,175.8,535.1,175.3,534.9,174.6z"
      />
      <path
        class="st3"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st3"
        d="M554.8,178c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C555.4,178.8,555,178.4,554.8,178z"
      />
      <path
        class="st3"
        d="M562.3,218.7c0.1,0.8,0.1,0.8,0.9,1.3C563.1,219.5,563.1,219,562.3,218.7z"
      />
      <path
        class="st3"
        d="M511.9,253.8c0,0.7,0.2,1.1,1,1.7C513,254.5,512.7,254.1,511.9,253.8z"
      />
      <path
        class="st3"
        d="M537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.9,537.3,176.9,537.1,177L537.1,177z"
      />
      <path
        class="st3"
        d="M518.4,219.7c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C519,220.1,518.6,220,518.4,219.7z"
      />
      <path
        class="st3"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st3"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st3"
        d="M558.5,193.9c-0.2-0.7-0.3-1.2-1.2-1.2C557.2,193.3,557.6,193.6,558.5,193.9z"
      />
      <path
        class="st3"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st3"
        d="M541.1,207.2c-0.3-0.5-0.7-0.7-1.6-0.4c0.4,0.3,0.8,0.5,1.2,0.8C540.9,207.4,541,207.3,541.1,207.2z"
      />
      <path
        class="st3"
        d="M579.4,184c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C579,184.5,579.2,184.2,579.4,184z"
      />
      <path
        class="st3"
        d="M547.4,179.3c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C547.5,179.2,547.5,179.2,547.4,179.3z"
      />
      <path
        class="st3"
        d="M546.8,168.4c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C547.4,168.7,547.1,168.6,546.8,168.4z"
      />
      <path
        class="st3"
        d="M338.1,235.2c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C337.6,235.8,337.8,235.5,338.1,235.2z"
      />
      <path
        class="st3"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st3"
        d="M321.9,233.7c0.2,0.1,0.3,0.1,0.4,0.2c0.3,0.1,0.5,0,0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3s-0.2-0.4-0.4-0.7
		C322.4,233.1,322.1,233.4,321.9,233.7z"
      />
      <path
        class="st3"
        d="M516.5,207.6c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2c0.1,0,0.3,0,0.4,0
		C516.3,208.4,516.4,208,516.5,207.6z"
      />
      <path
        class="st3"
        d="M395.8,253.5c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.5z"
      />
      <path
        class="st3"
        d="M488.4,213.8c0.6-0.2,1.1-0.5,0.7-1.3C488.8,213.1,488.6,213.5,488.4,213.8z"
      />
      <path
        class="st3"
        d="M499.2,184.7c0.7,0.2,1.1,0.3,1.8,0.5C500.6,184.5,500.2,184.3,499.2,184.7z"
      />
      <path
        class="st3"
        d="M490.3,191.7c0.4,0.2,0.8,0.4,1.5,0.8C491.5,191.7,491.1,191.6,490.3,191.7z"
      />
      <path
        class="st3"
        d="M519.7,222.4C519.7,222.4,519.7,222.5,519.7,222.4c0.1-0.4,0.1-0.8,0.2-1.2l0,0
		C519.8,221.7,519.7,222.1,519.7,222.4z"
      />
      <path class="st3" d="M520,222.5v-0.1V222.5L520,222.5z" />
      <path
        class="st3"
        d="M558.9,187.1c0.7-0.1,1.1-0.1,1.9-0.2C560,186.7,559.5,186.4,558.9,187.1z"
      />
      <path
        class="st3"
        d="M320.2,244.9c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C320.4,245.1,320.3,245,320.2,244.9z"
      />
      <path
        class="st3"
        d="M486.4,220.9c0.3-0.5,0.4-0.8,0.6-1.1C486.4,220,486,220.3,486.4,220.9z"
      />
      <path
        class="st3"
        d="M501.7,185.3c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C501.5,185.4,501.6,185.3,501.7,185.3z"
      />
      <path
        class="st3"
        d="M598.4,170.5L598.4,170.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C598.9,170.4,598.6,170.2,598.4,170.5z"
      />
      <path
        class="st3"
        d="M337.3,270.3c0.1,0,0.2,0.1,0.3,0.1c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C337.8,269.8,337.6,270.1,337.3,270.3z"
      />
      <path
        class="st3"
        d="M560.3,188.6c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C560.9,188.9,560.7,188.7,560.3,188.6z"
      />
      <path
        class="st3"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st3"
        d="M384.8,252.5c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.5
		C384.4,252.4,384.7,252.6,384.8,252.5z"
      />
      <path
        class="st3"
        d="M556.9,178.5c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C556.2,179.2,556.6,178.8,556.9,178.5z"
      />
      <path
        class="st3"
        d="M373.6,256.2c-0.3-0.3-0.5-0.5-0.7-0.7C372.7,256.2,372.7,256.2,373.6,256.2z"
      />
      <path
        class="st3"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st3"
        d="M398.7,225c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.6,225.2,398.7,225.1,398.7,225z"
      />
      <path
        class="st3"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st3"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c0,0-0.1,0-0.1,0.1s0.1,0.2,0.1,0.3c0.1,0,0.2,0.1,0.3,0.1
		C342.8,239.1,342.9,239,343.1,238.8z"
      />
      <path
        class="st3"
        d="M388.9,267.2c0.1,0.1,0.2,0.2,0.3,0.3v-0.1C389.2,267.4,389.1,267.3,388.9,267.2z"
      />
      <path
        class="st3"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st3"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st3"
        d="M609.2,214.6c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.6z"
      />
      <path
        class="st3"
        d="M551.9,173.2c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C552.5,172.8,552.2,173,551.9,173.2z"
      />
      <path
        class="st3"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st3"
        d="M516.2,202.7c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0.1,0.3,0.2,0.4
		C516.1,203.1,516.1,202.9,516.2,202.7z"
      />
      <path
        class="st3"
        d="M543.3,178.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5c0-0.1,0.1-0.2,0.1-0.3
		c-0.2,0.1-0.3,0.2-0.5,0.3C543.6,178.5,543.4,178.6,543.3,178.7z"
      />
      <path
        class="st3"
        d="M541.6,179.2c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.2,0.9-0.3
		C541.6,179.5,541.6,179.3,541.6,179.2z"
      />
      <path
        class="st3"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st3"
        d="M611.2,170.6C611.2,170.6,611.1,170.6,611.2,170.6c-0.1,0.1-0.1,0.1-0.1,0.1
		C611.1,170.7,611.1,170.7,611.2,170.6L611.2,170.6z"
      />
      <path
        class="st3"
        d="M551.2,182.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C551.4,182.1,551.3,182.2,551.2,182.2z"
      />
      <path
        class="st3"
        d="M389.8,249.7c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1
		C389.9,250.1,389.8,249.9,389.8,249.7z"
      />
      <path
        class="st3"
        d="M571.5,179.1c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0C571.5,179.2,571.5,179.1,571.5,179.1z"
      />
      <path
        class="st3"
        d="M571.9,178.5c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C572.1,178.6,572,178.6,571.9,178.5z"
      />
      <path
        class="st3"
        d="M536.2,203.3c-0.1,0.1-0.3,0.2-0.3,0.3s0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C536.4,203.3,536.2,203.3,536.2,203.3z"
      />
      <path
        class="st3"
        d="M507.2,263.5c0.2,0.2,0.4,0.4,0.6,0.6C507.8,263.8,508.1,263.5,507.2,263.5z"
      />
      <path
        class="st3"
        d="M507.8,264.1C507.7,264.1,507.7,264.2,507.8,264.1c0,0.1,0.1,0.1,0.1,0.1C507.8,264.2,507.8,264.2,507.8,264.1
		L507.8,264.1z"
      />
      <path
        class="st3"
        d="M399.3,234.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C399.2,234.4,399.3,234.2,399.3,234.2z"
      />
      <path
        class="st3"
        d="M569.5,165.3c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C569.8,165.4,569.7,165.3,569.5,165.3z"
      />
      <path
        class="st3"
        d="M609.3,167.7c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C609.4,167.5,609.3,167.6,609.3,167.7z"
      />
      <path
        class="st3"
        d="M519.8,211.5v-0.1c-0.2,0-0.4,0-0.5-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.7,211.5,519.8,211.5z"
      />
      <path
        class="st3"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.9,612,164.9,612.1,165z"
      />
      <path
        class="st3"
        d="M610.8,165.9c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C610.6,165.8,610.7,165.9,610.8,165.9z"
      />
      <path
        class="st3"
        d="M433.2,229.6c0.2,0.2,0.3,0.4,0.6,0.8c0,0,0,0,0.1,0C434,229.7,433.5,229.7,433.2,229.6z"
      />
      <path
        class="st3"
        d="M433.1,229.5C433.1,229.5,433.1,229.6,433.1,229.5c0.1,0.1,0.1,0.1,0.1,0.1S433.2,229.5,433.1,229.5
		L433.1,229.5z"
      />
      <path
        class="st3"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st3"
        d="M336.4,243.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C336.5,243.3,336.4,243.4,336.4,243.4z
		"
      />
      <path
        class="st3"
        d="M519.2,211.3L519.2,211.3c-0.1-0.1-0.1-0.1-0.1-0.1L519.2,211.3C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st3"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st3"
        d="M550.4,193.2l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1H551c-0.1,0-0.2,0-0.4,0
		C550.5,193.2,550.4,193.2,550.4,193.2z"
      />
      <path
        class="st3"
        d="M504.2,207.1l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C504.3,206.8,504.3,206.9,504.2,207.1z"
      />
      <path
        class="st3"
        d="M554.6,184.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4S554.7,184.2,554.6,184.2z
		"
      />
      <path
        class="st3"
        d="M396.6,244.9c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C396.7,244.7,396.6,244.9,396.6,244.9z"
      />
      <path
        class="st3"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.2,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st3"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.2,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st3"
        d="M364.7,245.3C364.8,245.3,364.8,245.3,364.7,245.3c0.1-0.1,0.1-0.1,0.1-0.2
		C364.8,245.2,364.8,245.3,364.7,245.3L364.7,245.3z"
      />
      <path
        class="st3"
        d="M364.8,245.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2,0-0.2-0.1C364.9,244.9,364.9,245.1,364.8,245.2z"
      />
      <path
        class="st3"
        d="M543.8,179.5c0.2-0.1,0.4-0.1,0.6-0.2v-0.1c-0.2,0-0.4,0-0.6,0C543.8,179.3,543.8,179.4,543.8,179.5z"
      />
      <path
        class="st3"
        d="M603.7,169.3c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C603.6,168.9,603.6,169,603.7,169.3z"
      />
      <path
        class="st3"
        d="M436.2,267.9L436.2,267.9c0-0.1,0-0.1-0.1-0.2C436.2,267.8,436.2,267.9,436.2,267.9z"
      />
      <path
        class="st3"
        d="M414.9,210c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C415,209.8,415,209.9,414.9,210z"
      />
      <path
        class="st3"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st3"
        d="M536.3,204.2c0.1,0.1,0.2,0.1,0.4,0.1c0,0,0.1-0.2,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
		C536.4,204,536.4,204.1,536.3,204.2z"
      />
      <path
        class="st3"
        d="M554.4,183.6c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C553.8,184.1,553.9,184,554.4,183.6z"
      />
      <path
        class="st3"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st3"
        d="M611.1,170.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C611,171.1,611,170.9,611.1,170.7z"
      />
      <path
        class="st3"
        d="M468.4,243.4C468.4,243.4,468.4,243.5,468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st3"
        d="M557.7,186.9C557.7,186.9,557.8,186.9,557.7,186.9c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C557.9,186.8,557.7,186.8,557.7,186.9z"
      />
      <path
        class="st3"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.3-0.1-0.4-0.1
		C368.8,253.6,368.7,253.6,368.7,253.7z"
      />
      <path
        class="st3"
        d="M515.8,199.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C515.9,199.5,515.9,199.4,515.8,199.4z"
      />
      <path
        class="st3"
        d="M501.9,205.6c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C501.8,205.4,501.8,205.5,501.9,205.6z"
      />
      <path
        class="st3"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st3"
        d="M598.1,189.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.7z"
      />
      <path
        class="st3"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st3"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path
        class="st3"
        d="M555.4,173c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L555.4,173z"
      />
      <path
        class="st3"
        d="M345.9,243.9c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0v-0.1C346.1,243.9,346,243.9,345.9,243.9z"
      />
      <path
        class="st3"
        d="M508,264.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C507.9,264.4,507.9,264.5,508,264.6z"
      />
      <path
        class="st3"
        d="M537.4,176C537.4,176.1,537.4,176.1,537.4,176c0,0.1,0.1,0.1,0.1,0.1L537.4,176C537.6,176,537.5,176,537.4,176
		z"
      />
      <path
        class="st3"
        d="M534.4,176.3L534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3
		C534.5,176.3,534.5,176.3,534.4,176.3z"
      />
      <path
        class="st3"
        d="M534.1,176.6c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C534,176.5,534,176.6,534.1,176.6z"
      />
      <path
        class="st3"
        d="M548.4,173.2l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C548.2,173.1,548.3,173.2,548.4,173.2z"
      />
      <path
        class="st3"
        d="M565.1,174l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C565.3,174,565.2,174,565.1,174z"
      />
      <path
        class="st3"
        d="M559.6,169l0.1,0.1c0.1,0,0.1,0,0.2,0C559.8,169.1,559.8,169,559.6,169C559.8,169,559.7,169,559.6,169z"
      />
      <path
        class="st3"
        d="M498.8,181c0,0,0.1,0.1,0.1,0.2l0,0l0,0C498.9,181.1,498.9,181,498.8,181z"
      />
      <path
        class="st3"
        d="M420.8,229.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C420.6,229.7,420.7,229.6,420.8,229.6z"
      />
      <path
        class="st3"
        d="M316.9,248.9l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1C317.1,248.8,317,248.8,316.9,248.9z"
      />
      <path
        class="st3"
        d="M450.3,225.3c0.1,0,0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st3"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.5,428,230.5,428,230.5z"
      />
      <path
        class="st3"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st3"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st3"
        d="M495,193.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C494.9,193.4,495.1,193.4,495,193.3z"
      />
      <path
        class="st3"
        d="M394.3,240c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C394.5,240.1,394.4,240,394.3,240z"
      />
      <path
        class="st3"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st3"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st3"
        d="M546.7,194.8C546.7,194.8,546.8,194.8,546.7,194.8c0-0.1-0.1-0.1-0.2-0.1l0,0c0,0,0,0.1-0.1,0.1
		C546.5,194.8,546.6,194.8,546.7,194.8L546.7,194.8z"
      />
      <path
        class="st3"
        d="M501.4,204.9c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C501.5,204.7,501.4,204.8,501.4,204.9z
		"
      />
      <path
        class="st3"
        d="M331.4,241.4c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C331.4,241.5,331.4,241.5,331.4,241.4z"
      />
      <path
        class="st3"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st3"
        d="M573.6,179.4l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C573.8,179.4,573.7,179.4,573.6,179.4z"
      />
      <path
        class="st3"
        d="M549.3,185.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C549.2,185.3,549.2,185.4,549.3,185.4z"
      />
      <path
        class="st3"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.5,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st3"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st3"
        d="M357.1,254.7C357.1,254.7,357.2,254.7,357.1,254.7c0.2,0,0.3,0,0.4-0.1c0,0,0,0-0.1,0
		C357.3,254.6,357.2,254.6,357.1,254.7z"
      />
      <path
        class="st3"
        d="M558.4,185.1L558.4,185.1c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C557.8,185.3,557.9,185.2,558.4,185.1
		L558.4,185.1z"
      />
      <path
        class="st3"
        d="M580.2,181c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C580.4,180.9,580.3,180.9,580.2,181z"
      />
      <path
        class="st3"
        d="M580.6,181.3C580.6,181.2,580.6,181.2,580.6,181.3C580.6,181.2,580.6,181.3,580.6,181.3L580.6,181.3
		L580.6,181.3C580.7,181.3,580.7,181.3,580.6,181.3L580.6,181.3z"
      />
      <path
        class="st3"
        d="M549.3,187.9C549.3,187.9,549.3,188,549.3,187.9c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2
		C549.7,187.8,549.5,187.8,549.3,187.9z"
      />
      <path
        class="st3"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st3"
        d="M574.5,182.7c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1C574.6,182.8,574.6,182.7,574.5,182.7z"
      />
      <path
        class="st3"
        d="M574.4,182.6c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		S574.3,182.9,574.4,182.6C574.5,182.7,574.5,182.7,574.4,182.6C574.5,182.7,574.5,182.6,574.4,182.6L574.4,182.6z"
      />
      <path
        class="st3"
        d="M580.7,181.6c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C580.7,181.4,580.6,181.5,580.7,181.6z"
      />
      <path
        class="st3"
        d="M567.4,211.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C567.3,211,567.3,211.1,567.4,211.2z"
      />
      <polygon class="st3" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st3"
        d="M510.7,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0.1C510.6,198.5,510.6,198.6,510.7,198.6z"
      />
      <path
        class="st3"
        d="M403.3,246.8c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.8
		C403.4,246.8,403.3,246.7,403.3,246.8z"
      />
      <path
        class="st3"
        d="M575.4,184.7l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C575.4,184.6,575.3,184.7,575.4,184.7z"
      />
      <path
        class="st3"
        d="M395.7,225c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C395.8,225.1,395.8,225.1,395.7,225z"
      />
      <path
        class="st3"
        d="M331.4,236.1l-0.1-0.1c0,0.1,0,0.1,0,0.2C331.4,236.1,331.4,236.1,331.4,236.1z"
      />
      <path
        class="st3"
        d="M319.1,237.5L319.1,237.5L319.1,237.5c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C319.1,237.4,319.1,237.4,319.1,237.5z"
      />
      <polygon class="st3" points="552.2,193.3 552.1,193.2 552.1,193.3 	" />
      <polygon class="st3" points="499.6,194.4 499.8,194.3 499.7,194.2 	" />
      <polygon class="st3" points="546.4,183.9 546.2,183.9 546.3,184 	" />
      <path
        class="st3"
        d="M578.2,176.6c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.1,0-0.2C578.4,176.5,578.3,176.5,578.2,176.6z"
      />
      <path
        class="st3"
        d="M578.8,176.1L578.8,176.1C578.8,176,578.7,176.1,578.8,176.1c-0.1,0.1-0.2,0.2-0.3,0.4l0,0l0,0l0,0
		C578.6,176.3,578.7,176.2,578.8,176.1z"
      />
      <path
        class="st3"
        d="M578.8,175.8c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1S578.9,175.9,578.8,175.8z"
      />
      <path
        class="st3"
        d="M552.5,181c0,0,0,0.1-0.1,0.1C552.5,181.1,552.5,181.1,552.5,181C552.5,181.1,552.5,181,552.5,181z"
      />
      <polygon class="st3" points="597,185.4 597,185.5 597.1,185.4 	" />
      <polygon class="st3" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <path
        class="st3"
        d="M547,197.5c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C547,197.6,547,197.5,547,197.5z"
      />
      <path
        class="st3"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <polygon class="st3" points="602.5,166.7 602.4,166.6 602.4,166.7 	" />
      <path
        class="st3"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st3"
        d="M546.7,200.2l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C546.6,200.1,546.7,200.2,546.7,200.2z"
      />
      <path
        class="st3"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st3"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st3"
        d="M558.8,170L558.8,170c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L558.8,170z"
      />
      <path
        class="st3"
        d="M546.1,172.7l0.1-0.1l-0.1-0.1l-0.1,0.1C546.1,172.7,546.1,172.7,546.1,172.7z"
      />
      <path
        class="st3"
        d="M569,167.3c0,0.1,0,0.2,0.1,0.2l0.1-0.1C569.2,167.3,569.1,167.3,569,167.3z"
      />
      <path
        class="st3"
        d="M559.6,167.8l0.1-0.1C559.7,167.7,559.6,167.7,559.6,167.8C559.6,167.7,559.6,167.8,559.6,167.8z"
      />
      <path
        class="st3"
        d="M559.7,167.7L559.7,167.7c0.1-0.1,0.1-0.1,0.1-0.1C559.8,167.6,559.8,167.6,559.7,167.7L559.7,167.7z"
      />
      <path
        class="st3"
        d="M420.9,230.3l-0.1,0.1l0.1,0.1l0.1-0.1C421,230.4,421,230.4,420.9,230.3z"
      />
      <polygon class="st3" points="391.4,238.8 391.5,238.7 391.4,238.7 	" />
      <polygon class="st3" points="486,219.5 486.1,219.5 486.1,219.4 	" />
      <polygon class="st3" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st3"
        d="M542,207.7c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C541.9,207.8,542,207.7,542,207.7z"
      />
      <path
        class="st3"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st3" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st3"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <polygon class="st3" points="543.9,211.7 544,211.7 544,211.6 	" />
      <path
        class="st3"
        d="M566.8,210.6L566.8,210.6C566.7,210.6,566.7,210.7,566.8,210.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C567.1,210.8,566.9,210.7,566.8,210.6z"
      />
      <polygon
        class="st3"
        points="478.3,234.9 478.4,235 478.4,234.9 478.4,234.9 478.4,234.9 	"
      />
      <path
        class="st3"
        d="M584.1,216.2c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C584.3,216.2,584.2,216.2,584.1,216.2z"
      />
      <path
        class="st3"
        d="M603.1,221.6c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.6c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.6L603.1,221.6z"
      />
      <path
        class="st3"
        d="M509.9,248.8l0.1,0.1l0.1-0.1C510,248.7,510,248.7,509.9,248.8C509.9,248.7,509.9,248.7,509.9,248.8z"
      />
      <polygon class="st3" points="500,266.3 500.1,266.3 500.1,266.2 	" />
      <path
        class="st3"
        d="M534.3,200.7c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C534.4,200.5,534.3,200.6,534.3,200.7z"
      />
      <path
        class="st3"
        d="M363.9,76.8c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C362.6,75.6,363.3,76.2,363.9,76.8z"
      />
      <path
        class="st3"
        d="M426.6,68c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0
		c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1C425.9,66.7,426,67.3,426.6,68z"
      />
      <path
        class="st3"
        d="M310.8,113.1c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4s0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C310.3,111.7,310.2,112.4,310.8,113.1C310.7,113,310.7,113.1,310.8,113.1z"
      />
      <path
        class="st3"
        d="M389,54.7c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C390,51,388.6,53,389,54.7z"
      />
      <path
        class="st3"
        d="M499.4,42.5c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2s0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C499,41.8,499.1,42.2,499.4,42.5z"
      />
      <path
        class="st3"
        d="M487,42.7c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C486.9,41.7,486.7,42.2,487,42.7z
M497.4,56.3c-0.5-0.4-0.6-0.9-0.8-1.4C497.2,55.4,497.2,55.4,497.4,56.3z"
      />
      <path
        class="st3"
        d="M402,57.9c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C402.7,57.9,402.3,57.9,402,57.9z"
      />
      <path
        class="st3"
        d="M371.9,81.6c2-0.4,3.5-2.1,3.2-3.8c-0.3-1.8-2.3-2.8-4.4-2.4c-2.1,0.5-3.4,2.1-3,3.8
		C368,80.9,369.9,82,371.9,81.6z"
      />
      <path
        class="st3"
        d="M537.5,68.9c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5
		c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0
		c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3C537.3,69.3,537.4,69.1,537.5,68.9z"
      />
      <path
        class="st3"
        d="M402.9,56.4c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C402.1,54.3,402.1,55.5,402.9,56.4z"
      />
      <path
        class="st3"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st3"
        d="M608.3,43.3C608.4,43.3,608.4,43.4,608.3,43.3C608.4,43.4,608.4,43.3,608.3,43.3
		C608.4,43.3,608.4,43.3,608.3,43.3L608.3,43.3z"
      />
      <path
        class="st3"
        d="M404.1,67.8c1-0.2,1.9-0.8,2.4-1.6c0.3-0.5,0.5-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5
		c-1.8,0.4-3,1.9-2.6,3.4C400.7,67.2,402.5,68.1,404.1,67.8z"
      />
      <path
        class="st3"
        d="M410.1,57.6c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3
		C413.6,58.1,411.9,57.2,410.1,57.6z"
      />
      <path
        class="st3"
        d="M526.5,48.9c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.1,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.8,49.3,526.5,48.9z"
      />
      <path
        class="st3"
        d="M399.3,70.8c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6
		c-0.9,0.6-1.4,1.6-1.1,2.6c0.2,0.8,0.8,1.4,1.6,1.7c0.6,0.3,1.4,0.4,2.1,0.2C398,72.3,398.9,71.6,399.3,70.8z"
      />
      <path
        class="st3"
        d="M346.5,95.4c0.5,0.2,1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6s-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9c-0.9,0.4-1.5,1.4-1.2,2.3
		c0.3,1,1.2,1.4,3.2,1.2C345.5,94.9,346,95.2,346.5,95.4z"
      />
      <path
        class="st3"
        d="M418.7,65.7c0-0.6-0.3-1.2-0.7-1.5c-0.5-0.4-1.1-0.6-1.9-0.6c-1.2,0.1-2.1,0.7-2.6,1.6
		c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6c-0.9,0.4-2.1,0.5-2,1.5c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2
		c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2C418,67.5,418.7,66.6,418.7,65.7z"
      />
      <path
        class="st3"
        d="M531.6,43.7c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C529.9,42.1,530.5,43.3,531.6,43.7z"
      />
      <path
        class="st3"
        d="M331.5,68.4c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7
		C332.5,65.9,331.3,67.2,331.5,68.4z"
      />
      <path
        class="st3"
        d="M404.3,76.1c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.2h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C402.9,77.7,403.9,77.1,404.3,76.1z"
      />
      <path
        class="st3"
        d="M411.4,71.3c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5c0.3-0.1,0.6-0.2,0.8-0.3
		C410.7,72.2,411.1,71.8,411.4,71.3z"
      />
      <path
        class="st3"
        d="M341.2,76.4c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C338,76.3,339.7,77,341.2,76.4z"
      />
      <path
        class="st3"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st3"
        d="M552.3,7.7c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.7z"
      />
      <path
        class="st3"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st3"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st3"
        d="M409.1,81.5c0.3-0.8,0-1.4-0.7-1.9c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3
		c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2
		s1.3,0.8,2.2,0.7C408.2,82.8,408.8,82.3,409.1,81.5z"
      />
      <path
        class="st3"
        d="M325.6,96.8c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1s-0.4-0.7-0.6-1.1
		c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3c-0.9,0.9-1,1.8-0.5,2.7
		C323.3,97.4,324.5,97.6,325.6,96.8z"
      />
      <path
        class="st3"
        d="M372.2,111.9c0.2-0.1,0.3-0.2,0.5-0.3c0.8-0.4,1.6-0.7,2.4-1.1c-0.3-0.5-0.9-0.7-1.5-0.9
		c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1
		c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1C372.2,110.7,371.9,111.3,372.2,111.9z"
      />
      <path
        class="st3"
        d="M378.3,100.3h-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0,0,0,0,0.1,0c0.6-0.2,1.3-0.2,1.9-0.2
		c-0.3,0.1-0.5,0.3-0.8,0.4c0.3,0.1,0.6,0.1,0.9,0.2l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c0,0,0,0.1,0.1,0.1
		c0.5-0.3,1.1-0.6,1.7-0.9c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1
		C378.8,100.4,378.6,100.4,378.3,100.3z"
      />
      <path
        class="st3"
        d="M382.6,103.7c-0.6,0.1-1.2,0.3-1.7,0.4c0.4,0.2,0.7,0.2,1.7,0C382.6,104,382.6,103.9,382.6,103.7z"
      />
      <path
        class="st3"
        d="M537.7,37.1c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C538.4,34.9,537.5,36,537.7,37.1z"
      />
      <path
        class="st3"
        d="M557.6,32.1c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.4-0.3-0.5
		C557.4,33,557.5,32.6,557.6,32.1z"
      />
      <path
        class="st3"
        d="M413.5,78.1c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4s0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2
		c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3
		C411.4,77.1,412.4,78,413.5,78.1z"
      />
      <path
        class="st3"
        d="M544.5,44.2c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C543.2,43.5,543.8,44,544.5,44.2z"
      />
      <path
        class="st3"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.5,572.7,21.7z"
      />
      <path
        class="st3"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C431.4,42.2,431.6,42.6,432.2,42.7z"
      />
      <path
        class="st3"
        d="M371.3,60.9c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C368.7,60.6,370,61.2,371.3,60.9z"
      />
      <path
        class="st3"
        d="M388.4,50.2c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C386,49.8,387.2,50.4,388.4,50.2z"
      />
      <path
        class="st3"
        d="M592.6,58.8c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1c0.8,0.7,1.6,1.3,2.3,2
		c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1C592.9,60.1,593.4,59.4,592.6,58.8z"
      />
      <path
        class="st3"
        d="M374.7,64.2c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C374.5,63.9,374.6,64,374.7,64.2z"
      />
      <path
        class="st3"
        d="M401.9,86.2c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-0.4,0.1-0.7,0.2-0.9,0.4c0.2,0.1,0.4,0.2,0.6,0.4
		c0.8,0.7,1.7,1.3,2.6,2C401.8,86.6,401.9,86.4,401.9,86.2z"
      />
      <path
        class="st3"
        d="M558.6,31.4c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C557.7,29.7,557.6,30.7,558.6,31.4z"
      />
      <path
        class="st3"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st3"
        d="M334.4,79.3c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C333.8,81.3,334.6,80.3,334.4,79.3z"
      />
      <path
        class="st3"
        d="M386.6,55.8c-2.1,0.8-3,1.8-2.6,3.2c0.3,1.4,1.4,2,3.4,1.8C386.9,59.1,387.3,57.4,386.6,55.8z"
      />
      <path
        class="st3"
        d="M340.2,85.6c-0.3-1-1.3-1.5-2.6-1.2c-1.2,0.3-2,1.3-1.8,2.3c0.2,0.9,1.5,1.6,2.6,1.3
		C339.7,87.7,340.5,86.6,340.2,85.6z"
      />
      <path
        class="st3"
        d="M349.9,91.6c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C349.5,88.8,349.3,90.2,349.9,91.6z"
      />
      <path
        class="st3"
        d="M391.7,66c1.1-0.3,1.9-1.3,1.7-2.2c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3
		C389.4,65.7,390.6,66.3,391.7,66z"
      />
      <path
        class="st3"
        d="M571.1,44.5C571.1,44.5,571.1,44.4,571.1,44.5c-0.2-0.4-0.3-0.6-0.4-0.9c-0.7,0.4-1.4,0.8-2,1.2
		c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6
		c0.6,1.2,0.3,2-0.5,2.7c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7
		C569.1,45.7,569.3,44.4,571.1,44.5L571.1,44.5z"
      />
      <path
        class="st3"
        d="M308.4,65.7c-0.2-0.8-1.2-1.4-2.2-1.3V68c0.2,0,0.3,0,0.5-0.1C307.9,67.7,308.6,66.7,308.4,65.7z"
      />
      <path
        class="st3"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st3"
        d="M394.9,82.6C394.9,82.6,395,82.6,394.9,82.6c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C394.5,82.4,394.7,82.5,394.9,82.6z"
      />
      <path
        class="st3"
        d="M376.8,71.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2s0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C378.1,71.8,377.4,71.5,376.8,71.6z"
      />
      <path
        class="st3"
        d="M364,103c0.1-0.2,0.3-0.4,0.4-0.6C364.2,102.6,364,102.8,364,103z"
      />
      <path
        class="st3"
        d="M366.6,105.1C366.6,105,366.6,105,366.6,105.1c-0.1,0-0.2,0.1-0.3,0.2C366.4,105.2,366.5,105.1,366.6,105.1z"
      />
      <path
        class="st3"
        d="M368,102.1c-0.2-0.2-0.4-0.3-0.6-0.4c-1,0.9-2,1.8-3.1,2.7c0.1,0.2,0.3,0.4,0.4,0.5s0.3,0.2,0.4,0.3
		c0.3-0.3,0.6-0.7,1-1c-0.3-0.3-0.6-0.7,0-1.3c0.3,0.1,0.5,0.3,0.8,0.4C367.3,102.9,367.6,102.5,368,102.1z"
      />
      <path
        class="st3"
        d="M449.4,61.2c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.2,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C449.3,60.7,449.3,61,449.4,61.2z"
      />
      <path
        class="st3"
        d="M544,51.2c-0.2,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C545.3,51.7,544.7,51.3,544,51.2z"
      />
      <path
        class="st3"
        d="M497.9,31.9c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C495.5,31.7,496.6,32.2,497.9,31.9z"
      />
      <path
        class="st3"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st3"
        d="M442.8,32.9c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st3"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.3,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st3"
        d="M424.7,77.6c0.1,0.4,0.5,0.7,0.9,0.9c0.1,0,0.2-0.1,0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.3,0.1,0.4,0.1
		s0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9s-1.1-1.2-2-1.1c-1,0.2-1.6,0.9-1.6,1.7C424.6,77.4,424.6,77.5,424.7,77.6z"
      />
      <path
        class="st3"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st3"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st3"
        d="M332.4,96.2c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C332.2,97.8,332.7,97,332.4,96.2z"
      />
      <path
        class="st3"
        d="M586.2,66.1c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C586.6,65.2,585.9,65.9,586.2,66.1z"
      />
      <path
        class="st3"
        d="M541.2,34c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C539.2,33.7,540.6,34.2,541.2,34z"
      />
      <path
        class="st3"
        d="M348.8,68.6c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C347.7,67.1,348,67.9,348.8,68.6z"
      />
      <path
        class="st3"
        d="M500,46.7c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8c0.6-0.3,1.1-0.7,1.6-0.9
		C500,48.5,500,47.7,500,46.7z"
      />
      <path
        class="st3"
        d="M330.3,93h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C328.4,92.8,329.3,93.2,330.3,93z"
      />
      <path
        class="st3"
        d="M357.4,75.3c0.3-1.9-0.6-2.7-3-2.8C353.6,74.5,354.6,75.5,357.4,75.3z"
      />
      <path
        class="st3"
        d="M381.5,62.7c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8
		C379.8,62.5,380.6,62.9,381.5,62.7z"
      />
      <path
        class="st3"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st3"
        d="M375.8,109.5c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0c0.5,0,1.1,0,1.6,0c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5
		c-0.2-0.1-0.3-0.2-0.5-0.3c-1.2,0.3-2.4,0.5-3.5,0.8c-0.2,0.2-0.4,0.5-0.2,0.9l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6
		C375.5,109.4,375.8,109.5,375.8,109.5z"
      />
      <path
        class="st3"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st3"
        d="M410.4,47.7L410.4,47.7c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.5,409.5,47.9,410.4,47.7z"
      />
      <path
        class="st3"
        d="M549.5,56.7C549.5,56.7,549.4,56.7,549.5,56.7L549.5,56.7C549.4,56.7,549.4,56.7,549.5,56.7
		C549.4,56.7,549.4,56.7,549.5,56.7C549.5,56.8,549.5,56.8,549.5,56.7L549.5,56.7z"
      />
      <path
        class="st3"
        d="M551.6,57.3c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C550.3,56.6,551,56.6,551.6,57.3z"
      />
      <path
        class="st3"
        d="M337.6,97.3c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C337.6,98.8,338,98.1,337.6,97.3z"
      />
      <path
        class="st3"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st3"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st3"
        d="M346.6,82.7c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C344.5,82.8,345.1,83,346.6,82.7z"
      />
      <path
        class="st3"
        d="M460.1,72.5c0.1-0.2,0.2-0.3,0.3-0.5c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7
		c-0.2,0.2-0.4,0.4-0.6,0.7c0.8,0,1.5,0,2.2,0v-0.1C459.7,73.2,459.9,72.9,460.1,72.5z"
      />
      <path
        class="st3"
        d="M377,81.6c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3c0.3,0.4,0.9,0.6,1.5,0.4
		c0.9-0.2,1.4-0.8,1.2-1.5C378.6,81.8,377.8,81.4,377,81.6z"
      />
      <path
        class="st3"
        d="M602,33.8c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.8z"
      />
      <path
        class="st3"
        d="M562,47.7c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C561.1,47,561.5,47.2,562,47.7z"
      />
      <path
        class="st3"
        d="M440,78.3c0.1-0.2,0.2-0.5,0.2-0.7c-0.1-0.5-0.5-0.9-1-1c-0.6,0.5-1.3,1-1.9,1.4c0,0,0,0,0,0.1
		c0.1,0.6,0.8,1,1.5,0.9C439.2,78.8,439.6,78.6,440,78.3z"
      />
      <path
        class="st3"
        d="M368.5,93.1c-0.5-1.5-1-1.8-3.1-1.7c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.3,1.4,0.4,2.1,0
		C368.4,93.3,368.4,93.2,368.5,93.1z"
      />
      <path
        class="st3"
        d="M348.8,80.7c0.1-1.6-0.4-2.1-2.6-2.4C346,80.2,346.7,80.8,348.8,80.7z"
      />
      <path
        class="st3"
        d="M342.8,97.7c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C343.7,97.8,343.3,97.6,342.8,97.7z"
      />
      <path
        class="st3"
        d="M562.4,26.2c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C561.4,25.8,561.9,26,562.4,26.2z"
      />
      <path
        class="st3"
        d="M445.2,68.9c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st3"
        d="M430.9,83.6c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8c0,0-0.1,0-0.1-0.1c-0.7,0.5-1.4,1-2.1,1.5
		C430.6,83.4,430.8,83.5,430.9,83.6z"
      />
      <path
        class="st3"
        d="M315.1,119.6c0.5-0.1,1-0.3,1.5-0.4c0.1-0.4,0.1-0.9,0-1.1s-0.1-0.4-0.3-0.5c-0.3-0.2-0.8-0.4-1.1-0.3
		c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C315,119.4,315,119.5,315.1,119.6z"
      />
      <path
        class="st3"
        d="M325.3,103.3c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.2C325,103.3,325.2,103.3,325.3,103.3z"
      />
      <path
        class="st3"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st3"
        d="M417.5,71c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.5-0.9-0.8-1.6-0.6c-0.7,0.2-1.1,0.7-1,1.3c0.1,0.7,0.8,1,1.6,0.8
		c0.3-0.1,0.6-0.2,0.8-0.4C417.5,71.8,417.6,71.4,417.5,71z"
      />
      <path
        class="st3"
        d="M393,83.3c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0,0.2,0.2,0.4,0.3,0.5c0.8-0.4,1.6-0.7,2.5-0.8
		C393,83.5,393,83.4,393,83.3z"
      />
      <path
        class="st3"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C549.6,44.7,549.9,44.9,550.4,45z"
      />
      <path
        class="st3"
        d="M438.2,54.1c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3s-0.2,0.2-0.3,0.4
		c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C437.8,55.1,438.1,54.7,438.2,54.1z"
      />
      <path
        class="st3"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C509.7,38.7,509.1,39.4,509.3,39.9z"
      />
      <path
        class="st3"
        d="M513.4,43.8c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0c-0.4-0.3-0.8-0.4-1.3-0.2
		h-0.1c-0.5,0.2-0.8,0.5-0.8,1C512.4,43.3,512.7,43.6,513.4,43.8z"
      />
      <path
        class="st3"
        d="M416.2,44.4c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4
		C414.7,44.3,415.5,44.7,416.2,44.4z"
      />
      <path
        class="st3"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.7,568.9,12.5z"
      />
      <path
        class="st3"
        d="M322.2,108.1c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C320.9,107.8,321.6,108.2,322.2,108.1z"
      />
      <path
        class="st3"
        d="M416.7,55.2c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C417.1,54.6,416.8,54.9,416.7,55.2z"
      />
      <path
        class="st3"
        d="M332.7,43.5c0.7-0.1,1.2-0.7,1.1-1.3s-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C331.3,43.2,332,43.6,332.7,43.5z"
      />
      <path
        class="st3"
        d="M445.7,57c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C446.7,58.2,446.5,57.4,445.7,57z"
      />
      <path
        class="st3"
        d="M451.9,66.6c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1c0,0.4,0.1,0.8,0.7,0.9
		c0.6,0,1.2-0.1,1.7-0.1C452.4,67.5,452.4,66.9,451.9,66.6z"
      />
      <path
        class="st3"
        d="M406.7,30.6c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C405.4,30.3,406.1,30.7,406.7,30.6z"
      />
      <path
        class="st3"
        d="M551.2,66c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C550.3,65.8,550.7,66.1,551.2,66z"
      />
      <path
        class="st3"
        d="M384,54.7c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C382.7,54.5,383.4,54.8,384,54.7z"
      />
      <path
        class="st3"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st3"
        d="M452.3,68.1c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6s0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2
		c-0.5-0.3-1.1-0.6-1.7-0.9C453.1,67.6,452.7,67.9,452.3,68.1z"
      />
      <path
        class="st3"
        d="M330.3,59.8c-0.2,1.2-0.3,2.4-0.4,3.5C331.8,61.9,331.8,60.9,330.3,59.8z"
      />
      <path
        class="st3"
        d="M544.5,65.6c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C546.3,64.9,546.2,64.9,544.5,65.6z"
      />
      <path
        class="st3"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st3"
        d="M354.7,86.5c-0.3-1.3-0.4-1.4-2.2-1.8C352.5,86.4,353.1,86.9,354.7,86.5z"
      />
      <path
        class="st3"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st3"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2C440.7,36,441.5,35.9,442.2,36z"
      />
      <path
        class="st3"
        d="M435.1,34.1c0.1,0.5,0.7,0.9,1.2,0.8c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C435.3,32.9,435,33.6,435.1,34.1z"
      />
      <path
        class="st3"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.7,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st3"
        d="M517.6,40.1c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C519,40.2,518.4,39.9,517.6,40.1z"
      />
      <path
        class="st3"
        d="M397.9,97.3c0.5-0.1,0.9-0.5,1-0.9c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3
		s-0.7,0.3-0.9,0.5c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6C397.3,97.3,397.6,97.4,397.9,97.3z"
      />
      <path
        class="st3"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st3"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st3"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st3"
        d="M345.6,61.4c-0.1-0.9-0.7-1.4-1.9-1.6C343.3,61.5,343.8,62,345.6,61.4z"
      />
      <path
        class="st3"
        d="M493.8,43c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C492.6,42.7,493.2,43.1,493.8,43z"
      />
      <path
        class="st3"
        d="M485.3,46.1c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C484.6,46.7,485,46.6,485.3,46.1z"
      />
      <path
        class="st3"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st3"
        d="M493,54.7c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C492.6,55.2,492.9,54.9,493,54.7z"
      />
      <path
        class="st3"
        d="M393.5,77c-0.1-0.4-0.7-0.7-1.2-0.6s-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6C393.1,78.1,393.6,77.4,393.5,77z"
      />
      <path
        class="st3"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st3"
        d="M356.7,90.9c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C357,90.6,356.8,90.8,356.7,90.9z"
      />
      <path
        class="st3"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st3"
        d="M476.2,34.4c-0.2-0.9-0.8-1.4-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st3"
        d="M482.4,62.8c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C484.1,62.2,483.6,62.3,482.4,62.8z"
      />
      <path
        class="st3"
        d="M413.4,36.4c-1.3,0.9-1.3,0.9-0.8,2C414.2,37.3,414.2,37.3,413.4,36.4z"
      />
      <path
        class="st3"
        d="M454.9,66.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C455.8,66.1,455.3,66.2,454.9,66.3z"
      />
      <path
        class="st3"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C419.3,44,419.9,44,421.1,43.6z"
      />
      <path
        class="st3"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st3"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st3"
        d="M570.7,51.1c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C570.3,50.9,570.6,51,570.7,51.1z"
      />
      <path
        class="st3"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st3"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st3"
        d="M307.3,106.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1s0,0,0,0.1v1.2
		c0.2,0.1,0.5,0.3,0.7,0.5C307.1,106.6,307.2,106.3,307.3,106.1z"
      />
      <path
        class="st3"
        d="M434.8,21.6c0.5-1.1,0.5-1.1-0.8-1.8C433.7,21.2,433.7,21.2,434.8,21.6z"
      />
      <path
        class="st3"
        d="M308.7,55c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1S308.1,55.2,308.7,55z"
      />
      <path
        class="st3"
        d="M492.8,47.8c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.8z"
      />
      <path
        class="st3"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st3"
        d="M582,58.4c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C582.6,57.8,582.1,57.8,582,58.4z"
      />
      <path
        class="st3"
        d="M444.6,30.2c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9S444.3,30,444.6,30.2z"
      />
      <path
        class="st3"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st3"
        d="M581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.7,581.4,73.6
		C581.3,73.7,581.4,73.7,581.4,73.6C581.4,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6L581.4,73.6z"
      />
      <path
        class="st3"
        d="M362.4,88c-0.5-0.6-1-1-1.9-1C360.4,88.5,360.8,88.6,362.4,88z"
      />
      <path
        class="st3"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st3"
        d="M485.7,42.4c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C484.5,42.3,485.2,42.2,485.7,42.4z"
      />
      <path
        class="st3"
        d="M483.7,50.9c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C483.3,51.3,483.6,51.1,483.7,50.9z"
      />
      <path
        class="st3"
        d="M434.3,50.3C434.3,50.3,434.2,50.3,434.3,50.3c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3
		c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C434.2,50.8,434.4,50.4,434.3,50.3z"
      />
      <path
        class="st3"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.4,565.7,30.8,565.7,31z"
      />
      <path
        class="st3"
        d="M435.6,37.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0
		c-0.2,0.1-0.2,0.6-0.1,0.8C434.8,36.8,435.2,37,435.6,37.3z"
      />
      <path
        class="st3"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st3"
        d="M561.3,49.6c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C559.1,49.5,559.5,49.8,561.3,49.6z"
      />
      <path
        class="st3"
        d="M319.4,98.4c1-1,0.8-1.3-0.7-1.4C318.6,97.6,318.8,98.1,319.4,98.4z"
      />
      <path
        class="st3"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st3"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st3"
        d="M538.1,11.7c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C537.7,12.1,538.1,11.9,538.1,11.7z"
      />
      <path
        class="st3"
        d="M307.1,85.5c-0.7,1.2-0.6,1.5,0.7,1.6C308,86.4,308.1,85.7,307.1,85.5z"
      />
      <path
        class="st3"
        d="M330.7,87.7c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8
		C329.9,87.4,330.3,87.5,330.7,87.7z"
      />
      <path
        class="st3"
        d="M379.5,104.6c0.3,0.3,0.7,0.6,0.6,0.9c0,0.1,0,0.1,0,0.2c0.2-0.1,0.4-0.1,0.5-0.2
		C380.5,105.1,380.1,104.8,379.5,104.6z"
      />
      <path
        class="st3"
        d="M553.4,28.6c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C552.5,28.7,553,28.8,553.4,28.6z"
      />
      <path
        class="st3"
        d="M430.9,53.2c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C430.1,53.8,430.6,53.9,430.9,53.2z"
      />
      <path
        class="st3"
        d="M311.3,133.8c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1,0.3-0.3,0.7-0.4,1c0,0,0.1,0,0.1,0.1
		C310.8,134.3,311,134.1,311.3,133.8z"
      />
      <path
        class="st3"
        d="M524.5,40.8c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C524.4,40.7,524.4,40.7,524.5,40.8z"
      />
      <path
        class="st3"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st3"
        d="M471.8,50c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C471.6,49.9,471.7,50,471.8,50z"
      />
      <path
        class="st3"
        d="M441.1,71.6c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1c0.3,0.1,0.7-0.1,1.1-0.1
		C441.1,71.7,441.1,71.7,441.1,71.6z"
      />
      <path
        class="st3"
        d="M423.8,40.9c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C422.7,40.7,423,41.1,423.8,40.9z"
      />
      <path
        class="st3"
        d="M564.6,49.6c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C564.2,48.8,564.4,49.2,564.6,49.6z"
      />
      <path
        class="st3"
        d="M507.9,49.2c0.2,0.5,0.3,0.8,0.5,0.9c0.2,0.1,0.5,0.1,1.2,0.1l0,0C509,49.7,508.9,49,507.9,49.2z"
      />
      <path
        class="st3"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st3"
        d="M481.9,45c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C482.2,45.5,482,45.3,481.9,45z"
      />
      <path
        class="st3"
        d="M481.3,46.7L481.3,46.7C481.2,46.7,481.2,46.7,481.3,46.7C481.2,46.8,481.3,46.8,481.3,46.7L481.3,46.7z"
      />
      <path
        class="st3"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st3"
        d="M400.5,70.6c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C400,69.7,400,69.7,400.5,70.6z"
      />
      <path
        class="st3"
        d="M429.5,43.6c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C429.7,43.2,429.4,43.5,429.5,43.6z"
      />
      <path
        class="st3"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st3"
        d="M429.7,74.5c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C430,73.9,429.7,74.4,429.7,74.5z"
      />
      <path
        class="st3"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st3"
        d="M339.1,101.7c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C339,101.9,339,101.8,339.1,101.7z"
      />
      <path
        class="st3"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st3"
        d="M489.6,55.1c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C489.7,54.7,489.5,55,489.6,55.1z"
      />
      <path
        class="st3"
        d="M579.8,65.8c0.4-1.2,0.4-1.2-0.9-1.7C579.2,64.7,579.4,65.1,579.8,65.8z"
      />
      <path
        class="st3"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st3"
        d="M579.2,67.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C579.8,66.8,579.5,67.1,579.2,67.3z"
      />
      <path
        class="st3"
        d="M490.8,53c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C490.5,53.5,490.6,53.2,490.8,53z"
      />
      <path
        class="st3"
        d="M330.6,109.7c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C331,109.3,330.8,109.5,330.6,109.7z"
      />
      <path
        class="st3"
        d="M440.7,57c-0.1,0.1-0.1,0.3-0.1,0.4c0.4,0.4,0.8,0.2,1.2-0.1c0,0,0-0.1,0.1-0.3C441,56.8,440.9,56.7,440.7,57z
		"
      />
      <path
        class="st3"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st3"
        d="M444.4,71.1c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1C444.5,70.7,444.5,70.9,444.4,71.1z
		"
      />
      <path
        class="st3"
        d="M437.1,43.7c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C436.5,43.2,436.4,43.6,437.1,43.7z"
      />
      <path
        class="st3"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st3"
        d="M476.4,38.2c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C475.8,38.7,476.1,38.5,476.4,38.2z"
      />
      <path
        class="st3"
        d="M391.9,79.2c0.7,0.3,1.1,0.1,1.4-0.6C392.5,78.4,392.1,78.6,391.9,79.2z"
      />
      <path
        class="st3"
        d="M441.3,59.8c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.7-0.5
		C441.7,60,441.4,59.8,441.3,59.8z"
      />
      <path
        class="st3"
        d="M440.8,48.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		c0.1,0,0.3,0,0.4-0.1C440.8,49,440.9,48.6,440.8,48.6L440.8,48.6z"
      />
      <path
        class="st3"
        d="M319.1,89.3c-0.1-0.6-0.2-1-0.3-1.4C318.2,88.6,318.3,89,319.1,89.3z"
      />
      <path
        class="st3"
        d="M313.9,102.2c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C312.8,101.3,312.9,101.7,313.9,102.2z"
      />
      <path
        class="st3"
        d="M578.6,66.3c-0.4-0.4-0.8-0.6-1.6,0.1C577.7,66.6,578.1,67.1,578.6,66.3z"
      />
      <path
        class="st3"
        d="M498.8,55.4c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C499,54.9,498.8,55.2,498.8,55.4z"
      />
      <path
        class="st3"
        d="M393.2,99.7c0.3-0.3,0.5-0.6,0.7-0.9C393,99.1,393,99.1,393.2,99.7z"
      />
      <path
        class="st3"
        d="M470.3,43.1c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C470.1,42.5,470.2,42.8,470.3,43.1z"
      />
      <path
        class="st3"
        d="M477.1,51.2c-0.7,0.5-1,1-0.6,1.6C476.9,52.3,477.3,51.9,477.1,51.2z"
      />
      <path
        class="st3"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st3"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st3"
        d="M550.1,57.8c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C548.6,57.6,549.2,57.7,550.1,57.8z"
      />
      <path
        class="st3"
        d="M558.9,43.8c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C558.4,43.4,558.7,43.6,558.9,43.8z"
      />
      <path
        class="st3"
        d="M578.6,71.1c-0.5,0.5-0.5,0.9,0,1.3C579.2,71.9,579,71.5,578.6,71.1z"
      />
      <path
        class="st3"
        d="M437.4,58.5c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C436.9,58.2,437.1,58.3,437.4,58.5z"
      />
      <path
        class="st3"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st3"
        d="M480.5,48.2c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C480.5,48.1,480.5,48.1,480.5,48.2z"
      />
      <path
        class="st3"
        d="M544.1,64c-0.3-0.1-0.5-0.2-0.8-0.3h0.1c0,0,0,0-0.1,0c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9
		c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3v0.1c0,0,0,0,0.1,0C543.1,64.9,543.1,64.9,544.1,64z"
      />
      <path
        class="st3"
        d="M339.4,104.1c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C339.1,104.5,339.4,104.2,339.4,104.1z"
      />
      <path
        class="st3"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st3"
        d="M355.2,82.4c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1c-0.1-0.1-0.2-0.1-0.3-0.2
		C355.7,81.9,355.4,82.1,355.2,82.4z"
      />
      <path
        class="st3"
        d="M333.5,105.5l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4s-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C333.1,106,333.3,105.7,333.5,105.5z"
      />
      <path
        class="st3"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st3"
        d="M410.7,64.3c0.3,0.4,0.4,0.7,0.7,1.2C411.6,64.7,411.6,64.3,410.7,64.3z"
      />
      <path
        class="st3"
        d="M547.3,63.2c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C547.6,62.2,547.4,62.5,547.3,63.2z"
      />
      <path
        class="st3"
        d="M434.4,46.8L434.4,46.8c-0.1,0-0.1,0.1-0.1,0.1C434.3,46.9,434.4,46.9,434.4,46.8
		C434.4,46.9,434.4,46.8,434.4,46.8z"
      />
      <path
        class="st3"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st3"
        d="M381.7,100.4c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.2,0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3
		c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4c-0.2,0.1-0.3,0.1-0.4,0.2C381.9,100.1,381.8,100.2,381.7,100.4z"
      />
      <path
        class="st3"
        d="M437.3,56.6c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C437,57,437.2,56.8,437.3,56.6z"
      />
      <path
        class="st3"
        d="M417.8,80c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C417.2,80.3,417.5,80.2,417.8,80z"
      />
      <path
        class="st3"
        d="M335,108.9c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C334.7,108.3,334.6,108.6,335,108.9z"
      />
      <path
        class="st3"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st3"
        d="M475,47.2c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C475.3,47.3,475.2,47.2,475,47.2z"
      />
      <path
        class="st3"
        d="M481.7,61.1C481.7,61.1,481.7,61,481.7,61.1h-0.1C481.7,61.1,481.7,61.1,481.7,61.1L481.7,61.1z"
      />
      <path
        class="st3"
        d="M482.6,61.7c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C481.8,61.5,481.9,61.8,482.6,61.7z"
      />
      <path
        class="st3"
        d="M484.1,60c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C484.4,60.1,484.2,60,484.1,60z"
      />
      <path
        class="st3"
        d="M361.8,84.6c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0c0.2,0,0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2
		c-0.4,0-0.8,0-1.3,0.1C362,84.6,361.9,84.6,361.8,84.6z"
      />
      <path
        class="st3"
        d="M589.5,56.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C588.7,56.9,589.1,56.8,589.5,56.6z"
      />
      <path
        class="st3"
        d="M371.1,109.3c-0.3-0.3-0.6-0.6-0.9-1c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0.3,0.7,0.6,1,1
		C371,109.4,371,109.3,371.1,109.3z"
      />
      <path
        class="st3"
        d="M539.7,60.4c-0.1,0.6,0.3,0.8,1,1.1C540.6,60.8,540.4,60.5,539.7,60.4z"
      />
      <path
        class="st3"
        d="M432.6,21.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C432.4,21.5,432.5,21.5,432.6,21.4z"
      />
      <path
        class="st3"
        d="M559.4,35.6c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C559.1,35.8,559.3,35.7,559.4,35.6z"
      />
      <path
        class="st3"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st3"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st3"
        d="M588,64.5c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3C588.6,64.7,588.3,64.6,588,64.5
		z"
      />
      <path
        class="st3"
        d="M436.3,47.8c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C436.4,47.4,436.3,47.6,436.3,47.8z"
      />
      <path
        class="st3"
        d="M448.7,61.8c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C447.7,62,448.1,62,448.7,61.8z"
      />
      <path
        class="st3"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st3"
        d="M420.5,39c0.4,0.2,0.7,0.4,1.2,0.7C421.6,38.8,421.2,38.7,420.5,39z"
      />
      <path
        class="st3"
        d="M484.4,20.9c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C483.8,21.3,484.1,21.3,484.4,20.9z"
      />
      <path
        class="st3"
        d="M523.7,50.5c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st3"
        d="M483.7,55.6c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C483.6,54.8,483.5,55.2,483.7,55.6z"
      />
      <path
        class="st3"
        d="M484.1,54.6L484.1,54.6c0.1-0.1,0.1-0.2,0.2-0.2C484.2,54.4,484.2,54.5,484.1,54.6L484.1,54.6z"
      />
      <path
        class="st3"
        d="M441.8,63.9c-0.2,0.2-0.4,0.4-0.5,0.5c0,0.1,0.2,0.2,0.3,0.3h0.1c0.2,0,0.4-0.2,0.5-0.4l0,0
		C442.1,64.2,441.9,64.1,441.8,63.9z"
      />
      <path
        class="st3"
        d="M533.6,63.3c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C534,63.5,533.7,63.3,533.6,63.3z"
      />
      <path
        class="st3"
        d="M465.2,75.3c-0.1,0.2-0.2,0.4-0.4,0.6c0.1,0.1,0.3,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.5
		C465.4,75.5,465.3,75.4,465.2,75.3z"
      />
      <path
        class="st3"
        d="M408.2,88.7L408.2,88.7c-0.2-0.2-0.3-0.4-0.5-0.5C407.5,88.5,407.7,88.5,408.2,88.7z"
      />
      <path
        class="st3"
        d="M479.8,47c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2C479.6,47,479.7,47,479.8,47z"
      />
      <path
        class="st3"
        d="M553,30.7c-0.2-0.3-0.5-0.5-0.8-1C552.1,30.4,552.3,30.7,553,30.7z"
      />
      <path
        class="st3"
        d="M553.2,41.8c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C553.6,41.5,553.4,41.6,553.2,41.8z"
      />
      <path
        class="st3"
        d="M442.1,66c0.3-0.1,0.6-0.2,0.8-0.3c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2C442,65.7,442.1,65.9,442.1,66z"
      />
      <path
        class="st3"
        d="M486,58.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4C485.6,58,485.9,58.2,486,58.2z"
      />
      <path
        class="st3"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st3"
        d="M594.9,58.4c0.4,0.2,0.6,0.3,1,0.4C595.6,58.3,595.6,58.3,594.9,58.4z"
      />
      <path
        class="st3"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st3"
        d="M576.8,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.8,0.6z"
      />
      <path
        class="st3"
        d="M387,100.3c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2C386.8,99.9,386.9,100.1,387,100.3z"
      />
      <path
        class="st3"
        d="M538.5,70.4c-0.7-0.3-1.1-0.4-1.5-0.6C537.1,70.3,537.5,70.6,538.5,70.4z"
      />
      <path
        class="st3"
        d="M537.1,69.8C537,69.8,537,69.7,537.1,69.8C537,69.7,537,69.7,537.1,69.8C537,69.8,537,69.8,537.1,69.8
		C537,69.8,537,69.8,537.1,69.8z"
      />
      <path
        class="st3"
        d="M451,35.9c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8C450.7,35.9,450.8,35.9,451,35.9z"
      />
      <path
        class="st3"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st3"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st3"
        d="M543.2,64.9c-0.5,0.3-0.8,0.5-1.3,0.8C542.8,65.6,542.8,65.6,543.2,64.9z"
      />
      <path
        class="st3"
        d="M339.5,93c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C339.5,93.6,339.5,93.3,339.5,93z"
      />
      <path
        class="st3"
        d="M388.9,99c0.1-0.3,0.3-0.5,0.4-0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.4,0.5-0.6,0.7
		C388.7,98.9,388.8,99,388.9,99z"
      />
      <path
        class="st3"
        d="M333.8,95.5c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C333.6,95.5,333.7,95.5,333.8,95.5z
		"
      />
      <path
        class="st3"
        d="M495.3,46.1c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C495.5,45.8,495.4,45.9,495.3,46.1z"
      />
      <path
        class="st3"
        d="M433.5,22.7c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C433,22.5,433.3,22.6,433.5,22.7z"
      />
      <path
        class="st3"
        d="M539.7,77.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C539.2,77.6,539.5,77.5,539.7,77.3z"
      />
      <path
        class="st3"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st3"
        d="M538.3,64.7c0.1-0.1,0.1-0.1,0.2-0.2l0,0c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1,0.1-0.2,0.2-0.3,0.2
		c0.1,0,0.1,0.1,0.2,0.1C538,64.4,538.2,64.5,538.3,64.7z"
      />
      <path
        class="st3"
        d="M539.4,65.9c-0.3,0.1-0.7,0.1-1,0.2v0.1C538.7,66.1,539.1,66.1,539.4,65.9C539.4,66,539.4,66,539.4,65.9z"
      />
      <path
        class="st3"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st3"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st3"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41.1,595.8,40.8,596,40.6z"
      />
      <path
        class="st3"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st3"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.9,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st3"
        d="M453.5,57.8c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C453.7,57.6,453.6,57.7,453.5,57.8z"
      />
      <path
        class="st3"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st3"
        d="M433.9,30.1c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C433.9,29.9,433.8,30,433.9,30.1z"
      />
      <path
        class="st3"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st3"
        d="M550,38.7c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1c0,0,0,0,0,0.1
		c-0.1,0.1-0.1,0.2-0.1,0.3C549.7,38.6,549.9,38.7,550,38.7z"
      />
      <path
        class="st3"
        d="M578.7,61.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C578.5,61.7,578.6,61.6,578.7,61.5z"
      />
      <path
        class="st3"
        d="M440.3,29.6c-0.1-0.3-0.1-0.7-0.7-0.7C439.7,29.2,439.6,29.6,440.3,29.6z"
      />
      <path
        class="st3"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st3"
        d="M435.1,48.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1V48C435,48.1,435,48.1,435.1,48.1z"
      />
      <path
        class="st3"
        d="M435.8,48.6c-0.3-0.2-0.5-0.3-0.7-0.5C435.2,48.4,435.1,48.8,435.8,48.6z"
      />
      <path
        class="st3"
        d="M389.6,74.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2
		C389.4,75,389.6,74.8,389.6,74.8z"
      />
      <path
        class="st3"
        d="M383.7,42c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3C383.2,42.3,383.4,42.1,383.7,42
		z"
      />
      <path
        class="st3"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st3"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st3"
        d="M452.3,63c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4C452.2,63.2,452.4,63.1,452.3,63z"
      />
      <path
        class="st3"
        d="M438,48.3c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C438.2,48.5,438.1,48.3,438,48.3z"
      />
      <path
        class="st3"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st3"
        d="M381.9,106.8c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2-0.1-0.2-0.1
		C382,106.6,381.9,106.7,381.9,106.8z"
      />
      <path
        class="st3"
        d="M531.1,47c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C531,46.8,531,46.9,531.1,47z"
      />
      <path
        class="st3"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st3"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st3"
        d="M530.7,46.6C530.7,46.6,530.8,46.6,530.7,46.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0-0.1
		C530.8,46.6,530.8,46.6,530.7,46.6z"
      />
      <path
        class="st3"
        d="M530,46.5c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C530.1,46.3,530.1,46.4,530,46.5z"
      />
      <path
        class="st3"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st3"
        d="M537.2,9.4c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C537.3,9.3,537.2,9.4,537.2,9.4z"
      />
      <path
        class="st3"
        d="M537.3,9.7v0.1l0,0C537.3,9.8,537.3,9.8,537.3,9.7C537.4,9.8,537.4,9.8,537.3,9.7z"
      />
      <path
        class="st3"
        d="M432.6,36.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C432.4,36.3,432.5,36.4,432.6,36.5z"
      />
      <path
        class="st3"
        d="M541.3,42.8c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C541.2,42.7,541.3,42.7,541.3,42.8z"
      />
      <path
        class="st3"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st3"
        d="M574.1,50.8c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0s0,0.2-0.1,0.2C573.9,50.8,574,50.8,574.1,50.8z"
      />
      <path
        class="st3"
        d="M331.5,105.5c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C331.7,105.6,331.6,105.5,331.5,105.5z"
      />
      <path
        class="st3"
        d="M430.6,69.8c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C430.8,69.8,430.7,69.8,430.6,69.8z"
      />
      <path
        class="st3"
        d="M484.7,53.5c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.6
		C484.8,53.6,484.8,53.6,484.7,53.5z"
      />
      <path
        class="st3"
        d="M491.9,57.1c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C491.8,56.9,491.8,57,491.9,57.1z"
      />
      <path
        class="st3"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st3"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st3"
        d="M492.7,57.4c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C492.5,57.6,492.6,57.5,492.7,57.4z"
      />
      <path
        class="st3"
        d="M492.1,57.3C492,57.3,492,57.2,492.1,57.3c-0.1-0.1-0.1-0.1-0.1-0.2v0.1C492,57.3,492,57.3,492.1,57.3z"
      />
      <path
        class="st3"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1l0,0v-0.1c0,0,0,0-0.1,0.1L381.3,75.7z"
      />
      <path
        class="st3"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st3"
        d="M495.2,50.9L495.2,50.9C495.1,50.9,495.1,50.9,495.2,50.9C495.2,50.9,495.2,51,495.2,50.9L495.2,50.9z"
      />
      <path
        class="st3"
        d="M495.8,50.5c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C495.8,50.8,495.8,50.6,495.8,50.5z"
      />
      <path
        class="st3"
        d="M337.7,91.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C337.8,91.3,337.8,91.2,337.7,91.2z"
      />
      <path
        class="st3"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st3"
        d="M505.8,47c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C505.8,46.8,505.7,47,505.8,47z"
      />
      <path
        class="st3"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st3"
        d="M427,41.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st3"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st3"
        d="M539.7,53.8c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C539.5,53.7,539.6,53.8,539.7,53.8z"
      />
      <path
        class="st3"
        d="M544.5,68.1c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C544.3,68.3,544.4,68.2,544.5,68.1z"
      />
      <path
        class="st3"
        d="M421.1,45.4c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C421.2,45.5,421.1,45.4,421.1,45.4z"
      />
      <path
        class="st3"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st3"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.9,581.3,43.7z"
      />
      <path
        class="st3"
        d="M540.5,67.4c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2S540.7,67.2,540.5,67.4
		C540.6,67.2,540.6,67.4,540.5,67.4z"
      />
      <path
        class="st3"
        d="M491.7,42.7c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C491.8,43.1,491.7,42.9,491.7,42.7z"
      />
      <path
        class="st3"
        d="M447.8,70.3c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C447.6,70.2,447.7,70.4,447.8,70.3z"
      />
      <path
        class="st3"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st3"
        d="M547.4,64.9c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C547.2,64.8,547.3,64.9,547.4,64.9z"
      />
      <path
        class="st3"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st3"
        d="M329.3,111.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C329.5,111.2,329.4,111.2,329.3,111.2z"
      />
      <path
        class="st3"
        d="M494.2,33.4c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C494.4,33.2,494.3,33.3,494.2,33.4z"
      />
      <path
        class="st3"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st3"
        d="M456.7,69.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0
		c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C456.4,69.9,456.5,69.9,456.7,69.9z"
      />
      <path
        class="st3"
        d="M474.7,51.1c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C474.7,50.8,474.7,51,474.7,51.1z"
      />
      <path
        class="st3"
        d="M447,56.4L447,56.4C446.9,56.3,446.9,56.3,447,56.4C446.9,56.4,446.9,56.5,447,56.4
		C447,56.4,447,56.4,447,56.4z"
      />
      <path
        class="st3"
        d="M448,55.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C448.1,55.3,448.1,55.2,448,55.2z"
      />
      <path
        class="st3"
        d="M547.4,32c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C547.2,31.9,547.3,32,547.4,32z"
      />
      <path
        class="st3"
        d="M471.8,52.5c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C471.7,52.4,471.7,52.5,471.8,52.5z"
      />
      <path
        class="st3"
        d="M390.4,70.4c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.1s0.1-0.1,0.2-0.1L390.4,70.4z"
      />
      <path
        class="st3"
        d="M412.1,66c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C412.4,66,412.3,66,412.1,66z"
      />
      <path
        class="st3"
        d="M489.6,42.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C489.6,42.1,489.5,42.2,489.6,42.2z"
      />
      <path
        class="st3"
        d="M382.1,73.7l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C382.1,73.9,382.1,73.8,382.1,73.7z"
      />
      <path
        class="st3"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st3"
        d="M381.3,99c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2C381.2,98.9,381.3,99,381.3,99z"
      />
      <path
        class="st3"
        d="M502.8,37.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C502.8,37.6,502.8,37.5,502.8,37.5z"
      />
      <path
        class="st3"
        d="M477.5,55.9h0.1C477.6,55.9,477.6,55.8,477.5,55.9C477.5,55.8,477.5,55.8,477.5,55.9
		C477.4,55.9,477.5,55.9,477.5,55.9z"
      />
      <path
        class="st3"
        d="M418.2,53.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
		C418.1,53.5,418.2,53.4,418.2,53.4z"
      />
      <path
        class="st3"
        d="M438.7,48c0,0,0.1,0,0.2,0c0,0,0-0.1-0.1-0.1C438.8,47.9,438.7,47.9,438.7,48C438.7,47.9,438.7,48,438.7,48z"
      />
      <path
        class="st3"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C477.5,57.9,477.5,58,477.4,58z"
      />
      <path
        class="st3"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.4,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st3"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st3"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st3"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st3"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,74,581.2,74.1z"
      />
      <path
        class="st3"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35c-0.1,0.2-0.1,0.3-0.1,0.3S597,35.2,597.1,35
		C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st3"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st3"
        d="M336.8,92.3l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C336.9,92.4,336.9,92.3,336.8,92.3z"
      />
      <path
        class="st3"
        d="M425.1,73.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C425.1,73.9,425.1,73.8,425.1,73.7z"
      />
      <path
        class="st3"
        d="M579.3,73.1L579.3,73.1c0.2,0,0.2,0,0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1C579.4,72.9,579.3,73,579.3,73.1z"
      />
      <path
        class="st3"
        d="M337.9,93.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C337.9,93.6,337.9,93.5,337.9,93.5z"
      />
      <path
        class="st3"
        d="M494.3,60.1l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C494.2,59.9,494.2,60,494.3,60.1z"
      />
      <path
        class="st3"
        d="M428.6,48.1c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1C428.6,48,428.6,48,428.6,48.1z
		"
      />
      <path
        class="st3"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st3"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st3"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st3"
        d="M316.1,100.5H316v0.1c0.1,0,0.1,0,0.2,0C316.2,100.6,316.2,100.6,316.1,100.5z"
      />
      <path
        class="st3"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st3"
        d="M526.3,23.3l-0.1-0.1c0,0,0,0,0-0.1v0.1C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st3"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st3"
        d="M554.7,15.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.6,554.7,15.6z"
      />
      <path
        class="st3"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st3"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st3"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st3"
        d="M333,58.6l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C333.2,58.6,333.1,58.6,333,58.6z"
      />
      <path
        class="st3"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st3"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2
		C583.9,65.1,583.8,65.2,583.8,65.3z"
      />
      <path
        class="st3"
        d="M450.6,32.9c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1-0.1C450.7,33,450.7,33,450.6,32.9z"
      />
      <path
        class="st3"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71L555.1,71z"
      />
      <path
        class="st3"
        d="M333.9,58.1c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C333.8,57.9,333.8,58,333.9,58.1z"
      />
      <path
        class="st3"
        d="M333.6,57.6C333.6,57.7,333.7,57.7,333.6,57.6c0.1,0.1,0.1,0.1,0.1,0.1C333.7,57.8,333.7,57.7,333.6,57.6
		C333.7,57.7,333.7,57.7,333.6,57.6z"
      />
      <path
        class="st3"
        d="M450.4,31.8l-0.1-0.1l-0.1,0.1l0.1,0.1C450.4,31.9,450.4,31.8,450.4,31.8z"
      />
      <path
        class="st3"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st3"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st3"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.9,479.1,22.8z"
      />
      <path
        class="st3"
        d="M375.2,107.4c0,0,0-0.1-0.1-0.1v0.1C375.1,107.4,375.1,107.5,375.2,107.4C375.2,107.4,375.2,107.4,375.2,107.4
		z"
      />
      <path
        class="st3"
        d="M576,62.8C576,62.8,576,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8L576,62.8z
		"
      />
      <path
        class="st3"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st3"
        d="M534.7,61.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1S534.6,61.4,534.7,61.3z"
      />
      <path
        class="st3"
        d="M550.5,68c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3C550.4,67.9,550.4,68,550.5,68z"
      />
      <path
        class="st3"
        d="M463.7,77.4L463.7,77.4L463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4z"
      />
      <path
        class="st3"
        d="M549.3,58.9c0,0.1,0,0.1,0.1,0.2l0.1-0.1C549.4,58.9,549.4,58.9,549.3,58.9C549.4,58.9,549.3,58.9,549.3,58.9z
		"
      />
      <path
        class="st3"
        d="M574.4,53.5c0,0.1,0.1,0.1,0.2,0.2v-0.1C574.6,53.4,574.5,53.4,574.4,53.5C574.5,53.4,574.4,53.4,574.4,53.5z"
      />
      <path
        class="st3"
        d="M546,60.3L546,60.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0.1C545.9,60.4,546,60.3,546,60.3z"
      />
      <path
        class="st3"
        d="M592.2,57.7c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C592.2,57.4,592.1,57.5,592.2,57.7
		C592.1,57.6,592.2,57.6,592.2,57.7z"
      />
      <path
        class="st3"
        d="M413.3,30.1l-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C413.1,30.1,413.2,30.1,413.3,30.1z"
      />
      <path
        class="st3"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st3"
        d="M399.6,92.2c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1l-0.1-0.1C399.8,92.2,399.8,92.1,399.6,92.2
		C399.7,92.1,399.6,92.2,399.6,92.2z"
      />
      <path
        class="st3"
        d="M332.5,107.6C332.5,107.5,332.6,107.5,332.5,107.6C332.6,107.5,332.5,107.5,332.5,107.6c0-0.2-0.1-0.2-0.1-0.2
		l-0.1,0.1C332.4,107.5,332.4,107.5,332.5,107.6L332.5,107.6z"
      />
      <path
        class="st3"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st3"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st3"
        d="M320.5,110.4c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C320.4,110.4,320.4,110.4,320.5,110.4z"
      />
      <path
        class="st3"
        d="M324.4,109.6c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C324.5,109.4,324.4,109.4,324.4,109.6L324.4,109.6z"
      />
      <path
        class="st3"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st3"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st3"
        d="M560.9,73.2L560.9,73.2C560.8,73.4,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st3"
        d="M586.7,64.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3l0,0C586.9,64.6,586.8,64.7,586.7,64.7z"
      />
      <path
        class="st3"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <path
        class="st3"
        d="M587,64.6L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6z"
      />
      <polygon class="st3" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st3"
        d="M576.1,64.3c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C576.2,64.2,576.2,64.2,576.1,64.3z"
      />
      <path
        class="st3"
        d="M314.4,119.8L314.4,119.8c0.1,0,0.1,0,0.2-0.1l0,0l-0.1-0.1C314.5,119.7,314.5,119.7,314.4,119.8z"
      />
      <path
        class="st3"
        d="M579.6,61.7C579.6,61.7,579.6,61.8,579.6,61.7l-0.1,0.2L579.6,61.7L579.6,61.7L579.6,61.7z"
      />
      <polygon class="st3" points="576.8,62 576.8,61.9 576.7,62 	" />
      <path
        class="st3"
        d="M389.8,99.6C389.7,99.5,389.7,99.5,389.8,99.6c-0.1-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C389.7,99.5,389.7,99.5,389.8,99.6z"
      />
      <path
        class="st3"
        d="M389.6,99.5c0-0.1,0-0.1-0.1-0.2l-0.1,0.1l0,0l0,0C389.5,99.5,389.6,99.5,389.6,99.5z"
      />
      <polygon class="st3" points="372.4,103.1 372.4,103 372.3,103.1 	" />
      <polygon class="st3" points="338.7,108.3 338.7,108.2 338.6,108.2 	" />
      <path
        class="st3"
        d="M539.2,64c0,0.1,0,0.2-0.1,0.2C539.1,64.1,539.2,64.1,539.2,64c0.1-0.1,0.1-0.1,0.1-0.2
		C539.3,63.8,539.2,63.9,539.2,64z"
      />
      <polygon class="st3" points="335,105.3 335.1,105.3 335,105.2 	" />
      <path
        class="st3"
        d="M392.3,90.8c0.1,0,0.2,0,0.3,0C392.5,90.8,392.5,90.8,392.3,90.8C392.3,90.7,392.3,90.7,392.3,90.8L392.3,90.8
		z"
      />
      <path
        class="st3"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st3"
        d="M548.8,56.8c0.1,0,0.1,0,0.2,0C548.9,56.8,548.9,56.7,548.8,56.8C548.9,56.7,548.9,56.8,548.8,56.8z"
      />
      <path
        class="st3"
        d="M392,90.6C392,90.7,392,90.7,392,90.6c0.1,0,0.2,0.1,0.3,0.1C392.2,90.7,392.2,90.6,392,90.6
		C392.1,90.6,392,90.6,392,90.6z"
      />
      <path
        class="st3"
        d="M541.7,56.5L541.7,56.5C541.8,56.6,541.8,56.5,541.7,56.5C541.8,56.5,541.8,56.5,541.7,56.5
		C541.8,56.5,541.8,56.5,541.7,56.5z"
      />
      <path
        class="st3"
        d="M541.5,56.4c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C541.6,56.3,541.6,56.4,541.5,56.4z"
      />
      <polygon class="st3" points="462.1,73.6 462,73.6 462.1,73.7 	" />
      <polygon class="st3" points="548.7,54.6 548.8,54.6 548.8,54.5 	" />
      <path
        class="st3"
        d="M541.8,56c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C541.8,56.2,541.8,56.1,541.8,56z"
      />
      <polygon class="st3" points="552.4,48.2 552.3,48.1 552.2,48.1 	" />
      <path
        class="st3"
        d="M596.5,36.4c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.5,596.4,36.4,596.5,36.4z"
      />
      <path
        class="st3"
        d="M493.1,57c0-0.1,0.1-0.2,0.1-0.3C493.1,56.9,493.1,56.9,493.1,57c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0
		C492.8,57.3,493,57.2,493.1,57z"
      />
      <path
        class="st3"
        d="M484.6,58.7c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1L484.6,58.7z"
      />
      <polygon class="st3" points="481.5,59.1 481.4,59.1 481.5,59.2 	" />
      <polygon class="st3" points="409.6,74 409.5,74 409.5,74.1 	" />
      <path
        class="st3"
        d="M488.8,55.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C488.7,55.7,488.8,55.6,488.8,55.6z"
      />
      <path
        class="st3"
        d="M444.4,65.1L444.4,65.1L444.4,65.1L444.4,65.1C444.4,65.1,444.4,65,444.4,65.1c0-0.1-0.1-0.1-0.1-0.1
		S444.4,65,444.4,65.1z"
      />
      <polygon class="st3" points="560.3,39.2 560.3,39.3 560.4,39.2 	" />
      <path
        class="st3"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st3"
        d="M380.5,75.2l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1C380.5,75.2,380.5,75.2,380.5,75.2z"
      />
      <path
        class="st3"
        d="M380.7,75.1L380.7,75.1c0.1,0,0.1-0.1,0.1-0.1C380.7,75,380.7,75,380.7,75.1z"
      />
      <path
        class="st3"
        d="M514.1,45.8L514.1,45.8c0.1-0.1,0-0.1,0-0.2V45.8C514,45.8,514.1,45.8,514.1,45.8z"
      />
      <polygon class="st3" points="549,36 548.9,36 548.9,36.1 	" />
      <path
        class="st3"
        d="M400.5,67.8C400.5,67.8,400.4,67.9,400.5,67.8l0.1,0.2c0-0.1,0-0.1,0-0.2H400.5z"
      />
      <polygon class="st3" points="333.4,82.3 333.4,82.4 333.6,82.4 	" />
      <polygon class="st3" points="548.5,35.5 548.4,35.4 548.4,35.6 	" />
      <polygon class="st3" points="433.3,57 433.4,57 433.3,56.9 	" />
      <path
        class="st3"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st3"
        d="M575.6,17.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.7z"
      />
      <polygon
        class="st3"
        points="533.2,26.6 533.2,26.5 533.2,26.5 533.1,26.5 533.1,26.5 	"
      />
      <polygon class="st3" points="438.4,47 438.3,47.1 438.4,47.1 	" />
      <path
        class="st3"
        d="M501.4,32.7c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C501.4,32.8,501.4,32.7,501.4,32.7z"
      />
      <path
        class="st3"
        d="M501.2,33L501.2,33c-0.1,0.1-0.1,0.2-0.1,0.3C501.2,33.2,501.2,33.1,501.2,33L501.2,33z"
      />
      <polygon class="st3" points="445.9,44.9 446,44.9 446,44.8 	" />
      <polygon class="st3" points="548.7,22.2 548.6,22.3 548.7,22.3 	" />
      <polygon class="st3" points="532.7,25.7 532.6,25.8 532.7,25.8 	" />
      <path
        class="st3"
        d="M434.3,47.1L434.3,47.1C434.3,46.9,434.3,46.9,434.3,47.1C434.2,47,434.3,47,434.3,47.1z"
      />
      <path
        class="st3"
        d="M421.4,49.6l0.1-0.1l-0.1-0.1l-0.1,0.1C421.3,49.6,421.4,49.6,421.4,49.6z"
      />
      <polygon
        class="st3"
        points="308.7,74 308.8,74 308.8,74 308.8,73.9 308.8,73.9 	"
      />
      <path
        class="st3"
        d="M575.8,13c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,13z"
      />
      <polygon class="st3" points="418.5,45.1 418.5,45.2 418.6,45.1 	" />
      <path
        class="st3"
        d="M376.5,53.5h-0.1v0.1l0.1,0.1C376.5,53.7,376.5,53.6,376.5,53.5z"
      />
      <path
        class="st3"
        d="M412.6,43c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C412.7,42.8,412.7,42.9,412.6,43z"
      />
      <path class="st3" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st3" points="427.4,38.2 427.3,38.3 427.4,38.3 	" />
      <polygon class="st3" points="445.5,33.7 445.4,33.6 445.3,33.7 	" />
      <path
        class="st3"
        d="M463.2,29.2l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.2z"
      />
      <path
        class="st3"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st3"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <polygon class="st3" points="440.8,29.9 440.8,30 440.9,30 	" />
      <path
        class="st3"
        d="M524.3,179.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C524.5,179.7,524.4,179.7,524.3,179.8z"
      />
      <path
        class="st3"
        d="M546.1,163.8c0,0-0.1,0-0.1-0.1l0,0l0,0C546,163.8,546,163.8,546.1,163.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "WrestlingCover_c2",
  props: ["fill"],
};
</script>
